import { $modelRelationships, assert, GadgetConnection, AuthenticationMode, InternalModelManager, GadgetClientError, enqueueActionRunner, BackgroundActionHandle } from "@gadgetinc/api-client-core";
import { pipe, map } from "wonka";
;
import { buildGlobalAction, buildInlineComputedView } from "./builder.js";
import { VoiceSimSessionManager } from "./models/VoiceSimSession.js";
import { AccessCodeManager } from "./models/AccessCode.js";
import { ScenarioShareTokenManager } from "./models/ScenarioShareToken.js";
import { BulkJobResultV2Manager } from "./models/BulkJobResultV2.js";
import { PublicScenarioAccessManager } from "./models/PublicScenarioAccess.js";
import { MemoryItemV2Manager } from "./models/MemoryItemV2.js";
import { AgentConfigurationManager } from "./models/AgentConfiguration.js";
import { Ph4456EvaluationManager } from "./models/Ph4456Evaluation.js";
import { PreceptorEvaluationManager } from "./models/PreceptorEvaluation.js";
import { InstitutionVectorStoreManager } from "./models/InstitutionVectorStore.js";
import { PreceptorRequestManager } from "./models/PreceptorRequest.js";
import { EmbedTokenManager } from "./models/EmbedToken.js";
import { MessageManager } from "./models/Message.js";
import { UserManager } from "./models/User.js";
import { AssistantManager } from "./models/Assistant.js";
import { SessionManager } from "./models/Session.js";
import { CurrentSessionManager } from "./models/CurrentSession.js";
import { ThreadManager } from "./models/Thread.js";
import { VectorStoreManager } from "./models/VectorStore.js";
import { AssistantFunctionLibraryManager } from "./models/AssistantFunctionLibrary.js";
import { HitlTaskManager } from "./models/HitlTask.js";
import { StudentFeedbackHistoryManager } from "./models/StudentFeedbackHistory.js";
import { AdminAssistantAuditLogManager } from "./models/AdminAssistantAuditLog.js";
import { ChatMessageManager } from "./models/ChatMessage.js";
import { DocumentProcessorConfigManager } from "./models/DocumentProcessorConfig.js";
import { SessionSummaryV2Manager } from "./models/SessionSummaryV2.js";
import { InstitutionalPartnershipManager } from "./models/InstitutionalPartnership.js";
import { ConversationArchiveManager } from "./models/ConversationArchive.js";
import { UserFileManager } from "./models/UserFile.js";
import { ClinicalEvaluationManager } from "./models/ClinicalEvaluation.js";
import { AgentMessageManager } from "./models/AgentMessage.js";
import { ClinicalDocumentProcessorManager } from "./models/ClinicalDocumentProcessor.js";
import { FisdapSessionManager } from "./models/FisdapSession.js";
import { AgencyManager } from "./models/Agency.js";
import { KnowledgeBaseManager } from "./models/KnowledgeBase.js";
import { NremtMedicalEvaluationManager } from "./models/NremtMedicalEvaluation.js";
import { AgentChatV2Manager } from "./models/AgentChatV2.js";
import { ShiftManager } from "./models/Shift.js";
import { CohortManager } from "./models/Cohort.js";
import { ScenarioGenerationProgressManager } from "./models/ScenarioGenerationProgress.js";
import { PatientEncounterManager } from "./models/PatientEncounter.js";
import { NremtTraumaEvaluationManager } from "./models/NremtTraumaEvaluation.js";
import { EducationalContentManager } from "./models/EducationalContent.js";
import { CohortMembershipManager } from "./models/CohortMembership.js";
import { AuditLogV2Manager } from "./models/AuditLogV2.js";
import { AgentChatManager } from "./models/AgentChat.js";
import { InstitutionalRepositoryManager } from "./models/InstitutionalRepository.js";
import { FormLayoutManager } from "./models/FormLayout.js";
import { AssistantAccessManager } from "./models/AssistantAccess.js";
import { AgentConversationManager } from "./models/AgentConversation.js";
import { ShiftProcessingManager } from "./models/ShiftProcessing.js";
import { PreceptorManager } from "./models/Preceptor.js";
import { WebhookSubscriptionManager } from "./models/WebhookSubscription.js";
import { BulkJobV2Manager } from "./models/BulkJobV2.js";
import { RoomOfRequirementManager } from "./models/RoomOfRequirement.js";
import { ConversationMemoryManager } from "./models/ConversationMemory.js";
import { SimulationSessionManager } from "./models/SimulationSession.js";
import { ClinicalSiteManager } from "./models/ClinicalSite.js";
import { ChatMessageV2Manager } from "./models/ChatMessageV2.js";
import { DeletedShiftProcessingManager } from "./models/DeletedShiftProcessing.js";
import { WatermarkConfigurationManager } from "./models/WatermarkConfiguration.js";
import { AiTrainingDataManager } from "./models/AiTrainingData.js";
import { ClinicalScenarioManager } from "./models/ClinicalScenario.js";
import { GeneratedEcgManager } from "./models/GeneratedEcg.js";
import { InstitutionConfigurationManager } from "./models/InstitutionConfiguration.js";
import { ExtractionTemplateManager } from "./models/ExtractionTemplate.js";
import { ShiftUnlockTokenManager } from "./models/ShiftUnlockToken.js";
import { ScenarioRunManager } from "./models/ScenarioRun.js";
import { EvalSystemManager } from "./models/EvalSystem.js";
import { EvalResultManager } from "./models/EvalResult.js";
import { MicuAccessTokenManager } from "./models/MicuAccessToken.js";
import { MicuCaseManager } from "./models/MicuCase.js";
import { MicuDeviceInstanceManager } from "./models/MicuDeviceInstance.js";
import { MicuDeviceLogManager } from "./models/MicuDeviceLog.js";
import { MicuMedicationInstanceManager } from "./models/MicuMedicationInstance.js";
import { MicuMedicationLogManager } from "./models/MicuMedicationLog.js";
import { FormQrCodeManager } from "./models/FormQrCode.js";
import { FormSubmissionManager } from "./models/FormSubmission.js";
import { InstitutionFormManager } from "./models/InstitutionForm.js";
import { ShiftPackManager } from "./models/ShiftPack.js";
import { CohortSemesterManager } from "./models/CohortSemester.js";
import { ShiftDocumentationManager } from "./models/ShiftDocumentation.js";
import { LiveAudioChunkManager } from "./models/LiveAudioChunk.js";
import { AttendanceMagicLinkTokenManager } from "./models/AttendanceMagicLinkToken.js";
import { EmsRunEvaluationManager } from "./models/EmsRunEvaluation.js";
import { QaChartManager } from "./models/QaChart.js";
import { QaChartFieldManager } from "./models/QaChartField.js";
import { QaGroupManager } from "./models/QaGroup.js";
import { QaKnowledgeBaseManager } from "./models/QaKnowledgeBase.js";
import { QaKnowledgeDocumentManager } from "./models/QaKnowledgeDocument.js";
import { QaMappingMemoryManager } from "./models/QaMappingMemory.js";
import { QaProcessingEventManager } from "./models/QaProcessingEvent.js";
import { QaReviewDecisionManager } from "./models/QaReviewDecision.js";
import { QaRoutingAssignmentManager } from "./models/QaRoutingAssignment.js";
import { QaRoutingRoleManager } from "./models/QaRoutingRole.js";
import { QaWorkflowManager } from "./models/QaWorkflow.js";
import { QuickChartEvaluationManager } from "./models/QuickChartEvaluation.js";
import { QuickQaProtocolRouteManager } from "./models/QuickQaProtocolRoute.js";
import { ClinicalReviewArtifactManager } from "./models/ClinicalReviewArtifact.js";
import { QaCrewIdentityManager } from "./models/QaCrewIdentity.js";
import { AuthorTrendProfileManager } from "./models/AuthorTrendProfile.js";
import { AttendanceEventManager } from "./models/AttendanceEvent.js";
import { AttendanceUserIpProfileManager } from "./models/AttendanceUserIpProfile.js";
import { AttendanceTestLinkManager } from "./models/AttendanceTestLink.js";
import { DefaultVoiceSimSessionSelection as DefaultVoiceSimSessionSelection2 } from "./models/VoiceSimSession.js";
import { DefaultAccessCodeSelection as DefaultAccessCodeSelection2 } from "./models/AccessCode.js";
import { DefaultScenarioShareTokenSelection as DefaultScenarioShareTokenSelection2 } from "./models/ScenarioShareToken.js";
import { DefaultBulkJobResultV2Selection as DefaultBulkJobResultV2Selection2 } from "./models/BulkJobResultV2.js";
import { DefaultPublicScenarioAccessSelection as DefaultPublicScenarioAccessSelection2 } from "./models/PublicScenarioAccess.js";
import { DefaultMemoryItemV2Selection as DefaultMemoryItemV2Selection2 } from "./models/MemoryItemV2.js";
import { DefaultAgentConfigurationSelection as DefaultAgentConfigurationSelection2 } from "./models/AgentConfiguration.js";
import { DefaultPh4456EvaluationSelection as DefaultPh4456EvaluationSelection2 } from "./models/Ph4456Evaluation.js";
import { DefaultPreceptorEvaluationSelection as DefaultPreceptorEvaluationSelection2 } from "./models/PreceptorEvaluation.js";
import { DefaultInstitutionVectorStoreSelection as DefaultInstitutionVectorStoreSelection2 } from "./models/InstitutionVectorStore.js";
import { DefaultPreceptorRequestSelection as DefaultPreceptorRequestSelection2 } from "./models/PreceptorRequest.js";
import { DefaultEmbedTokenSelection as DefaultEmbedTokenSelection2 } from "./models/EmbedToken.js";
import { DefaultMessageSelection as DefaultMessageSelection2 } from "./models/Message.js";
import { DefaultUserSelection as DefaultUserSelection2 } from "./models/User.js";
import { DefaultAssistantSelection as DefaultAssistantSelection2 } from "./models/Assistant.js";
import { DefaultSessionSelection as DefaultSessionSelection2 } from "./models/Session.js";
import { DefaultThreadSelection as DefaultThreadSelection2 } from "./models/Thread.js";
import { DefaultVectorStoreSelection as DefaultVectorStoreSelection2 } from "./models/VectorStore.js";
import { DefaultAssistantFunctionLibrarySelection as DefaultAssistantFunctionLibrarySelection2 } from "./models/AssistantFunctionLibrary.js";
import { DefaultHitlTaskSelection as DefaultHitlTaskSelection2 } from "./models/HitlTask.js";
import { DefaultStudentFeedbackHistorySelection as DefaultStudentFeedbackHistorySelection2 } from "./models/StudentFeedbackHistory.js";
import { DefaultAdminAssistantAuditLogSelection as DefaultAdminAssistantAuditLogSelection2 } from "./models/AdminAssistantAuditLog.js";
import { DefaultChatMessageSelection as DefaultChatMessageSelection2 } from "./models/ChatMessage.js";
import { DefaultDocumentProcessorConfigSelection as DefaultDocumentProcessorConfigSelection2 } from "./models/DocumentProcessorConfig.js";
import { DefaultSessionSummaryV2Selection as DefaultSessionSummaryV2Selection2 } from "./models/SessionSummaryV2.js";
import { DefaultInstitutionalPartnershipSelection as DefaultInstitutionalPartnershipSelection2 } from "./models/InstitutionalPartnership.js";
import { DefaultConversationArchiveSelection as DefaultConversationArchiveSelection2 } from "./models/ConversationArchive.js";
import { DefaultUserFileSelection as DefaultUserFileSelection2 } from "./models/UserFile.js";
import { DefaultClinicalEvaluationSelection as DefaultClinicalEvaluationSelection2 } from "./models/ClinicalEvaluation.js";
import { DefaultAgentMessageSelection as DefaultAgentMessageSelection2 } from "./models/AgentMessage.js";
import { DefaultClinicalDocumentProcessorSelection as DefaultClinicalDocumentProcessorSelection2 } from "./models/ClinicalDocumentProcessor.js";
import { DefaultFisdapSessionSelection as DefaultFisdapSessionSelection2 } from "./models/FisdapSession.js";
import { DefaultAgencySelection as DefaultAgencySelection2 } from "./models/Agency.js";
import { DefaultKnowledgeBaseSelection as DefaultKnowledgeBaseSelection2 } from "./models/KnowledgeBase.js";
import { DefaultNremtMedicalEvaluationSelection as DefaultNremtMedicalEvaluationSelection2 } from "./models/NremtMedicalEvaluation.js";
import { DefaultAgentChatV2Selection as DefaultAgentChatV2Selection2 } from "./models/AgentChatV2.js";
import { DefaultShiftSelection as DefaultShiftSelection2 } from "./models/Shift.js";
import { DefaultCohortSelection as DefaultCohortSelection2 } from "./models/Cohort.js";
import { DefaultScenarioGenerationProgressSelection as DefaultScenarioGenerationProgressSelection2 } from "./models/ScenarioGenerationProgress.js";
import { DefaultPatientEncounterSelection as DefaultPatientEncounterSelection2 } from "./models/PatientEncounter.js";
import { DefaultNremtTraumaEvaluationSelection as DefaultNremtTraumaEvaluationSelection2 } from "./models/NremtTraumaEvaluation.js";
import { DefaultEducationalContentSelection as DefaultEducationalContentSelection2 } from "./models/EducationalContent.js";
import { DefaultCohortMembershipSelection as DefaultCohortMembershipSelection2 } from "./models/CohortMembership.js";
import { DefaultAuditLogV2Selection as DefaultAuditLogV2Selection2 } from "./models/AuditLogV2.js";
import { DefaultAgentChatSelection as DefaultAgentChatSelection2 } from "./models/AgentChat.js";
import { DefaultInstitutionalRepositorySelection as DefaultInstitutionalRepositorySelection2 } from "./models/InstitutionalRepository.js";
import { DefaultFormLayoutSelection as DefaultFormLayoutSelection2 } from "./models/FormLayout.js";
import { DefaultAssistantAccessSelection as DefaultAssistantAccessSelection2 } from "./models/AssistantAccess.js";
import { DefaultAgentConversationSelection as DefaultAgentConversationSelection2 } from "./models/AgentConversation.js";
import { DefaultShiftProcessingSelection as DefaultShiftProcessingSelection2 } from "./models/ShiftProcessing.js";
import { DefaultPreceptorSelection as DefaultPreceptorSelection2 } from "./models/Preceptor.js";
import { DefaultWebhookSubscriptionSelection as DefaultWebhookSubscriptionSelection2 } from "./models/WebhookSubscription.js";
import { DefaultBulkJobV2Selection as DefaultBulkJobV2Selection2 } from "./models/BulkJobV2.js";
import { DefaultRoomOfRequirementSelection as DefaultRoomOfRequirementSelection2 } from "./models/RoomOfRequirement.js";
import { DefaultConversationMemorySelection as DefaultConversationMemorySelection2 } from "./models/ConversationMemory.js";
import { DefaultSimulationSessionSelection as DefaultSimulationSessionSelection2 } from "./models/SimulationSession.js";
import { DefaultClinicalSiteSelection as DefaultClinicalSiteSelection2 } from "./models/ClinicalSite.js";
import { DefaultChatMessageV2Selection as DefaultChatMessageV2Selection2 } from "./models/ChatMessageV2.js";
import { DefaultDeletedShiftProcessingSelection as DefaultDeletedShiftProcessingSelection2 } from "./models/DeletedShiftProcessing.js";
import { DefaultWatermarkConfigurationSelection as DefaultWatermarkConfigurationSelection2 } from "./models/WatermarkConfiguration.js";
import { DefaultAiTrainingDataSelection as DefaultAiTrainingDataSelection2 } from "./models/AiTrainingData.js";
import { DefaultClinicalScenarioSelection as DefaultClinicalScenarioSelection2 } from "./models/ClinicalScenario.js";
import { DefaultGeneratedEcgSelection as DefaultGeneratedEcgSelection2 } from "./models/GeneratedEcg.js";
import { DefaultInstitutionConfigurationSelection as DefaultInstitutionConfigurationSelection2 } from "./models/InstitutionConfiguration.js";
import { DefaultExtractionTemplateSelection as DefaultExtractionTemplateSelection2 } from "./models/ExtractionTemplate.js";
import { DefaultShiftUnlockTokenSelection as DefaultShiftUnlockTokenSelection2 } from "./models/ShiftUnlockToken.js";
import { DefaultScenarioRunSelection as DefaultScenarioRunSelection2 } from "./models/ScenarioRun.js";
import { DefaultEvalSystemSelection as DefaultEvalSystemSelection2 } from "./models/EvalSystem.js";
import { DefaultEvalResultSelection as DefaultEvalResultSelection2 } from "./models/EvalResult.js";
import { DefaultMicuAccessTokenSelection as DefaultMicuAccessTokenSelection2 } from "./models/MicuAccessToken.js";
import { DefaultMicuCaseSelection as DefaultMicuCaseSelection2 } from "./models/MicuCase.js";
import { DefaultMicuDeviceInstanceSelection as DefaultMicuDeviceInstanceSelection2 } from "./models/MicuDeviceInstance.js";
import { DefaultMicuDeviceLogSelection as DefaultMicuDeviceLogSelection2 } from "./models/MicuDeviceLog.js";
import { DefaultMicuMedicationInstanceSelection as DefaultMicuMedicationInstanceSelection2 } from "./models/MicuMedicationInstance.js";
import { DefaultMicuMedicationLogSelection as DefaultMicuMedicationLogSelection2 } from "./models/MicuMedicationLog.js";
import { DefaultFormQrCodeSelection as DefaultFormQrCodeSelection2 } from "./models/FormQrCode.js";
import { DefaultFormSubmissionSelection as DefaultFormSubmissionSelection2 } from "./models/FormSubmission.js";
import { DefaultInstitutionFormSelection as DefaultInstitutionFormSelection2 } from "./models/InstitutionForm.js";
import { DefaultShiftPackSelection as DefaultShiftPackSelection2 } from "./models/ShiftPack.js";
import { DefaultCohortSemesterSelection as DefaultCohortSemesterSelection2 } from "./models/CohortSemester.js";
import { DefaultShiftDocumentationSelection as DefaultShiftDocumentationSelection2 } from "./models/ShiftDocumentation.js";
import { DefaultLiveAudioChunkSelection as DefaultLiveAudioChunkSelection2 } from "./models/LiveAudioChunk.js";
import { DefaultAttendanceMagicLinkTokenSelection as DefaultAttendanceMagicLinkTokenSelection2 } from "./models/AttendanceMagicLinkToken.js";
import { DefaultEmsRunEvaluationSelection as DefaultEmsRunEvaluationSelection2 } from "./models/EmsRunEvaluation.js";
import { DefaultQaChartSelection as DefaultQaChartSelection2 } from "./models/QaChart.js";
import { DefaultQaChartFieldSelection as DefaultQaChartFieldSelection2 } from "./models/QaChartField.js";
import { DefaultQaGroupSelection as DefaultQaGroupSelection2 } from "./models/QaGroup.js";
import { DefaultQaKnowledgeBaseSelection as DefaultQaKnowledgeBaseSelection2 } from "./models/QaKnowledgeBase.js";
import { DefaultQaKnowledgeDocumentSelection as DefaultQaKnowledgeDocumentSelection2 } from "./models/QaKnowledgeDocument.js";
import { DefaultQaMappingMemorySelection as DefaultQaMappingMemorySelection2 } from "./models/QaMappingMemory.js";
import { DefaultQaProcessingEventSelection as DefaultQaProcessingEventSelection2 } from "./models/QaProcessingEvent.js";
import { DefaultQaReviewDecisionSelection as DefaultQaReviewDecisionSelection2 } from "./models/QaReviewDecision.js";
import { DefaultQaRoutingAssignmentSelection as DefaultQaRoutingAssignmentSelection2 } from "./models/QaRoutingAssignment.js";
import { DefaultQaRoutingRoleSelection as DefaultQaRoutingRoleSelection2 } from "./models/QaRoutingRole.js";
import { DefaultQaWorkflowSelection as DefaultQaWorkflowSelection2 } from "./models/QaWorkflow.js";
import { DefaultQuickChartEvaluationSelection as DefaultQuickChartEvaluationSelection2 } from "./models/QuickChartEvaluation.js";
import { DefaultQuickQaProtocolRouteSelection as DefaultQuickQaProtocolRouteSelection2 } from "./models/QuickQaProtocolRoute.js";
import { DefaultClinicalReviewArtifactSelection as DefaultClinicalReviewArtifactSelection2 } from "./models/ClinicalReviewArtifact.js";
import { DefaultQaCrewIdentitySelection as DefaultQaCrewIdentitySelection2 } from "./models/QaCrewIdentity.js";
import { DefaultAuthorTrendProfileSelection as DefaultAuthorTrendProfileSelection2 } from "./models/AuthorTrendProfile.js";
import { DefaultAttendanceEventSelection as DefaultAttendanceEventSelection2 } from "./models/AttendanceEvent.js";
import { DefaultAttendanceUserIpProfileSelection as DefaultAttendanceUserIpProfileSelection2 } from "./models/AttendanceUserIpProfile.js";
import { DefaultAttendanceTestLinkSelection as DefaultAttendanceTestLinkSelection2 } from "./models/AttendanceTestLink.js";
const productionEnv = "production";
const fallbackEnv = "development";
const availableAuthenticationModes = [
  "apiKey",
  "browserSession",
  "anonymous",
  "internalAuthToken",
  "internal",
  "custom"
];
const maybeGetAuthenticationModeOptionsFromClientOptions = (options) => {
  const topLevelAuthModes = {};
  for (const key of availableAuthenticationModes) {
    if (key in options) {
      topLevelAuthModes[key] = options[key];
    }
  }
  if ("authenticationMode" in options && Object.keys(topLevelAuthModes).length > 0) {
    throw new GadgetClientError(
      "Declaring authentication modes at the top level and under the `authenticationMode` key at the same time is not allowed."
    );
  }
  if ("authenticationMode" in options) {
    return options.authenticationMode;
  }
  if (Object.keys(topLevelAuthModes).length === 0) {
    return void 0;
  }
  return topLevelAuthModes;
};
const getImplicitEnv = () => {
  try {
    return process.env.GADGET_ENV;
  } catch (error) {
    return void 0;
  }
};
class PapamedicAiClient {
  constructor(options) {
    /** Executes the OGclone2FisdapScraping global action. */
    this.OGclone2FisdapScraping = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "OGclone2FisdapScraping",
      operationName: "OGclone2FisdapScraping",
      operationReturnType: "OGclone2FisdapScraping",
      namespace: null,
      variables: {
        shiftId: { required: false, type: "String" },
        emailSubject: { required: false, type: "String" },
        bypassMode: { required: false, type: "Boolean" },
        mockSubject: { required: false, type: "String" },
        htmlContent: { required: false, type: "String" },
        shiftProcessingId: { required: false, type: "String" },
        skipEvaluation: { required: false, type: "Boolean" },
        isDraft: { required: false, type: "Boolean" },
        generatePdf: { required: false, type: "Boolean" }
      }
    });
    /** Executes the acceptPrivacyAgreement global action. */
    this.acceptPrivacyAgreement = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "acceptPrivacyAgreement",
      operationName: "acceptPrivacyAgreement",
      operationReturnType: "AcceptPrivacyAgreement",
      namespace: null,
      variables: {}
    });
    /** Executes the addFilesToVectorStore global action. */
    this.addFilesToVectorStore = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "addFilesToVectorStore",
      operationName: "addFilesToVectorStore",
      operationReturnType: "AddFilesToVectorStore",
      namespace: null,
      variables: {
        vectorStoreId: { required: false, type: "String" },
        files: {
          required: false,
          type: "[AddFilesToVectorStoreFilesElementTypeInput!]"
        },
        chunkSize: { required: false, type: "Float" },
        chunkOverlap: { required: false, type: "Float" }
      }
    });
    /** Executes the addUserRoleToApprovedUsers global action. */
    this.addUserRoleToApprovedUsers = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "addUserRoleToApprovedUsers",
      operationName: "addUserRoleToApprovedUsers",
      operationReturnType: "AddUserRoleToApprovedUsers",
      namespace: null,
      variables: {}
    });
    /** Executes the adminCreateShift global action. */
    this.adminCreateShift = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "adminCreateShift",
      operationName: "adminCreateShift",
      operationReturnType: "AdminCreateShift",
      namespace: null,
      variables: {
        shiftDate: { required: false, type: "String" },
        endTime: { required: false, type: "String" },
        shiftType: { required: false, type: "String" },
        location: { required: false, type: "String" },
        unit: { required: false, type: "String" },
        maxStudents: { required: false, type: "String" },
        cohort: { required: false, type: "String" },
        institution: { required: false, type: "String" }
      }
    });
    /** Executes the adminResetUserPassword global action. */
    this.adminResetUserPassword = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "adminResetUserPassword",
      operationName: "adminResetUserPassword",
      operationReturnType: "AdminResetUserPassword",
      namespace: null,
      variables: { userId: { required: false, type: "String" } }
    });
    /** Executes the agentChatMessage global action. */
    this.agentChatMessage = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "agentChatMessage",
      operationName: "agentChatMessage",
      operationReturnType: "AgentChatMessage",
      namespace: null,
      variables: {
        input: { required: false, type: "String" },
        agentType: { required: false, type: "String" },
        agentConfigId: { required: false, type: "String" },
        localSessionId: { required: false, type: "String" },
        conversationId: { required: false, type: "String" },
        instructions: { required: false, type: "String" },
        vectorStoreId: { required: false, type: "String" },
        skipInitiator: { required: false, type: "Boolean" },
        resumeConversation: { required: false, type: "Boolean" }
      }
    });
    /** Executes the agentChatMessageV2 global action. */
    this.agentChatMessageV2 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "agentChatMessageV2",
      operationName: "agentChatMessageV2",
      operationReturnType: "AgentChatMessageV2",
      namespace: null,
      variables: {
        input: { required: false, type: "String" },
        message: { required: false, type: "String" },
        agentType: { required: false, type: "String" },
        localSessionId: { required: false, type: "String" },
        conversationId: { required: false, type: "String" },
        model: { required: false, type: "String" },
        maxTokens: { required: false, type: "Float" },
        temperature: { required: false, type: "Float" }
      }
    });
    /** Executes the agentChatMessageV2Admin global action. */
    this.agentChatMessageV2Admin = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "agentChatMessageV2Admin",
      operationName: "agentChatMessageV2Admin",
      operationReturnType: "AgentChatMessageV2Admin",
      namespace: null,
      variables: {}
    });
    /** Executes the agentRouter global action. */
    this.agentRouter = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "agentRouter",
      operationName: "agentRouter",
      operationReturnType: "AgentRouter",
      namespace: null,
      variables: {}
    });
    /** Executes the analyzeAndCleanupShiftData global action. */
    this.analyzeAndCleanupShiftData = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "analyzeAndCleanupShiftData",
      operationName: "analyzeAndCleanupShiftData",
      operationReturnType: "AnalyzeAndCleanupShiftData",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        deduplicatePatientCounts: { required: false, type: "Boolean" },
        deleteZeroPatientShifts: { required: false, type: "Boolean" },
        deleteDuplicateShifts: { required: false, type: "Boolean" },
        minSubmissionCount: { required: false, type: "Float" },
        createBackups: { required: false, type: "Boolean" },
        deleteAfterBackup: { required: false, type: "Boolean" }
      }
    });
    /** Executes the analyzeDocumentProcessingState global action. */
    this.analyzeDocumentProcessingState = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "analyzeDocumentProcessingState",
      operationName: "analyzeDocumentProcessingState",
      operationReturnType: "AnalyzeDocumentProcessingState",
      namespace: null,
      variables: {}
    });
    /** Executes the analyzeDocumentWithAssistant global action. */
    this.analyzeDocumentWithAssistant = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "analyzeDocumentWithAssistant",
      operationName: "analyzeDocumentWithAssistant",
      operationReturnType: "AnalyzeDocumentWithAssistant",
      namespace: null,
      variables: {
        documentProcessingId: { required: false, type: "String" },
        customInstructions: { required: false, type: "String" }
      }
    });
    /** Executes the answerScenarioQuestion global action. */
    this.answerScenarioQuestion = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "answerScenarioQuestion",
      operationName: "answerScenarioQuestion",
      operationReturnType: "AnswerScenarioQuestion",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        question: { required: false, type: "String" },
        useEmbeddings: { required: false, type: "Boolean" }
      }
    });
    /** Executes the appointInstitutionAdministrator global action. */
    this.appointInstitutionAdministrator = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "appointInstitutionAdministrator",
      operationName: "appointInstitutionAdministrator",
      operationReturnType: "AppointInstitutionAdministrator",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        institution: { required: false, type: "String" }
      }
    });
    /** Executes the approveUser global action. */
    this.approveUser = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "approveUser",
      operationName: "approveUser",
      operationReturnType: "ApproveUser",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        approvedBy: { required: false, type: "String" },
        role: { required: false, type: "String" },
        assistantAccess: { required: false, type: "String" },
        selectedAssistants: { required: false, type: "[String!]" },
        duration: { required: false, type: "String" },
        accessNotes: { required: false, type: "String" }
      }
    });
    /** Executes the archiveThread global action. */
    this.archiveThread = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "archiveThread",
      operationName: "archiveThread",
      operationReturnType: "ArchiveThread",
      namespace: null,
      variables: {
        threadId: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        forceArchive: { required: false, type: "Boolean" }
      }
    });
    /** Executes the assignAccessTier global action. */
    this.assignAccessTier = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "assignAccessTier",
      operationName: "assignAccessTier",
      operationReturnType: "AssignAccessTier",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        userEmail: { required: false, type: "String" },
        tier: { required: false, type: "String" },
        source: { required: false, type: "String" },
        addons: { required: false, type: "[String!]" },
        startAt: { required: false, type: "String" },
        endAt: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        notes: { required: false, type: "String" },
        syncAgentAccess: { required: false, type: "Boolean" }
      }
    });
    /** Executes the assignPreceptorToPatient global action. */
    this.assignPreceptorToPatient = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "assignPreceptorToPatient",
      operationName: "assignPreceptorToPatient",
      operationReturnType: "AssignPreceptorToPatient",
      namespace: null,
      variables: {
        patientEncounterId: { required: false, type: "String" },
        preceptorId: { required: false, type: "String" },
        overrideValidation: { required: false, type: "Boolean" }
      }
    });
    /** Executes the auditRoleChecks global action. */
    this.auditRoleChecks = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "auditRoleChecks",
      operationName: "auditRoleChecks",
      operationReturnType: "AuditRoleChecks",
      namespace: null,
      variables: {}
    });
    /** Executes the backfillClinicalSiteGeocoding global action. */
    this.backfillClinicalSiteGeocoding = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "backfillClinicalSiteGeocoding",
      operationName: "backfillClinicalSiteGeocoding",
      operationReturnType: "BackfillClinicalSiteGeocoding",
      namespace: null,
      variables: {}
    });
    /** Executes the backfillDebriefAudioFlags global action. */
    this.backfillDebriefAudioFlags = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "backfillDebriefAudioFlags",
      operationName: "backfillDebriefAudioFlags",
      operationReturnType: "BackfillDebriefAudioFlags",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        institution: { required: false, type: "String" },
        cohortBatchSize: { required: false, type: "Float" },
        userId: { required: false, type: "String" },
        internalApi: { required: false, type: "Boolean" }
      }
    });
    /** Executes the backfillShiftTypes global action. */
    this.backfillShiftTypes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "backfillShiftTypes",
      operationName: "backfillShiftTypes",
      operationReturnType: "BackfillShiftTypes",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        batchSize: { required: false, type: "Float" },
        runCount: { required: false, type: "Float" }
      }
    });
    /** Executes the batchProcessDocuments global action. */
    this.batchProcessDocuments = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "batchProcessDocuments",
      operationName: "batchProcessDocuments",
      operationReturnType: "BatchProcessDocuments",
      namespace: null,
      variables: {
        fileIds: { required: false, type: "[String!]" },
        duplicateAction: { required: false, type: "String" },
        namePattern: { required: false, type: "String" }
      }
    });
    /** Executes the blockPreceptorFromInstitution global action. */
    this.blockPreceptorFromInstitution = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "blockPreceptorFromInstitution",
      operationName: "blockPreceptorFromInstitution",
      operationReturnType: "BlockPreceptorFromInstitution",
      namespace: null,
      variables: {
        preceptorId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        reason: { required: false, type: "String" }
      }
    });
    /** Executes the bulkAssignPreceptorToShift global action. */
    this.bulkAssignPreceptorToShift = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "bulkAssignPreceptorToShift",
      operationName: "bulkAssignPreceptorToShift",
      operationReturnType: "BulkAssignPreceptorToShift",
      namespace: null,
      variables: {
        shiftId: { required: false, type: "String" },
        preceptorId: { required: false, type: "String" },
        applyToExisting: { required: false, type: "Boolean" },
        skipIfAssigned: { required: false, type: "Boolean" },
        overrideValidation: { required: false, type: "Boolean" }
      }
    });
    /** Executes the bulkGenerateThreadSummaries global action. */
    this.bulkGenerateThreadSummaries = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "bulkGenerateThreadSummaries",
      operationName: "bulkGenerateThreadSummaries",
      operationReturnType: "BulkGenerateThreadSummaries",
      namespace: null,
      variables: {}
    });
    /** Executes the bulkJobWorkerV2 global action. */
    this.bulkJobWorkerV2 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "bulkJobWorkerV2",
      operationName: "bulkJobWorkerV2",
      operationReturnType: "BulkJobWorkerV2",
      namespace: null,
      variables: { jobId: { required: false, type: "String" } }
    });
    /** Executes the bulkPasswordReset global action. */
    this.bulkPasswordReset = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "bulkPasswordReset",
      operationName: "bulkPasswordReset",
      operationReturnType: "BulkPasswordReset",
      namespace: null,
      variables: {
        userIds: { required: false, type: "[String!]" },
        customMessage: { required: false, type: "String" }
      }
    });
    /** Executes the callMedicalControl global action. */
    this.callMedicalControl = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "callMedicalControl",
      operationName: "callMedicalControl",
      operationReturnType: "CallMedicalControl",
      namespace: null,
      variables: {
        message: { required: false, type: "String" },
        trainingLevel: { required: false, type: "String" },
        conversationHistory: {
          required: false,
          type: "[CallMedicalControlConversationHistoryElementTypeInput!]"
        },
        patientContext: { required: false, type: "CallMedicalControlPatientContextInput" }
      }
    });
    /** Executes the canonicalizeAction global action. */
    this.canonicalizeAction = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "canonicalizeAction",
      operationName: "canonicalizeAction",
      operationReturnType: "CanonicalizeAction",
      namespace: null,
      variables: {
        rawText: { required: false, type: "String" },
        timestamp: { required: false, type: "String" }
      }
    });
    /** Executes the checkActiveVoiceSession global action. */
    this.checkActiveVoiceSession = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkActiveVoiceSession",
      operationName: "checkActiveVoiceSession",
      operationReturnType: "CheckActiveVoiceSession",
      namespace: null,
      variables: {
        voiceSimSessionId: { required: false, type: "String" },
        deviceFingerprint: { required: false, type: "String" }
      }
    });
    /** Executes the checkAdminAccess global action. */
    this.checkAdminAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkAdminAccess",
      operationName: "checkAdminAccess",
      operationReturnType: "CheckAdminAccess",
      namespace: null,
      variables: {}
    });
    /** Executes the checkAgentAccess global action. */
    this.checkAgentAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkAgentAccess",
      operationName: "checkAgentAccess",
      operationReturnType: "CheckAgentAccess",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        agentName: { required: false, type: "String" }
      }
    });
    /** Executes the checkAssistantAccess global action. */
    this.checkAssistantAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkAssistantAccess",
      operationName: "checkAssistantAccess",
      operationReturnType: "CheckAssistantAccess",
      namespace: null,
      variables: {
        assistantId: { required: false, type: "String" },
        userEmail: { required: false, type: "String" }
      }
    });
    /** Executes the checkDocumentProcessingDuplicates global action. */
    this.checkDocumentProcessingDuplicates = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkDocumentProcessingDuplicates",
      operationName: "checkDocumentProcessingDuplicates",
      operationReturnType: "CheckDocumentProcessingDuplicates",
      namespace: null,
      variables: {
        userFileId: { required: false, type: "String" },
        action: { required: false, type: "String" },
        newFileName: { required: false, type: "String" }
      }
    });
    /** Executes the checkEmailExists global action. */
    this.checkEmailExists = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkEmailExists",
      operationName: "checkEmailExists",
      operationReturnType: "CheckEmailExists",
      namespace: null,
      variables: { email: { required: false, type: "String" } }
    });
    /** Executes the checkEnhancedScenarioAccess global action. */
    this.checkEnhancedScenarioAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkEnhancedScenarioAccess",
      operationName: "checkEnhancedScenarioAccess",
      operationReturnType: "CheckEnhancedScenarioAccess",
      namespace: null,
      variables: { userId: { required: false, type: "String" } }
    });
    /** Executes the checkForNewClinicalEmails global action. */
    this.checkForNewClinicalEmails = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkForNewClinicalEmails",
      operationName: "checkForNewClinicalEmails",
      operationReturnType: "CheckForNewClinicalEmails",
      namespace: null,
      variables: {
        webhookTriggered: { required: false, type: "Boolean" },
        lookbackHours: { required: false, type: "Float" },
        sweepMode: { required: false, type: "Boolean" },
        sweepRequestedHours: { required: false, type: "Float" },
        sweepRequestedByEmail: { required: false, type: "String" },
        sweepReplyToEmail: { required: false, type: "String" },
        sweepRequestMessageId: { required: false, type: "String" },
        sweepRequestSubject: { required: false, type: "String" },
        messageIds: { required: false, type: "[String!]" }
      }
    });
    /** Executes the checkPublicScenarioAccess global action. */
    this.checkPublicScenarioAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkPublicScenarioAccess",
      operationName: "checkPublicScenarioAccess",
      operationReturnType: "CheckPublicScenarioAccess",
      namespace: null,
      variables: {}
    });
    /** Executes the checkUserSession global action. */
    this.checkUserSession = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkUserSession",
      operationName: "checkUserSession",
      operationReturnType: "CheckUserSession",
      namespace: null,
      variables: {}
    });
    /** Executes the cleanupInactiveSessions global action. */
    this.cleanupInactiveSessions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "cleanupInactiveSessions",
      operationName: "cleanupInactiveSessions",
      operationReturnType: "CleanupInactiveSessions",
      namespace: null,
      variables: {}
    });
    /** Executes the clearAllUsers global action. */
    this.clearAllUsers = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "clearAllUsers",
      operationName: "clearAllUsers",
      operationReturnType: "ClearAllUsers",
      namespace: null,
      variables: {}
    });
    /** Executes the combineFisdapPatientData global action. */
    this.combineFisdapPatientData = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "combineFisdapPatientData",
      operationName: "combineFisdapPatientData",
      operationReturnType: "CombineFisdapPatientData",
      namespace: null,
      variables: {
        shiftId: { required: false, type: "String" },
        bypassMode: { required: false, type: "Boolean" },
        htmlContent: { required: false, type: "String" }
      }
    });
    /** Executes the compareVectorStoreFileSizes global action. */
    this.compareVectorStoreFileSizes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "compareVectorStoreFileSizes",
      operationName: "compareVectorStoreFileSizes",
      operationReturnType: "CompareVectorStoreFileSizes",
      namespace: null,
      variables: { vectorStoreId: { required: false, type: "String" } }
    });
    /** Executes the consolidateAdminRoles global action. */
    this.consolidateAdminRoles = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "consolidateAdminRoles",
      operationName: "consolidateAdminRoles",
      operationReturnType: "ConsolidateAdminRoles",
      namespace: null,
      variables: {}
    });
    /** Executes the convertCohortAssignmentStructure global action. */
    this.convertCohortAssignmentStructure = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "convertCohortAssignmentStructure",
      operationName: "convertCohortAssignmentStructure",
      operationReturnType: "ConvertCohortAssignmentStructure",
      namespace: null,
      variables: {}
    });
    /** Executes the createAdminUser global action. */
    this.createAdminUser = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createAdminUser",
      operationName: "createAdminUser",
      operationReturnType: "CreateAdminUser",
      namespace: null,
      variables: {}
    });
    /** Executes the createAgentFineTuningJob global action. */
    this.createAgentFineTuningJob = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createAgentFineTuningJob",
      operationName: "createAgentFineTuningJob",
      operationReturnType: "CreateAgentFineTuningJob",
      namespace: null,
      variables: {
        agentType: { required: false, type: "String" },
        baseModel: { required: false, type: "String" },
        batchId: { required: false, type: "String" },
        trainingCategory: { required: false, type: "String" },
        maxSamples: { required: false, type: "Float" },
        hyperparameters: {
          required: false,
          type: "CreateAgentFineTuningJobHyperparametersInput"
        }
      }
    });
    /** Executes the createAgentResponseWithContext global action. */
    this.createAgentResponseWithContext = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createAgentResponseWithContext",
      operationName: "createAgentResponseWithContext",
      operationReturnType: "CreateAgentResponseWithContext",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        agentType: { required: false, type: "String" },
        userMessage: { required: false, type: "String" },
        conversationId: { required: false, type: "String" },
        includeContext: { required: false, type: "Boolean" }
      }
    });
    /** Executes the createBackgroundTask global action. */
    this.createBackgroundTask = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createBackgroundTask",
      operationName: "createBackgroundTask",
      operationReturnType: "CreateBackgroundTask",
      namespace: null,
      variables: {
        task_type: { required: false, type: "String" },
        task_prompt: { required: false, type: "String" },
        user_id: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        cohort: { required: false, type: "String" },
        agent_name: { required: false, type: "String" },
        quantity: { required: false, type: "Float" },
        subject_area: { required: false, type: "String" },
        difficulty_level: { required: false, type: "String" },
        additional_context: { required: false, type: "String" }
      }
    });
    /** Executes the createCohortGlobal global action. */
    this.createCohortGlobal = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createCohortGlobal",
      operationName: "createCohortGlobal",
      operationReturnType: "CreateCohortGlobal",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        name: { required: false, type: "String" },
        displayName: { required: false, type: "String" },
        cohortType: { required: false, type: "String" },
        academicYear: { required: false, type: "String" },
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" },
        isActive: { required: false, type: "Boolean" },
        maxStudents: { required: false, type: "Float" },
        semester: { required: false, type: "String" },
        graduationDate: { required: false, type: "String" },
        description: { required: false, type: "String" },
        requirements: { required: false, type: "JSONObject" },
        shiftEligibility: { required: false, type: "JSONObject" },
        enableClinicalDocNotifications: { required: false, type: "Boolean" },
        escalationMembers: { required: false, type: "[String!]" },
        escalationSettings: { required: false, type: "JSONObject" },
        instructorPermissions: { required: false, type: "JSONObject" },
        cohortScenarioGeneratorAccess: { required: false, type: "Boolean" },
        grantScenarioAccessToInstructors: { required: false, type: "Boolean" },
        cohortDocReaderEnabled: { required: false, type: "Boolean" },
        cohortHasUnlimitedScenarios: { required: false, type: "Boolean" },
        cohortScenarioGenerationLimit: { required: false, type: "Float" },
        cohortAgentAccessEnabled: { required: false, type: "Boolean" },
        defaultAgentAccessMode: { required: false, type: "String" },
        cohortAccessibleAgents: { required: false, type: "[String!]" },
        autoGrantAgentAccess: { required: false, type: "Boolean" },
        cohortDebriefAudioEnabled: { required: false, type: "Boolean" },
        calendarMode: { required: false, type: "String" },
        calendarSyncEnabled: { required: false, type: "Boolean" },
        fisdapCalendarUrl: { required: false, type: "String" }
      }
    });
    /** Executes the createDocRealtimeAgent global action. */
    this.createDocRealtimeAgent = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createDocRealtimeAgent",
      operationName: "createDocRealtimeAgent",
      operationReturnType: "CreateDocRealtimeAgent",
      namespace: null,
      variables: {}
    });
    /** Executes the createDocumentProcessor global action. */
    this.createDocumentProcessor = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createDocumentProcessor",
      operationName: "createDocumentProcessor",
      operationReturnType: "CreateDocumentProcessor",
      namespace: null,
      variables: {
        processingGoal: { required: false, type: "String" },
        fieldDefinitionMethod: { required: false, type: "String" },
        templateFile: { required: false, type: "JSONObject" },
        manualFields: { required: false, type: "[String!]" },
        referenceFiles: { required: false, type: "[JSONObject!]" },
        configName: { required: false, type: "String" },
        institution: { required: false, type: "String" }
      }
    });
    /** Executes the createEmailWebhookSubscription global action. */
    this.createEmailWebhookSubscription = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createEmailWebhookSubscription",
      operationName: "createEmailWebhookSubscription",
      operationReturnType: "CreateEmailWebhookSubscription",
      namespace: null,
      variables: {}
    });
    /** Executes the createGraphSubscription global action. */
    this.createGraphSubscription = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createGraphSubscription",
      operationName: "createGraphSubscription",
      operationReturnType: "CreateGraphSubscription",
      namespace: null,
      variables: {}
    });
    /** Executes the createInstitution global action. */
    this.createInstitution = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createInstitution",
      operationName: "createInstitution",
      operationReturnType: "CreateInstitution",
      namespace: null,
      variables: {
        institutionName: { required: false, type: "String" },
        institutionType: { required: false, type: "String" },
        description: { required: false, type: "String" },
        adminEmail: { required: false, type: "String" }
      }
    });
    /** Executes the createLocalVectorStore global action. */
    this.createLocalVectorStore = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createLocalVectorStore",
      operationName: "createLocalVectorStore",
      operationReturnType: "CreateLocalVectorStore",
      namespace: null,
      variables: {
        name: { required: false, type: "String" },
        description: { required: false, type: "String" },
        agentTypes: { required: false, type: "[String!]" },
        files: { required: false, type: "[JSONObject!]" },
        institution: { required: false, type: "String" },
        chunkSize: { required: false, type: "Float" },
        chunkOverlap: { required: false, type: "Float" }
      }
    });
    /** Executes the createNewInstitution global action. */
    this.createNewInstitution = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createNewInstitution",
      operationName: "createNewInstitution",
      operationReturnType: "CreateNewInstitution",
      namespace: null,
      variables: {
        institutionName: { required: false, type: "String" },
        template: { required: false, type: "String" },
        features: { required: false, type: "JSONObject" },
        contactInfo: { required: false, type: "JSONObject" }
      }
    });
    /** Executes the createOpenShift global action. */
    this.createOpenShift = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createOpenShift",
      operationName: "createOpenShift",
      operationReturnType: "CreateOpenShift",
      namespace: null,
      variables: {
        shiftDate: { required: false, type: "String" },
        startTime: { required: false, type: "String" },
        duration: { required: false, type: "Float" },
        shiftType: { required: false, type: "String" },
        location: { required: false, type: "String" },
        unit: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        cohort: { required: false, type: "String" },
        maxStudents: { required: false, type: "Float" },
        assignedCohorts: { required: false, type: "[String!]" }
      }
    });
    /** Executes the createQaKnowledgeBase global action. */
    this.createQaKnowledgeBase = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createQaKnowledgeBase",
      operationName: "createQaKnowledgeBase",
      operationReturnType: "CreateQaKnowledgeBase",
      namespace: null,
      variables: {
        workflowId: { required: false, type: "String" },
        name: { required: false, type: "String" },
        institution: { required: false, type: "String" }
      }
    });
    /** Executes the createResponse global action. */
    this.createResponse = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createResponse",
      operationName: "createResponse",
      operationReturnType: "CreateResponse",
      namespace: null,
      variables: {
        input: { required: false, type: "String" },
        agentType: { required: false, type: "String" },
        instructions: { required: false, type: "String" },
        vectorStoreId: { required: false, type: "String" },
        conversationId: { required: false, type: "String" },
        previousResponseId: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the createScenarioShareLink global action. */
    this.createScenarioShareLink = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createScenarioShareLink",
      operationName: "createScenarioShareLink",
      operationReturnType: "CreateScenarioShareLink",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        emailAddresses: { required: false, type: "[String!]" },
        password: { required: false, type: "String" },
        expiresInHours: { required: false, type: "Float" },
        expiresAt: { required: false, type: "String" },
        notes: { required: false, type: "String" },
        useInstitutionalDomain: { required: false, type: "Boolean" },
        institutionalDomain: { required: false, type: "String" },
        notifyInstructorOnSubmit: { required: false, type: "Boolean" },
        selectedInstitution: { required: false, type: "String" },
        cloneToInstructors: { required: false, type: "[String!]" }
      }
    });
    /** Executes the createScenarioWithECG global action. */
    this.createScenarioWithECG = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createScenarioWithECG",
      operationName: "createScenarioWithECG",
      operationReturnType: "CreateScenarioWithECG",
      namespace: null,
      variables: {
        scenarioDescription: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        generateECG: { required: false, type: "Boolean" },
        ecgLayout: { required: false, type: "String" },
        includeDebugInfo: { required: false, type: "Boolean" },
        patientNumber: { required: false, type: "Float" }
      }
    });
    /** Executes the createShiftWrapper global action. */
    this.createShiftWrapper = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createShiftWrapper",
      operationName: "createShiftWrapper",
      operationReturnType: "CreateShiftWrapper",
      namespace: null,
      variables: {
        studentEmail: { required: false, type: "String" },
        startTime: { required: false, type: "String" },
        endTime: { required: false, type: "String" },
        shiftType: { required: false, type: "String" },
        location: { required: false, type: "String" },
        unit: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        cohort: { required: false, type: "String" }
      }
    });
    /** Executes the createVectorStoreForAgent global action. */
    this.createVectorStoreForAgent = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createVectorStoreForAgent",
      operationName: "createVectorStoreForAgent",
      operationReturnType: "CreateVectorStoreForAgent",
      namespace: null,
      variables: {
        name: { required: false, type: "String" },
        description: { required: false, type: "String" },
        fileUrls: { required: false, type: "[String!]" },
        agentType: { required: false, type: "String" }
      }
    });
    /** Executes the createVectorStoreWithFiles global action. */
    this.createVectorStoreWithFiles = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createVectorStoreWithFiles",
      operationName: "createVectorStoreWithFiles",
      operationReturnType: "CreateVectorStoreWithFiles",
      namespace: null,
      variables: {
        name: { required: false, type: "String" },
        description: { required: false, type: "String" },
        files: {
          required: false,
          type: "[CreateVectorStoreWithFilesFilesElementTypeInput!]"
        },
        textContent: { required: false, type: "String" }
      }
    });
    /** Executes the dailyShiftComplianceCheck global action. */
    this.dailyShiftComplianceCheck = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "dailyShiftComplianceCheck",
      operationName: "dailyShiftComplianceCheck",
      operationReturnType: "DailyShiftComplianceCheck",
      namespace: null,
      variables: {}
    });
    /** Executes the denyUser global action. */
    this.denyUser = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "denyUser",
      operationName: "denyUser",
      operationReturnType: "DenyUser",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        deniedReason: { required: false, type: "String" }
      }
    });
    /** Executes the detectShiftAttachmentPhi global action. */
    this.detectShiftAttachmentPhi = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "detectShiftAttachmentPhi",
      operationName: "detectShiftAttachmentPhi",
      operationReturnType: "DetectShiftAttachmentPhi",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        force: { required: false, type: "Boolean" },
        triggerSource: { required: false, type: "String" }
      }
    });
    /** Executes the detectSimilarInstitutions global action. */
    this.detectSimilarInstitutions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "detectSimilarInstitutions",
      operationName: "detectSimilarInstitutions",
      operationReturnType: "DetectSimilarInstitutions",
      namespace: null,
      variables: {}
    });
    /** Executes the diagnoseOpenAIConnection global action. */
    this.diagnoseOpenAIConnection = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "diagnoseOpenAIConnection",
      operationName: "diagnoseOpenAIConnection",
      operationReturnType: "DiagnoseOpenAIConnection",
      namespace: null,
      variables: {}
    });
    /** Executes the diagnoseScenarioGeneratorAccess global action. */
    this.diagnoseScenarioGeneratorAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "diagnoseScenarioGeneratorAccess",
      operationName: "diagnoseScenarioGeneratorAccess",
      operationReturnType: "DiagnoseScenarioGeneratorAccess",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        email: { required: false, type: "String" }
      }
    });
    /** Executes the emergencySessionFix global action. */
    this.emergencySessionFix = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "emergencySessionFix",
      operationName: "emergencySessionFix",
      operationReturnType: "EmergencySessionFix",
      namespace: null,
      variables: { dryRun: { required: false, type: "Boolean" } }
    });
    /** Executes the enableDonContextFeatures global action. */
    this.enableDonContextFeatures = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "enableDonContextFeatures",
      operationName: "enableDonContextFeatures",
      operationReturnType: "EnableDonContextFeatures",
      namespace: null,
      variables: {}
    });
    /** Executes the enableEvaluationTemplateForInstitution global action. */
    this.enableEvaluationTemplateForInstitution = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "enableEvaluationTemplateForInstitution",
      operationName: "enableEvaluationTemplateForInstitution",
      operationReturnType: "EnableEvaluationTemplateForInstitution",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        templateKey: { required: false, type: "String" },
        enabled: { required: false, type: "Boolean" }
      }
    });
    /** Executes the enableInstitutionAIProcessing global action. */
    this.enableInstitutionAIProcessing = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "enableInstitutionAIProcessing",
      operationName: "enableInstitutionAIProcessing",
      operationReturnType: "EnableInstitutionAIProcessing",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        tier: { required: false, type: "String" },
        monthlyLimit: { required: false, type: "Float" },
        notes: { required: false, type: "String" }
      }
    });
    /** Executes the enableMaiaContextFeatures global action. */
    this.enableMaiaContextFeatures = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "enableMaiaContextFeatures",
      operationName: "enableMaiaContextFeatures",
      operationReturnType: "EnableMaiaContextFeatures",
      namespace: null,
      variables: {}
    });
    /** Executes the endVoiceSession global action. */
    this.endVoiceSession = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "endVoiceSession",
      operationName: "endVoiceSession",
      operationReturnType: "EndVoiceSession",
      namespace: null,
      variables: {
        voiceSimSessionId: { required: false, type: "String" },
        reason: { required: false, type: "String" },
        completedSuccessfully: { required: false, type: "Boolean" },
        deviceFingerprint: { required: false, type: "String" }
      }
    });
    /** Executes the enqueueHitl global action. */
    this.enqueueHitl = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "enqueueHitl",
      operationName: "enqueueHitl",
      operationReturnType: "EnqueueHitl",
      namespace: null,
      variables: {
        evaluationId: { required: false, type: "String" },
        reason: { required: false, type: "String" },
        reviewerNote: { required: false, type: "String" }
      }
    });
    /** Executes the ensureDefaultEvaluationTemplates global action. */
    this.ensureDefaultEvaluationTemplates = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "ensureDefaultEvaluationTemplates",
      operationName: "ensureDefaultEvaluationTemplates",
      operationReturnType: "EnsureDefaultEvaluationTemplates",
      namespace: null,
      variables: { institution: { required: false, type: "String" } }
    });
    /** Executes the evaluateEmsRunArtifact global action. */
    this.evaluateEmsRunArtifact = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "evaluateEmsRunArtifact",
      operationName: "evaluateEmsRunArtifact",
      operationReturnType: "EvaluateEmsRunArtifact",
      namespace: null,
      variables: {
        userFileId: { required: false, type: "String" },
        sourceSystem: { required: false, type: "String" },
        useClinicalGroundTruth: { required: false, type: "Boolean" },
        agencyProfile: { required: false, type: "JSONObject" }
      }
    });
    /** Executes the evaluateEmsRunDocumentation global action. */
    this.evaluateEmsRunDocumentation = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "evaluateEmsRunDocumentation",
      operationName: "evaluateEmsRunDocumentation",
      operationReturnType: "EvaluateEmsRunDocumentation",
      namespace: null,
      variables: {
        payload: { required: false, type: "JSONObject" },
        sourceSystem: { required: false, type: "String" },
        sourceType: { required: false, type: "String" },
        useClinicalGroundTruth: { required: false, type: "Boolean" },
        agencyProfile: { required: false, type: "JSONObject" },
        persist: { required: false, type: "Boolean" },
        title: { required: false, type: "String" },
        sourceReference: { required: false, type: "String" }
      }
    });
    /** Executes the evaluateShift global action. */
    this.evaluateShift = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "evaluateShift",
      operationName: "evaluateShift",
      operationReturnType: "EvaluateShift",
      namespace: null,
      variables: {}
    });
    /** Executes the evaluateShiftA global action. */
    this.evaluateShiftA = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "evaluateShiftA",
      operationName: "evaluateShiftA",
      operationReturnType: "EvaluateShiftA",
      namespace: null,
      variables: {
        shiftId: { required: false, type: "String" },
        shiftProcessingId: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the exportAssistantsForMigration global action. */
    this.exportAssistantsForMigration = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "exportAssistantsForMigration",
      operationName: "exportAssistantsForMigration",
      operationReturnType: "ExportAssistantsForMigration",
      namespace: null,
      variables: {}
    });
    /** Executes the exportClinicalTrainingData global action. */
    this.exportClinicalTrainingData = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "exportClinicalTrainingData",
      operationName: "exportClinicalTrainingData",
      operationReturnType: "ExportClinicalTrainingData",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" },
        format: { required: false, type: "String" },
        minConfidenceScore: { required: false, type: "Float" },
        includeFeedbackCategories: { required: false, type: "[String!]" },
        maxRecords: { required: false, type: "Float" },
        includePositiveExamples: { required: false, type: "Boolean" },
        includeNegativeExamples: { required: false, type: "Boolean" }
      }
    });
    /** Executes the exportOpenAIFineTuningData global action. */
    this.exportOpenAIFineTuningData = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "exportOpenAIFineTuningData",
      operationName: "exportOpenAIFineTuningData",
      operationReturnType: "ExportOpenAIFineTuningData",
      namespace: null,
      variables: {}
    });
    /** Executes the exportQuestionBank global action. */
    this.exportQuestionBank = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "exportQuestionBank",
      operationName: "exportQuestionBank",
      operationReturnType: "ExportQuestionBank",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        format: { required: false, type: "String" },
        profileId: { required: false, type: "String" },
        category: { required: false, type: "String" },
        filename: { required: false, type: "String" },
        questions: { required: false, type: "[JSONObject!]" },
        level: { required: false, type: "String" },
        topic: { required: false, type: "String" },
        difficulty: { required: false, type: "String" },
        questionType: { required: false, type: "String" },
        status: { required: false, type: "String" },
        search: { required: false, type: "String" },
        limit: { required: false, type: "Float" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the exportScenarioToISimulate global action. */
    this.exportScenarioToISimulate = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "exportScenarioToISimulate",
      operationName: "exportScenarioToISimulate",
      operationReturnType: "ExportScenarioToISimulate",
      namespace: null,
      variables: { scenarioId: { required: false, type: "String" } }
    });
    /** Executes the exportUserScenariosToJson global action. */
    this.exportUserScenariosToJson = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "exportUserScenariosToJson",
      operationName: "exportUserScenariosToJson",
      operationReturnType: "ExportUserScenariosToJson",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        includeInactive: { required: false, type: "Boolean" }
      }
    });
    /** Executes the extractEducationalContent global action. */
    this.extractEducationalContent = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "extractEducationalContent",
      operationName: "extractEducationalContent",
      operationReturnType: "ExtractEducationalContent",
      namespace: null,
      variables: {
        agentResponse: { required: false, type: "String" },
        agentName: { required: false, type: "String" },
        conversationId: { required: false, type: "String" },
        messageId: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        cohort: { required: false, type: "String" }
      }
    });
    /** Executes the extractFormTemplate global action. */
    this.extractFormTemplate = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "extractFormTemplate",
      operationName: "extractFormTemplate",
      operationReturnType: "ExtractFormTemplate",
      namespace: null,
      variables: {
        pdfText: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        name: { required: false, type: "String" }
      }
    });
    /** Executes the extractScenarioEvents global action. */
    this.extractScenarioEvents = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "extractScenarioEvents",
      operationName: "extractScenarioEvents",
      operationReturnType: "ExtractScenarioEvents",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        transcriptText: { required: false, type: "String" }
      }
    });
    /** Executes the extractTemplateFields global action. */
    this.extractTemplateFields = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "extractTemplateFields",
      operationName: "extractTemplateFields",
      operationReturnType: "ExtractTemplateFields",
      namespace: null,
      variables: { evalSystemId: { required: false, type: "String" } }
    });
    /** Executes the extractWithTemplate global action. */
    this.extractWithTemplate = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "extractWithTemplate",
      operationName: "extractWithTemplate",
      operationReturnType: "ExtractWithTemplate",
      namespace: null,
      variables: {
        documentId: { required: false, type: "String" },
        templateId: { required: false, type: "String" }
      }
    });
    /** Executes the finalizeLiveAudioRun global action. */
    this.finalizeLiveAudioRun = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "finalizeLiveAudioRun",
      operationName: "finalizeLiveAudioRun",
      operationReturnType: "FinalizeLiveAudioRun",
      namespace: null,
      variables: {
        runId: { required: false, type: "String" },
        requesterUserId: { required: false, type: "String" }
      }
    });
    /** Executes the findLocalFilesForOpenAIVectorStore global action. */
    this.findLocalFilesForOpenAIVectorStore = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "findLocalFilesForOpenAIVectorStore",
      operationName: "findLocalFilesForOpenAIVectorStore",
      operationReturnType: "FindLocalFilesForOpenAIVectorStore",
      namespace: null,
      variables: { openaiVectorStoreId: { required: false, type: "String" } }
    });
    /** Executes the findSimilarShifts global action. */
    this.findSimilarShifts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "findSimilarShifts",
      operationName: "findSimilarShifts",
      operationReturnType: "FindSimilarShifts",
      namespace: null,
      variables: {
        query: { required: false, type: "String" },
        shiftId: { required: false, type: "String" },
        studentId: { required: false, type: "String" },
        institutionId: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        passStatus: { required: false, type: "String" },
        shiftType: { required: false, type: "String" },
        limit: { required: false, type: "Float" },
        minScore: { required: false, type: "Float" },
        searchMode: { required: false, type: "String" }
      }
    });
    /** Executes the fixCohortNullFields global action. */
    this.fixCohortNullFields = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "fixCohortNullFields",
      operationName: "fixCohortNullFields",
      operationReturnType: "FixCohortNullFields",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        institution: { required: false, type: "String" }
      }
    });
    /** Executes the generateAIDataSystem global action. */
    this.generateAIDataSystem = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateAIDataSystem",
      operationName: "generateAIDataSystem",
      operationReturnType: "GenerateAIDataSystem",
      namespace: null,
      variables: {
        userGoal: { required: false, type: "String" },
        userTechnicalLevel: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        systemName: { required: false, type: "String" },
        phase: { required: false, type: "String" },
        chunkIndex: { required: false, type: "Float" }
      }
    });
    /** Executes the generateBatchAccessCodes global action. */
    this.generateBatchAccessCodes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateBatchAccessCodes",
      operationName: "generateBatchAccessCodes",
      operationReturnType: "GenerateBatchAccessCodes",
      namespace: null,
      variables: {
        codeType: { required: false, type: "String" },
        duration: { required: false, type: "String" },
        quantity: { required: false, type: "Float" },
        maxUsesPerCode: { required: false, type: "Float" },
        description: { required: false, type: "String" },
        notes: { required: false, type: "String" },
        assistantIds: { required: false, type: "[String!]" },
        expiresAt: { required: false, type: "String" },
        prefix: { required: false, type: "String" },
        permissions: { required: false, type: "JSONObject" }
      }
    });
    /** Executes the generateClinicalReport global action. */
    this.generateClinicalReport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateClinicalReport",
      operationName: "generateClinicalReport",
      operationReturnType: "GenerateClinicalReport",
      namespace: null,
      variables: {
        documentId: { required: false, type: "String" },
        reportFormat: { required: false, type: "String" },
        includePatientData: { required: false, type: "Boolean" },
        customBranding: { required: false, type: "JSONObject" }
      }
    });
    /** Executes the generateClinicalScenario global action. */
    this.generateClinicalScenario = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateClinicalScenario",
      operationName: "generateClinicalScenario",
      operationReturnType: "GenerateClinicalScenario",
      namespace: null,
      variables: {
        trainingLevel: { required: false, type: "String" },
        difficulty: { required: false, type: "Float" },
        primaryBodySystem: { required: false, type: "String" },
        natureMechanism: { required: false, type: "String" },
        patientAge: { required: false, type: "String" },
        biologicalSex: { required: false, type: "String" },
        barriersToCare: { required: false, type: "String" },
        sceneDescription: { required: false, type: "String" },
        safetyConsideration: { required: false, type: "String" },
        chiefComplaint: { required: false, type: "String" },
        secondaryComplaint: { required: false, type: "String" },
        hpi: { required: false, type: "String" },
        pmhx: { required: false, type: "String" },
        allergies: { required: false, type: "String" },
        currentMedications: { required: false, type: "String" },
        levelOfConsciousness: { required: false, type: "String" },
        airwayStatus: { required: false, type: "String" },
        breathingStatus: { required: false, type: "String" },
        circulatoryStatus: { required: false, type: "String" },
        heent: { required: false, type: "String" },
        respiratory: { required: false, type: "String" },
        cardiovascular: { required: false, type: "String" },
        gi: { required: false, type: "String" },
        nervous: { required: false, type: "String" },
        musculoskeletal: { required: false, type: "String" },
        integumentary: { required: false, type: "String" },
        endocrine: { required: false, type: "String" },
        gu: { required: false, type: "String" },
        reproductive: { required: false, type: "String" },
        allowRecovery: { required: false, type: "Boolean" },
        include12Lead: { required: false, type: "Boolean" },
        useGroundTruthRouter: { required: false, type: "Boolean" },
        includeDefinitiveCare: { required: false, type: "Boolean" },
        useEnhanced: { required: false, type: "Boolean" },
        verbosity: { required: false, type: "String" },
        progressSessionId: { required: false, type: "String" },
        generateMedia: { required: false, type: "Boolean" },
        generatePatientImage: { required: false, type: "Boolean" },
        generateSceneVideo: { required: false, type: "Boolean" },
        generateClinicalVideos: { required: false, type: "Boolean" }
      }
    });
    /** Executes the generateDocumentReport global action. */
    this.generateDocumentReport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateDocumentReport",
      operationName: "generateDocumentReport",
      operationReturnType: "GenerateDocumentReport",
      namespace: null,
      variables: { documentProcessingId: { required: false, type: "String" } }
    });
    /** Executes the generateEmbedToken global action. */
    this.generateEmbedToken = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateEmbedToken",
      operationName: "generateEmbedToken",
      operationReturnType: "GenerateEmbedToken",
      namespace: null,
      variables: {
        userEmail: { required: false, type: "String" },
        hostDomain: { required: false, type: "String" },
        assistantId: { required: false, type: "String" },
        expirationHours: { required: false, type: "Float" },
        maxUses: { required: false, type: "Float" },
        sessionData: { required: false, type: "JSONObject" }
      }
    });
    /** Executes the generateEvalPrompt global action. */
    this.generateEvalPrompt = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateEvalPrompt",
      operationName: "generateEvalPrompt",
      operationReturnType: "GenerateEvalPrompt",
      namespace: null,
      variables: { evalSystemId: { required: false, type: "String" } }
    });
    /** Executes the generateExamItems global action. */
    this.generateExamItems = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateExamItems",
      operationName: "generateExamItems",
      operationReturnType: "GenerateExamItems",
      namespace: null,
      variables: {
        desiredCount: { required: false, type: "Float" },
        providerLevel: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        domains: { required: false, type: "[String!]" },
        topics: { required: false, type: "[String!]" },
        objectives: { required: false, type: "[JSONObject!]" },
        questionTypes: { required: false, type: "[String!]" },
        cognitiveMix: { required: false, type: "JSONObject" },
        itemTypesAllowed: { required: false, type: "[String!]" },
        difficultyTarget: { required: false, type: "String" },
        ceMode: { required: false, type: "Boolean" },
        includeBlocked: { required: false, type: "Boolean" },
        persistDraft: { required: false, type: "Boolean" },
        background: { required: false, type: "Boolean" },
        batchName: { required: false, type: "String" },
        gtkbVersion: { required: false, type: "String" },
        model: { required: false, type: "String" },
        vectorStoreIds: { required: false, type: "[String!]" },
        maxTokens: { required: false, type: "Float" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the generateExtractionTemplateFieldInstruction global action. */
    this.generateExtractionTemplateFieldInstruction = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateExtractionTemplateFieldInstruction",
      operationName: "generateExtractionTemplateFieldInstruction",
      operationReturnType: "GenerateExtractionTemplateFieldInstruction",
      namespace: null,
      variables: {
        templateId: { required: false, type: "String" },
        fieldId: { required: false, type: "String" }
      }
    });
    /** Executes the generateFisdapScenarioPrefillSnippet global action. */
    this.generateFisdapScenarioPrefillSnippet = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateFisdapScenarioPrefillSnippet",
      operationName: "generateFisdapScenarioPrefillSnippet",
      operationReturnType: "GenerateFisdapScenarioPrefillSnippet",
      namespace: null,
      variables: { scenarioId: { required: false, type: "String" } }
    });
    /** Executes the generateFormQrCodes global action. */
    this.generateFormQrCodes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateFormQrCodes",
      operationName: "generateFormQrCodes",
      operationReturnType: "GenerateFormQrCodes",
      namespace: null,
      variables: { shiftId: { required: false, type: "String" } }
    });
    /** Executes the generateHitlReviews global action. */
    this.generateHitlReviews = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateHitlReviews",
      operationName: "generateHitlReviews",
      operationReturnType: "GenerateHitlReviews",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        manualReviewReason: { required: false, type: "String" },
        forcePriority: { required: false, type: "String" }
      }
    });
    /** Executes the generateScenarioECG global action. */
    this.generateScenarioECG = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateScenarioECG",
      operationName: "generateScenarioECG",
      operationReturnType: "GenerateScenarioECG",
      namespace: null,
      variables: {}
    });
    /** Executes the generateScenarioMedia global action. */
    this.generateScenarioMedia = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateScenarioMedia",
      operationName: "generateScenarioMedia",
      operationReturnType: "GenerateScenarioMedia",
      namespace: null,
      variables: { scenarioId: { required: false, type: "String" } }
    });
    /** Executes the generateScenarioQRCodes global action. */
    this.generateScenarioQRCodes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateScenarioQRCodes",
      operationName: "generateScenarioQRCodes",
      operationReturnType: "GenerateScenarioQRCodes",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        qrTypes: { required: false, type: "[String!]" }
      }
    });
    /** Executes the generateScenarioRunLink global action. */
    this.generateScenarioRunLink = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateScenarioRunLink",
      operationName: "generateScenarioRunLink",
      operationReturnType: "GenerateScenarioRunLink",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        evaluationForm: { required: false, type: "String" },
        evaluationNotes: { required: false, type: "String" },
        expirationHours: { required: false, type: "Float" },
        allowEmailToStudent: { required: false, type: "Boolean" },
        trainingLevel: { required: false, type: "String" }
      }
    });
    /** Executes the generateScenarioShareToken global action. */
    this.generateScenarioShareToken = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateScenarioShareToken",
      operationName: "generateScenarioShareToken",
      operationReturnType: "GenerateScenarioShareToken",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        expiresInDays: { required: false, type: "Float" },
        maxUses: { required: false, type: "Float" },
        cohortId: { required: false, type: "String" }
      }
    });
    /** Executes the generateShiftPDF global action. */
    this.generateShiftPDF = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateShiftPDF",
      operationName: "generateShiftPDF",
      operationReturnType: "GenerateShiftPDF",
      namespace: null,
      variables: {
        shiftId: { required: false, type: "String" },
        numberOfForms: { required: false, type: "Float" }
      }
    });
    /** Executes the generateShiftUnlockToken global action. */
    this.generateShiftUnlockToken = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateShiftUnlockToken",
      operationName: "generateShiftUnlockToken",
      operationReturnType: "GenerateShiftUnlockToken",
      namespace: null,
      variables: {
        shiftId: { required: false, type: "String" },
        fisdapShiftId: { required: false, type: "String" },
        instructorEmail: { required: false, type: "String" },
        instructorName: { required: false, type: "String" },
        studentName: { required: false, type: "String" }
      }
    });
    /** Executes the generateStandaloneECG global action. */
    this.generateStandaloneECG = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateStandaloneECG",
      operationName: "generateStandaloneECG",
      operationReturnType: "GenerateStandaloneECG",
      namespace: null,
      variables: {
        heartRate: { required: false, type: "Float" },
        rhythm: { required: false, type: "String" },
        layout: { required: false, type: "String" },
        patientAge: { required: false, type: "Float" },
        patientSex: { required: false, type: "String" },
        abnormalities: { required: false, type: "[String!]" },
        outputFileName: { required: false, type: "String" }
      }
    });
    /** Executes the generateStudentFeedbackHistory global action. */
    this.generateStudentFeedbackHistory = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateStudentFeedbackHistory",
      operationName: "generateStudentFeedbackHistory",
      operationReturnType: "GenerateStudentFeedbackHistory",
      namespace: null,
      variables: {
        recordType: { required: false, type: "String" },
        recordId: { required: false, type: "String" },
        studentId: { required: false, type: "String" }
      }
    });
    /** Executes the generateStudyMaterials global action. */
    this.generateStudyMaterials = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateStudyMaterials",
      operationName: "generateStudyMaterials",
      operationReturnType: "GenerateStudyMaterials",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        contentTypes: { required: false, type: "[String!]" },
        subjects: { required: false, type: "[String!]" },
        difficulty: { required: false, type: "String" },
        count: { required: false, type: "Float" },
        format: { required: false, type: "String" },
        includeAnswers: { required: false, type: "Boolean" }
      }
    });
    /** Executes the generateTempPassword global action. */
    this.generateTempPassword = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateTempPassword",
      operationName: "generateTempPassword",
      operationReturnType: "GenerateTempPassword",
      namespace: null,
      variables: {
        lengthMin: { required: false, type: "Float" },
        lengthMax: { required: false, type: "Float" }
      }
    });
    /** Executes the generateThreadSummary global action. */
    this.generateThreadSummary = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateThreadSummary",
      operationName: "generateThreadSummary",
      operationReturnType: "GenerateThreadSummary",
      namespace: null,
      variables: { threadId: { required: false, type: "String" } }
    });
    /** Executes the generateTrainingDataFromReview global action. */
    this.generateTrainingDataFromReview = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateTrainingDataFromReview",
      operationName: "generateTrainingDataFromReview",
      operationReturnType: "GenerateTrainingDataFromReview",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        batchId: { required: false, type: "String" },
        modelVersion: { required: false, type: "String" }
      }
    });
    /** Executes the getAgentConfigurations global action. */
    this.getAgentConfigurations = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getAgentConfigurations",
      operationName: "getAgentConfigurations",
      operationReturnType: "GetAgentConfigurations",
      namespace: null,
      variables: {}
    });
    /** Executes the getAgentConversationHistory global action. */
    this.getAgentConversationHistory = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getAgentConversationHistory",
      operationName: "getAgentConversationHistory",
      operationReturnType: "GetAgentConversationHistory",
      namespace: null,
      variables: {
        agentType: { required: false, type: "String" },
        limit: { required: false, type: "Float" },
        localSessionId: { required: false, type: "String" },
        includeMessages: { required: false, type: "Boolean" }
      }
    });
    /** Executes the getAgentConversationMessagesV2 global action. */
    this.getAgentConversationMessagesV2 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getAgentConversationMessagesV2",
      operationName: "getAgentConversationMessagesV2",
      operationReturnType: "GetAgentConversationMessagesV2",
      namespace: null,
      variables: {
        localSessionId: { required: false, type: "String" },
        agentType: { required: false, type: "String" }
      }
    });
    /** Executes the getAvailableEvaluationTemplates global action. */
    this.getAvailableEvaluationTemplates = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getAvailableEvaluationTemplates",
      operationName: "getAvailableEvaluationTemplates",
      operationReturnType: "GetAvailableEvaluationTemplates",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        trainingLevel: { required: false, type: "String" }
      }
    });
    /** Executes the getAvailablePreceptors global action. */
    this.getAvailablePreceptors = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getAvailablePreceptors",
      operationName: "getAvailablePreceptors",
      operationReturnType: "GetAvailablePreceptors",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        agencyId: { required: false, type: "String" },
        includeInactive: { required: false, type: "Boolean" }
      }
    });
    /** Executes the getAvailableSDKAgents global action. */
    this.getAvailableSDKAgents = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getAvailableSDKAgents",
      operationName: "getAvailableSDKAgents",
      operationReturnType: "GetAvailableSDKAgents",
      namespace: null,
      variables: {}
    });
    /** Executes the getCohortManagementData global action. */
    this.getCohortManagementData = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getCohortManagementData",
      operationName: "getCohortManagementData",
      operationReturnType: "GetCohortManagementData",
      namespace: null,
      variables: { cohortId: { required: false, type: "String" } }
    });
    /** Executes the getCurrentUserAccessProfile global action. */
    this.getCurrentUserAccessProfile = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getCurrentUserAccessProfile",
      operationName: "getCurrentUserAccessProfile",
      operationReturnType: "GetCurrentUserAccessProfile",
      namespace: null,
      variables: { userId: { required: false, type: "String" } }
    });
    /** Executes the getEmsRunEvaluation global action. */
    this.getEmsRunEvaluation = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getEmsRunEvaluation",
      operationName: "getEmsRunEvaluation",
      operationReturnType: "GetEmsRunEvaluation",
      namespace: null,
      variables: { evaluationId: { required: false, type: "String" } }
    });
    /** Executes the getFisdapShiftsForReview global action. */
    this.getFisdapShiftsForReview = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getFisdapShiftsForReview",
      operationName: "getFisdapShiftsForReview",
      operationReturnType: "GetFisdapShiftsForReview",
      namespace: null,
      variables: {
        cohortId: { required: false, type: "String" },
        studentId: { required: false, type: "String" },
        dateFrom: { required: false, type: "String" },
        dateTo: { required: false, type: "String" },
        search: { required: false, type: "String" }
      }
    });
    /** Executes the getHitlQueue global action. */
    this.getHitlQueue = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getHitlQueue",
      operationName: "getHitlQueue",
      operationReturnType: "GetHitlQueue",
      namespace: null,
      variables: {
        priority: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" },
        limit: { required: false, type: "Float" }
      }
    });
    /** Executes the getHitlReviewData global action. */
    this.getHitlReviewData = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getHitlReviewData",
      operationName: "getHitlReviewData",
      operationReturnType: "GetHitlReviewData",
      namespace: null,
      variables: {
        page: { required: false, type: "Float" },
        limit: { required: false, type: "Float" },
        search: { required: false, type: "String" },
        status: { required: false, type: "String" },
        verdict: { required: false, type: "String" }
      }
    });
    /** Executes the getInstitutionAIProcessingStatus global action. */
    this.getInstitutionAIProcessingStatus = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getInstitutionAIProcessingStatus",
      operationName: "getInstitutionAIProcessingStatus",
      operationReturnType: "GetInstitutionAIProcessingStatus",
      namespace: null,
      variables: { institution: { required: false, type: "String" } }
    });
    /** Executes the getInstitutionAnalytics global action. */
    this.getInstitutionAnalytics = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getInstitutionAnalytics",
      operationName: "getInstitutionAnalytics",
      operationReturnType: "GetInstitutionAnalytics",
      namespace: null,
      variables: {
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" },
        activityStatus: { required: false, type: "String" }
      }
    });
    /** Executes the getInstitutionMergePreview global action. */
    this.getInstitutionMergePreview = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getInstitutionMergePreview",
      operationName: "getInstitutionMergePreview",
      operationReturnType: "GetInstitutionMergePreview",
      namespace: null,
      variables: {
        sourceInstitution: { required: false, type: "String" },
        targetInstitution: { required: false, type: "String" }
      }
    });
    /** Executes the getInstitutionOptions global action. */
    this.getInstitutionOptions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getInstitutionOptions",
      operationName: "getInstitutionOptions",
      operationReturnType: "GetInstitutionOptions",
      namespace: null,
      variables: {}
    });
    /** Executes the getInstitutionUsers global action. */
    this.getInstitutionUsers = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getInstitutionUsers",
      operationName: "getInstitutionUsers",
      operationReturnType: "GetInstitutionUsers",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        cohort: { required: false, type: "String" },
        role: { required: false, type: "String" },
        approvalStatus: { required: false, type: "String" },
        activeOnly: { required: false, type: "Boolean" },
        pendingApprovalOnly: { required: false, type: "Boolean" },
        first: { required: false, type: "Float" },
        after: { required: false, type: "String" }
      }
    });
    /** Executes the getInstitutionalConfig global action. */
    this.getInstitutionalConfig = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getInstitutionalConfig",
      operationName: "getInstitutionalConfig",
      operationReturnType: "GetInstitutionalConfig",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the getInstructorRollingShareCode global action. */
    this.getInstructorRollingShareCode = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getInstructorRollingShareCode",
      operationName: "getInstructorRollingShareCode",
      operationReturnType: "GetInstructorRollingShareCode",
      namespace: null,
      variables: {
        shareToken: { required: false, type: "String" },
        generate: { required: false, type: "Boolean" }
      }
    });
    /** Executes the getLiveAudioRunStatus global action. */
    this.getLiveAudioRunStatus = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getLiveAudioRunStatus",
      operationName: "getLiveAudioRunStatus",
      operationReturnType: "GetLiveAudioRunStatus",
      namespace: null,
      variables: {
        runId: { required: false, type: "String" },
        requesterUserId: { required: false, type: "String" }
      }
    });
    /** Executes the getOpenAIAssistantInstructions global action. */
    this.getOpenAIAssistantInstructions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getOpenAIAssistantInstructions",
      operationName: "getOpenAIAssistantInstructions",
      operationReturnType: "GetOpenAIAssistantInstructions",
      namespace: null,
      variables: { assistantId: { required: false, type: "String" } }
    });
    /** Executes the getQaChart global action. */
    this.getQaChart = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getQaChart",
      operationName: "getQaChart",
      operationReturnType: "GetQaChart",
      namespace: null,
      variables: {
        chartId: { required: false, type: "String" },
        scope: { required: false, type: "String" }
      }
    });
    /** Executes the getQuestionAdaptiveFeedbackQueue global action. */
    this.getQuestionAdaptiveFeedbackQueue = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getQuestionAdaptiveFeedbackQueue",
      operationName: "getQuestionAdaptiveFeedbackQueue",
      operationReturnType: "GetQuestionAdaptiveFeedbackQueue",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        limit: { required: false, type: "Float" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the getQuestionBank global action. */
    this.getQuestionBank = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getQuestionBank",
      operationName: "getQuestionBank",
      operationReturnType: "GetQuestionBank",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        category: { required: false, type: "String" },
        includePublic: { required: false, type: "Boolean" },
        level: { required: false, type: "String" },
        topic: { required: false, type: "String" },
        difficulty: { required: false, type: "String" },
        questionType: { required: false, type: "String" },
        status: { required: false, type: "String" },
        search: { required: false, type: "String" },
        limit: { required: false, type: "Float" },
        publicLimit: { required: false, type: "Float" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the getQuestionBankExportProfiles global action. */
    this.getQuestionBankExportProfiles = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getQuestionBankExportProfiles",
      operationName: "getQuestionBankExportProfiles",
      operationReturnType: "GetQuestionBankExportProfiles",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the getQuestionBankInstitutions global action. */
    this.getQuestionBankInstitutions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getQuestionBankInstitutions",
      operationName: "getQuestionBankInstitutions",
      operationReturnType: "GetQuestionBankInstitutions",
      namespace: null,
      variables: { userId: { required: false, type: "String" } }
    });
    /** Executes the getQuickChartEvaluation global action. */
    this.getQuickChartEvaluation = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getQuickChartEvaluation",
      operationName: "getQuickChartEvaluation",
      operationReturnType: "GetQuickChartEvaluation",
      namespace: null,
      variables: { evaluationId: { required: false, type: "String" } }
    });
    /** Executes the getStudentEvaluations global action. */
    this.getStudentEvaluations = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getStudentEvaluations",
      operationName: "getStudentEvaluations",
      operationReturnType: "GetStudentEvaluations",
      namespace: null,
      variables: {
        studentId: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        evaluationType: { required: false, type: "String" },
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" },
        includeRelatedData: { required: false, type: "Boolean" }
      }
    });
    /** Executes the getStudentFeedbackPatterns global action. */
    this.getStudentFeedbackPatterns = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getStudentFeedbackPatterns",
      operationName: "getStudentFeedbackPatterns",
      operationReturnType: "GetStudentFeedbackPatterns",
      namespace: null,
      variables: {
        studentId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        category: { required: false, type: "String" }
      }
    });
    /** Executes the getTrainingDataStatus global action. */
    this.getTrainingDataStatus = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getTrainingDataStatus",
      operationName: "getTrainingDataStatus",
      operationReturnType: "GetTrainingDataStatus",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        dateRange: { required: false, type: "GetTrainingDataStatusDateRangeInput" }
      }
    });
    /** Executes the getTrainingJob global action. */
    this.getTrainingJob = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getTrainingJob",
      operationName: "getTrainingJob",
      operationReturnType: "GetTrainingJob",
      namespace: null,
      variables: { jobId: { required: false, type: "String" } }
    });
    /** Executes the getUserContextForAgent global action. */
    this.getUserContextForAgent = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getUserContextForAgent",
      operationName: "getUserContextForAgent",
      operationReturnType: "GetUserContextForAgent",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        agentType: { required: false, type: "String" },
        maxRecentChats: { required: false, type: "Float" }
      }
    });
    /** Executes the getUserConversationHistory global action. */
    this.getUserConversationHistory = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getUserConversationHistory",
      operationName: "getUserConversationHistory",
      operationReturnType: "GetUserConversationHistory",
      namespace: null,
      variables: {
        agentType: { required: false, type: "String" },
        limit: { required: false, type: "Float" }
      }
    });
    /** Executes the getUserInfoGlobal global action. */
    this.getUserInfoGlobal = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getUserInfoGlobal",
      operationName: "getUserInfoGlobal",
      operationReturnType: "GetUserInfoGlobal",
      namespace: null,
      variables: {
        email: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        firstName: { required: false, type: "String" },
        lastName: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        cohort: { required: false, type: "String" }
      }
    });
    /** Executes the getUserVectorStores global action. */
    this.getUserVectorStores = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getUserVectorStores",
      operationName: "getUserVectorStores",
      operationReturnType: "GetUserVectorStores",
      namespace: null,
      variables: {}
    });
    /** Executes the getVectorStoreInfo global action. */
    this.getVectorStoreInfo = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getVectorStoreInfo",
      operationName: "getVectorStoreInfo",
      operationReturnType: "GetVectorStoreInfo",
      namespace: null,
      variables: { vectorStoreId: { required: false, type: "String" } }
    });
    /** Executes the getWatermarkConfig global action. */
    this.getWatermarkConfig = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getWatermarkConfig",
      operationName: "getWatermarkConfig",
      operationReturnType: "GetWatermarkConfig",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the giveUserAllAssistantAccess global action. */
    this.giveUserAllAssistantAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "giveUserAllAssistantAccess",
      operationName: "giveUserAllAssistantAccess",
      operationReturnType: "GiveUserAllAssistantAccess",
      namespace: null,
      variables: {}
    });
    /** Executes the globalCreateAssistant global action. */
    this.globalCreateAssistant = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "globalCreateAssistant",
      operationName: "globalCreateAssistant",
      operationReturnType: "GlobalCreateAssistant",
      namespace: null,
      variables: {
        assistantName: { required: false, type: "String" },
        assistantInstructions: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        assistantHasCodeInterpreter: { required: false, type: "Boolean" },
        assistantHasRetrieval: { required: false, type: "Boolean" }
      }
    });
    /** Executes the globalCreateMessage global action. */
    this.globalCreateMessage = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "globalCreateMessage",
      operationName: "globalCreateMessage",
      operationReturnType: "GlobalCreateMessage",
      namespace: null,
      variables: {
        threadId: { required: false, type: "String" },
        userQuestion: { required: false, type: "String" },
        assistantId: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the globalCreateThread global action. */
    this.globalCreateThread = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "globalCreateThread",
      operationName: "globalCreateThread",
      operationReturnType: "GlobalCreateThread",
      namespace: null,
      variables: {
        inputAssistantId: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the grantAgentAccess global action. */
    this.grantAgentAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "grantAgentAccess",
      operationName: "grantAgentAccess",
      operationReturnType: "GrantAgentAccess",
      namespace: null,
      variables: {
        userEmail: { required: false, type: "String" },
        agentTypes: { required: false, type: "[String!]" },
        accessType: { required: false, type: "String" },
        notes: { required: false, type: "String" }
      }
    });
    /** Executes the grantAssistantAccess global action. */
    this.grantAssistantAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "grantAssistantAccess",
      operationName: "grantAssistantAccess",
      operationReturnType: "GrantAssistantAccess",
      namespace: null,
      variables: {
        assistantId: { required: false, type: "String" },
        accessType: { required: false, type: "String" },
        accessValue: { required: false, type: "String" },
        notes: { required: false, type: "String" }
      }
    });
    /** Executes the grantPublicScenarioAccess global action. */
    this.grantPublicScenarioAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "grantPublicScenarioAccess",
      operationName: "grantPublicScenarioAccess",
      operationReturnType: "GrantPublicScenarioAccess",
      namespace: null,
      variables: {
        accessType: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        notes: { required: false, type: "String" }
      }
    });
    /** Executes the grantUserAgentAccess global action. */
    this.grantUserAgentAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "grantUserAgentAccess",
      operationName: "grantUserAgentAccess",
      operationReturnType: "GrantUserAgentAccess",
      namespace: null,
      variables: {
        userEmail: { required: false, type: "String" },
        agentNames: { required: false, type: "[String!]" },
        mode: { required: false, type: "String" }
      }
    });
    /** Executes the handleMultipleCohorts global action. */
    this.handleMultipleCohorts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "handleMultipleCohorts",
      operationName: "handleMultipleCohorts",
      operationReturnType: "HandleMultipleCohorts",
      namespace: null,
      variables: {
        mode: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        keepMostRecent: { required: false, type: "Boolean" }
      }
    });
    /** Executes the impersonateUser global action. */
    this.impersonateUser = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "impersonateUser",
      operationName: "impersonateUser",
      operationReturnType: "ImpersonateUser",
      namespace: null,
      variables: {
        targetUserId: { required: false, type: "String" },
        targetUserEmail: { required: false, type: "String" }
      }
    });
    /** Executes the importExistingAssistants global action. */
    this.importExistingAssistants = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "importExistingAssistants",
      operationName: "importExistingAssistants",
      operationReturnType: "ImportExistingAssistants",
      namespace: null,
      variables: { userId: { required: false, type: "String" } }
    });
    /** Executes the importFisdapShift global action. */
    this.importFisdapShift = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "importFisdapShift",
      operationName: "importFisdapShift",
      operationReturnType: "ImportFisdapShift",
      namespace: null,
      variables: {
        shiftId: { required: false, type: "String" },
        fisdapUsername: { required: false, type: "String" },
        fisdapPassword: { required: false, type: "String" },
        forceReauth: { required: false, type: "Boolean" }
      }
    });
    /** Executes the importOpenAIVectorStoreFiles global action. */
    this.importOpenAIVectorStoreFiles = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "importOpenAIVectorStoreFiles",
      operationName: "importOpenAIVectorStoreFiles",
      operationReturnType: "ImportOpenAIVectorStoreFiles",
      namespace: null,
      variables: {
        openaiVectorStoreId: { required: false, type: "String" },
        ownerUserId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        attachToVectorStoreId: { required: false, type: "String" }
      }
    });
    /** Executes the importScenarioFromJson global action. */
    this.importScenarioFromJson = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "importScenarioFromJson",
      operationName: "importScenarioFromJson",
      operationReturnType: "ImportScenarioFromJson",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        title: { required: false, type: "String" },
        makePublic: { required: false, type: "Boolean" },
        difficulty: { required: false, type: "Float" },
        trainingLevel: { required: false, type: "String" }
      }
    });
    /** Executes the importUserScenariosFromJson global action. */
    this.importUserScenariosFromJson = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "importUserScenariosFromJson",
      operationName: "importUserScenariosFromJson",
      operationReturnType: "ImportUserScenariosFromJson",
      namespace: null,
      variables: {
        targetUserId: { required: false, type: "String" },
        scenariosJson: { required: false, type: "[JSONObject!]" },
        overwriteExisting: { required: false, type: "Boolean" },
        makeAllPublic: { required: false, type: "Boolean" },
        makeAllActive: { required: false, type: "Boolean" }
      }
    });
    /** Executes the indexShiftEvaluation global action. */
    this.indexShiftEvaluation = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "indexShiftEvaluation",
      operationName: "indexShiftEvaluation",
      operationReturnType: "IndexShiftEvaluation",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        evaluationResult: { required: false, type: "JSONObject" },
        forceReindex: { required: false, type: "Boolean" }
      }
    });
    /** Executes the ingestQaChartArtifact global action. */
    this.ingestQaChartArtifact = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "ingestQaChartArtifact",
      operationName: "ingestQaChartArtifact",
      operationReturnType: "IngestQaChartArtifact",
      namespace: null,
      variables: {
        workflowId: { required: false, type: "String" },
        base64: { required: false, type: "String" },
        fileName: { required: false, type: "String" },
        mimeType: { required: false, type: "String" },
        redactionMode: { required: false, type: "String" },
        submitterEmail: { required: false, type: "String" },
        sourceReference: { required: false, type: "String" },
        sourceSystem: { required: false, type: "String" },
        processImmediately: { required: false, type: "Boolean" },
        templateId: { required: false, type: "String" }
      }
    });
    /** Executes the ingestQaChartStructuredPayload global action. */
    this.ingestQaChartStructuredPayload = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "ingestQaChartStructuredPayload",
      operationName: "ingestQaChartStructuredPayload",
      operationReturnType: "IngestQaChartStructuredPayload",
      namespace: null,
      variables: {
        workflowId: { required: false, type: "String" },
        payload: { required: false, type: "JSONObject" },
        title: { required: false, type: "String" },
        submitterEmail: { required: false, type: "String" },
        sourceReference: { required: false, type: "String" },
        sourceSystem: { required: false, type: "String" }
      }
    });
    /** Executes the ingestQaChartText global action. */
    this.ingestQaChartText = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "ingestQaChartText",
      operationName: "ingestQaChartText",
      operationReturnType: "IngestQaChartText",
      namespace: null,
      variables: {
        workflowId: { required: false, type: "String" },
        text: { required: false, type: "String" },
        title: { required: false, type: "String" },
        submitterEmail: { required: false, type: "String" },
        sourceReference: { required: false, type: "String" },
        sourceSystem: { required: false, type: "String" }
      }
    });
    /** Executes the initializeEmptyStaffAssignments global action. */
    this.initializeEmptyStaffAssignments = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "initializeEmptyStaffAssignments",
      operationName: "initializeEmptyStaffAssignments",
      operationReturnType: "InitializeEmptyStaffAssignments",
      namespace: null,
      variables: {}
    });
    /** Executes the initializeSeekDBCollections global action. */
    this.initializeSeekDBCollections = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "initializeSeekDBCollections",
      operationName: "initializeSeekDBCollections",
      operationReturnType: "InitializeSeekDBCollections",
      namespace: null,
      variables: {
        forceRecreate: { required: false, type: "Boolean" },
        collectionsToCreate: { required: false, type: "[String!]" },
        dryRun: { required: false, type: "Boolean" },
        verifyFunctionality: { required: false, type: "Boolean" }
      }
    });
    /** Executes the initializeSimulationState global action. */
    this.initializeSimulationState = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "initializeSimulationState",
      operationName: "initializeSimulationState",
      operationReturnType: "InitializeSimulationState",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the initializeStreamlinedAdminAssistant global action. */
    this.initializeStreamlinedAdminAssistant = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "initializeStreamlinedAdminAssistant",
      operationName: "initializeStreamlinedAdminAssistant",
      operationReturnType: "InitializeStreamlinedAdminAssistant",
      namespace: null,
      variables: {}
    });
    /** Executes the initializeThreadWithGreeting global action. */
    this.initializeThreadWithGreeting = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "initializeThreadWithGreeting",
      operationName: "initializeThreadWithGreeting",
      operationReturnType: "InitializeThreadWithGreeting",
      namespace: null,
      variables: {
        assistantId: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the initializeVoiceAgent global action. */
    this.initializeVoiceAgent = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "initializeVoiceAgent",
      operationName: "initializeVoiceAgent",
      operationReturnType: "InitializeVoiceAgent",
      namespace: null,
      variables: {
        institutionId: { required: false, type: "String" },
        agentName: { required: false, type: "String" },
        knowledgeBaseIds: { required: false, type: "[String!]" },
        enableHotword: { required: false, type: "Boolean" },
        maxSessionLength: { required: false, type: "Float" },
        phiSanitization: { required: false, type: "Boolean" },
        auditLogging: { required: false, type: "Boolean" }
      }
    });
    /** Executes the issueLiveAudioJoinToken global action. */
    this.issueLiveAudioJoinToken = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "issueLiveAudioJoinToken",
      operationName: "issueLiveAudioJoinToken",
      operationReturnType: "IssueLiveAudioJoinToken",
      namespace: null,
      variables: {
        runId: { required: false, type: "String" },
        sourceLabel: { required: false, type: "String" },
        participantRole: { required: false, type: "String" },
        expiresInMinutes: { required: false, type: "Float" },
        requesterUserId: { required: false, type: "String" }
      }
    });
    /** Executes the linkOrphanedShiftsToUsers global action. */
    this.linkOrphanedShiftsToUsers = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "linkOrphanedShiftsToUsers",
      operationName: "linkOrphanedShiftsToUsers",
      operationReturnType: "LinkOrphanedShiftsToUsers",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        cohortId: { required: false, type: "String" },
        limit: { required: false, type: "Float" }
      }
    });
    /** Executes the linkRecoveredShiftsToUsers global action. */
    this.linkRecoveredShiftsToUsers = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "linkRecoveredShiftsToUsers",
      operationName: "linkRecoveredShiftsToUsers",
      operationReturnType: "LinkRecoveredShiftsToUsers",
      namespace: null,
      variables: {
        batchSize: { required: false, type: "Float" },
        dryRun: { required: false, type: "Boolean" }
      }
    });
    /** Executes the listActiveWebhookSubscriptions global action. */
    this.listActiveWebhookSubscriptions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "listActiveWebhookSubscriptions",
      operationName: "listActiveWebhookSubscriptions",
      operationReturnType: "ListActiveWebhookSubscriptions",
      namespace: null,
      variables: {}
    });
    /** Executes the listAvailableInstitutions global action. */
    this.listAvailableInstitutions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "listAvailableInstitutions",
      operationName: "listAvailableInstitutions",
      operationReturnType: "ListAvailableInstitutions",
      namespace: null,
      variables: {}
    });
    /** Executes the listEmsRunEvaluations global action. */
    this.listEmsRunEvaluations = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "listEmsRunEvaluations",
      operationName: "listEmsRunEvaluations",
      operationReturnType: "ListEmsRunEvaluations",
      namespace: null,
      variables: {
        sourceType: { required: false, type: "String" },
        sourceSystem: { required: false, type: "String" },
        status: { required: false, type: "String" },
        first: { required: false, type: "Float" }
      }
    });
    /** Executes the listOpenAIAgents global action. */
    this.listOpenAIAgents = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "listOpenAIAgents",
      operationName: "listOpenAIAgents",
      operationReturnType: "ListOpenAIAgents",
      namespace: null,
      variables: {}
    });
    /** Executes the listQaCharts global action. */
    this.listQaCharts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "listQaCharts",
      operationName: "listQaCharts",
      operationReturnType: "ListQaCharts",
      namespace: null,
      variables: {
        workflowId: { required: false, type: "String" },
        scope: { required: false, type: "String" }
      }
    });
    /** Executes the listQuickChartEvaluations global action. */
    this.listQuickChartEvaluations = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "listQuickChartEvaluations",
      operationName: "listQuickChartEvaluations",
      operationReturnType: "ListQuickChartEvaluations",
      namespace: null,
      variables: {
        sourceType: { required: false, type: "String" },
        status: { required: false, type: "String" },
        overallStatus: { required: false, type: "String" },
        first: { required: false, type: "Float" }
      }
    });
    /** Executes the listVMAgents global action. */
    this.listVMAgents = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "listVMAgents",
      operationName: "listVMAgents",
      operationReturnType: "ListVMAgents",
      namespace: null,
      variables: {}
    });
    /** Executes the logScreenshotAttempt global action. */
    this.logScreenshotAttempt = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "logScreenshotAttempt",
      operationName: "logScreenshotAttempt",
      operationReturnType: "LogScreenshotAttempt",
      namespace: null,
      variables: {
        shareToken: { required: false, type: "String" },
        attemptType: { required: false, type: "String" },
        userAgent: { required: false, type: "String" },
        timestamp: { required: false, type: "String" }
      }
    });
    /** Executes the manageFisdapCredentials global action. */
    this.manageFisdapCredentials = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "manageFisdapCredentials",
      operationName: "manageFisdapCredentials",
      operationReturnType: "ManageFisdapCredentials",
      namespace: null,
      variables: {
        operation: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        username: { required: false, type: "String" },
        password: { required: false, type: "String" },
        sessionId: { required: false, type: "String" }
      }
    });
    /** Executes the manageVoiceSimInvitation global action. */
    this.manageVoiceSimInvitation = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "manageVoiceSimInvitation",
      operationName: "manageVoiceSimInvitation",
      operationReturnType: "ManageVoiceSimInvitation",
      namespace: null,
      variables: {
        voiceSimSessionId: { required: false, type: "String" },
        expiresAt: { required: false, type: "String" },
        remainingAttempts: { required: false, type: "Float" },
        resendEmail: { required: false, type: "Boolean" }
      }
    });
    /** Executes the manualEmailCheck global action. */
    this.manualEmailCheck = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "manualEmailCheck",
      operationName: "manualEmailCheck",
      operationReturnType: "ManualEmailCheck",
      namespace: null,
      variables: {
        timeRange: { required: false, type: "Float" },
        emailAddress: { required: false, type: "String" },
        maxEmails: { required: false, type: "Float" },
        testWebhook: { required: false, type: "Boolean" }
      }
    });
    /** Executes the manuallyRenewWebhookSubscription global action. */
    this.manuallyRenewWebhookSubscription = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "manuallyRenewWebhookSubscription",
      operationName: "manuallyRenewWebhookSubscription",
      operationReturnType: "ManuallyRenewWebhookSubscription",
      namespace: null,
      variables: { subscriptionId: { required: false, type: "String" } }
    });
    /** Executes the manuallyTriggerNotification global action. */
    this.manuallyTriggerNotification = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "manuallyTriggerNotification",
      operationName: "manuallyTriggerNotification",
      operationReturnType: "ManuallyTriggerNotification",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        forceNotification: { required: false, type: "Boolean" },
        additionalRecipients: { required: false, type: "[String!]" }
      }
    });
    /** Executes the mergeInstitutions global action. */
    this.mergeInstitutions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "mergeInstitutions",
      operationName: "mergeInstitutions",
      operationReturnType: "MergeInstitutions",
      namespace: null,
      variables: {
        sourceInstitution: { required: false, type: "String" },
        targetInstitution: { required: false, type: "String" },
        mergedConfig: { required: false, type: "JSONObject" },
        updateAllUsers: { required: false, type: "Boolean" }
      }
    });
    /** Executes the monitorCohortMembershipHealth global action. */
    this.monitorCohortMembershipHealth = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "monitorCohortMembershipHealth",
      operationName: "monitorCohortMembershipHealth",
      operationReturnType: "MonitorCohortMembershipHealth",
      namespace: null,
      variables: {}
    });
    /** Executes the monitorFineTuningJobs global action. */
    this.monitorFineTuningJobs = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "monitorFineTuningJobs",
      operationName: "monitorFineTuningJobs",
      operationReturnType: "MonitorFineTuningJobs",
      namespace: null,
      variables: {}
    });
    /** Executes the normalizeAccessFieldMirrors global action. */
    this.normalizeAccessFieldMirrors = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "normalizeAccessFieldMirrors",
      operationName: "normalizeAccessFieldMirrors",
      operationReturnType: "NormalizeAccessFieldMirrors",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        institution: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        actingUserId: { required: false, type: "String" },
        actorUserId: { required: false, type: "String" },
        currentUserId: { required: false, type: "String" }
      }
    });
    /** Executes the nukeAllFileData global action. */
    this.nukeAllFileData = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "nukeAllFileData",
      operationName: "nukeAllFileData",
      operationReturnType: "NukeAllFileData",
      namespace: null,
      variables: { confirmation: { required: false, type: "String" } }
    });
    /** Executes the pollBackgroundResponse global action. */
    this.pollBackgroundResponse = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "pollBackgroundResponse",
      operationName: "pollBackgroundResponse",
      operationReturnType: "PollBackgroundResponse",
      namespace: null,
      variables: {
        responseId: { required: false, type: "String" },
        agentName: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        conversationId: { required: false, type: "String" },
        userMessage: { required: false, type: "String" },
        agentConfigId: { required: false, type: "String" }
      }
    });
    /** Executes the pollBackgroundTask global action. */
    this.pollBackgroundTask = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "pollBackgroundTask",
      operationName: "pollBackgroundTask",
      operationReturnType: "PollBackgroundTask",
      namespace: null,
      variables: {
        response_id: { required: false, type: "String" },
        task_id: { required: false, type: "String" },
        user_id: { required: false, type: "String" },
        max_polls: { required: false, type: "Float" },
        poll_interval: { required: false, type: "Float" }
      }
    });
    /** Executes the pollExamItemGeneration global action. */
    this.pollExamItemGeneration = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "pollExamItemGeneration",
      operationName: "pollExamItemGeneration",
      operationReturnType: "PollExamItemGeneration",
      namespace: null,
      variables: {
        jobId: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the pollMaiaPracticeGeneration global action. */
    this.pollMaiaPracticeGeneration = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "pollMaiaPracticeGeneration",
      operationName: "pollMaiaPracticeGeneration",
      operationReturnType: "PollMaiaPracticeGeneration",
      namespace: null,
      variables: { jobId: { required: false, type: "String" } }
    });
    /** Executes the pollResponseTask global action. */
    this.pollResponseTask = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "pollResponseTask",
      operationName: "pollResponseTask",
      operationReturnType: "PollResponseTask",
      namespace: null,
      variables: {
        responseId: { required: false, type: "String" },
        conversationId: { required: false, type: "String" },
        maxPollingTime: { required: false, type: "Float" }
      }
    });
    /** Executes the pollVMAgentResponse global action. */
    this.pollVMAgentResponse = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "pollVMAgentResponse",
      operationName: "pollVMAgentResponse",
      operationReturnType: "PollVMAgentResponse",
      namespace: null,
      variables: { taskId: { required: false, type: "String" } }
    });
    /** Executes the populateCohortMembershipEmails global action. */
    this.populateCohortMembershipEmails = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "populateCohortMembershipEmails",
      operationName: "populateCohortMembershipEmails",
      operationReturnType: "PopulateCohortMembershipEmails",
      namespace: null,
      variables: { dryRun: { required: false, type: "Boolean" } }
    });
    /** Executes the processDebriefAudio global action. */
    this.processDebriefAudio = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processDebriefAudio",
      operationName: "processDebriefAudio",
      operationReturnType: "ProcessDebriefAudio",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        audioFileKey: { required: false, type: "String" }
      }
    });
    /** Executes the processDocument global action. */
    this.processDocument = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processDocument",
      operationName: "processDocument",
      operationReturnType: "ProcessDocument",
      namespace: null,
      variables: {
        documentProcessingId: { required: false, type: "String" },
        fileId: { required: false, type: "String" }
      }
    });
    /** Executes the processDocumentAuditResults global action. */
    this.processDocumentAuditResults = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processDocumentAuditResults",
      operationName: "processDocumentAuditResults",
      operationReturnType: "ProcessDocumentAuditResults",
      namespace: null,
      variables: {
        documentProcessingId: { required: false, type: "String" },
        auditResults: { required: false, type: "JSONObject" },
        auditPassed: { required: false, type: "Boolean" },
        agentRecommendations: { required: false, type: "String" },
        confidenceScore: { required: false, type: "Float" },
        flaggedIssues: { required: false, type: "[String!]" }
      }
    });
    /** Executes the processDocumentWithAI global action. */
    this.processDocumentWithAI = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processDocumentWithAI",
      operationName: "processDocumentWithAI",
      operationReturnType: "ProcessDocumentWithAI",
      namespace: null,
      variables: { documentProcessingId: { required: false, type: "String" } }
    });
    /** Executes the processDocumentWithSchema global action. */
    this.processDocumentWithSchema = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processDocumentWithSchema",
      operationName: "processDocumentWithSchema",
      operationReturnType: "ProcessDocumentWithSchema",
      namespace: null,
      variables: {
        fileId: { required: false, type: "String" },
        schemaType: { required: false, type: "String" },
        customSchema: { required: false, type: "JSONObject" },
        imageAnalysisOptions: { required: false, type: "JSONObject" },
        validationLevel: { required: false, type: "String" }
      }
    });
    /** Executes the processDocumentsWithAI global action. */
    this.processDocumentsWithAI = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processDocumentsWithAI",
      operationName: "processDocumentsWithAI",
      operationReturnType: "ProcessDocumentsWithAI",
      namespace: null,
      variables: {}
    });
    /** Executes the processExtractionTemplateBuild global action. */
    this.processExtractionTemplateBuild = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processExtractionTemplateBuild",
      operationName: "processExtractionTemplateBuild",
      operationReturnType: "ProcessExtractionTemplateBuild",
      namespace: null,
      variables: { templateId: { required: false, type: "String" } }
    });
    /** Executes the processFisdapFromEmail global action. */
    this.processFisdapFromEmail = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processFisdapFromEmail",
      operationName: "processFisdapFromEmail",
      operationReturnType: "ProcessFisdapFromEmail",
      namespace: null,
      variables: {
        subject: { required: false, type: "String" },
        body: { required: false, type: "String" },
        sender: { required: false, type: "String" },
        timestamp: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        detectedShiftIds: { required: false, type: "[String!]" }
      }
    });
    /** Executes the processFisdapShift global action. */
    this.processFisdapShift = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processFisdapShift",
      operationName: "processFisdapShift",
      operationReturnType: "ProcessFisdapShift",
      namespace: null,
      variables: {}
    });
    /** Executes the processFormSubmission global action. */
    this.processFormSubmission = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processFormSubmission",
      operationName: "processFormSubmission",
      operationReturnType: "ProcessFormSubmission",
      namespace: null,
      variables: { formSubmissionId: { required: false, type: "String" } }
    });
    /** Executes the processIncomingEmails global action. */
    this.processIncomingEmails = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processIncomingEmails",
      operationName: "processIncomingEmails",
      operationReturnType: "ProcessIncomingEmails",
      namespace: null,
      variables: {
        emailId: { required: false, type: "String" },
        notificationData: {
          required: false,
          type: "ProcessIncomingEmailsNotificationDataInput"
        },
        sendNotifications: { required: false, type: "Boolean" },
        bypassMode: { required: false, type: "Boolean" }
      }
    });
    /** Executes the processLiveAudioChunk global action. */
    this.processLiveAudioChunk = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processLiveAudioChunk",
      operationName: "processLiveAudioChunk",
      operationReturnType: "ProcessLiveAudioChunk",
      namespace: null,
      variables: { chunkId: { required: false, type: "String" } }
    });
    /** Executes the processPendingFineTuningBatch global action. */
    this.processPendingFineTuningBatch = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processPendingFineTuningBatch",
      operationName: "processPendingFineTuningBatch",
      operationReturnType: "ProcessPendingFineTuningBatch",
      namespace: null,
      variables: {}
    });
    /** Executes the processQueuedShifts global action. */
    this.processQueuedShifts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processQueuedShifts",
      operationName: "processQueuedShifts",
      operationReturnType: "ProcessQueuedShifts",
      namespace: null,
      variables: {}
    });
    /** Executes the processScenarioAudio global action. */
    this.processScenarioAudio = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processScenarioAudio",
      operationName: "processScenarioAudio",
      operationReturnType: "ProcessScenarioAudio",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        audioFileKey: { required: false, type: "String" }
      }
    });
    /** Executes the processTempFilesToUserFiles global action. */
    this.processTempFilesToUserFiles = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processTempFilesToUserFiles",
      operationName: "processTempFilesToUserFiles",
      operationReturnType: "ProcessTempFilesToUserFiles",
      namespace: null,
      variables: { shiftProcessingId: { required: false, type: "String" } }
    });
    /** Executes the promoteQaMappingMemory global action. */
    this.promoteQaMappingMemory = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "promoteQaMappingMemory",
      operationName: "promoteQaMappingMemory",
      operationReturnType: "PromoteQaMappingMemory",
      namespace: null,
      variables: {
        workflowId: { required: false, type: "String" },
        sourceField: { required: false, type: "String" },
        sourceLabel: { required: false, type: "String" },
        canonicalPath: { required: false, type: "String" },
        nemsisElementId: { required: false, type: "String" },
        notes: { required: false, type: "String" }
      }
    });
    /** Executes the queryStudentHistoricalPatterns global action. */
    this.queryStudentHistoricalPatterns = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "queryStudentHistoricalPatterns",
      operationName: "queryStudentHistoricalPatterns",
      operationReturnType: "QueryStudentHistoricalPatterns",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        studentEmail: { required: false, type: "String" },
        includeDetailedAnalysis: { required: false, type: "Boolean" },
        maxHistoryItems: { required: false, type: "Float" }
      }
    });
    /** Executes the questionBankChat global action. */
    this.questionBankChat = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "questionBankChat",
      operationName: "questionBankChat",
      operationReturnType: "QuestionBankChat",
      namespace: null,
      variables: {
        conversationId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        message: { required: false, type: "String" },
        level: { required: false, type: "String" },
        topic: { required: false, type: "String" },
        tags: { required: false, type: "[String!]" },
        difficulty: { required: false, type: "String" },
        questionType: { required: false, type: "String" },
        status: { required: false, type: "String" },
        search: { required: false, type: "String" },
        desiredCount: { required: false, type: "Float" },
        ceMode: { required: false, type: "Boolean" },
        autoSaveDraft: { required: false, type: "Boolean" },
        draftName: { required: false, type: "String" },
        model: { required: false, type: "String" },
        vectorStoreIds: { required: false, type: "[String!]" },
        maxTokens: { required: false, type: "Float" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the queueFisdapReviewArtifact global action. */
    this.queueFisdapReviewArtifact = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "queueFisdapReviewArtifact",
      operationName: "queueFisdapReviewArtifact",
      operationReturnType: "QueueFisdapReviewArtifact",
      namespace: null,
      variables: { shiftProcessingId: { required: false, type: "String" } }
    });
    /** Executes the quickFieldChartEvaluator global action. */
    this.quickFieldChartEvaluator = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "quickFieldChartEvaluator",
      operationName: "quickFieldChartEvaluator",
      operationReturnType: "QuickFieldChartEvaluator",
      namespace: null,
      variables: {
        chartFileId: { required: false, type: "String" },
        chartText: { required: false, type: "String" },
        chartMetadata: { required: false, type: "JSONObject" },
        forceTennesseeProtocolCheck: { required: false, type: "Boolean" },
        forceCmsMedicalNecessityReview: { required: false, type: "Boolean" }
      }
    });
    /** Executes the quickSessionFix global action. */
    this.quickSessionFix = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "quickSessionFix",
      operationName: "quickSessionFix",
      operationReturnType: "QuickSessionFix",
      namespace: null,
      variables: {}
    });
    /** Executes the recalculateShiftCounts global action. */
    this.recalculateShiftCounts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "recalculateShiftCounts",
      operationName: "recalculateShiftCounts",
      operationReturnType: "RecalculateShiftCounts",
      namespace: null,
      variables: {
        cohortId: { required: false, type: "String" },
        membershipId: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        dryRun: { required: false, type: "Boolean" }
      }
    });
    /** Executes the recordQuestionAdaptiveFeedback global action. */
    this.recordQuestionAdaptiveFeedback = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "recordQuestionAdaptiveFeedback",
      operationName: "recordQuestionAdaptiveFeedback",
      operationReturnType: "RecordQuestionAdaptiveFeedback",
      namespace: null,
      variables: {
        action: { required: false, type: "String" },
        explanation: { required: false, type: "String" },
        originalQuestion: { required: false, type: "JSONObject" },
        editedQuestion: { required: false, type: "JSONObject" },
        institution: { required: false, type: "String" },
        conversationId: { required: false, type: "String" },
        batchId: { required: false, type: "String" },
        modelVersion: { required: false, type: "String" },
        originalModel: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the recordScenarioLicenseAcceptance global action. */
    this.recordScenarioLicenseAcceptance = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "recordScenarioLicenseAcceptance",
      operationName: "recordScenarioLicenseAcceptance",
      operationReturnType: "RecordScenarioLicenseAcceptance",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        licenseType: { required: false, type: "String" },
        scenarioId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        ipAddress: { required: false, type: "String" },
        userAgent: { required: false, type: "String" }
      }
    });
    /** Executes the recoverMissingEvaluations global action. */
    this.recoverMissingEvaluations = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "recoverMissingEvaluations",
      operationName: "recoverMissingEvaluations",
      operationReturnType: "RecoverMissingEvaluations",
      namespace: null,
      variables: {
        batchSize: { required: false, type: "Float" },
        dryRun: { required: false, type: "Boolean" }
      }
    });
    /** Executes the refineEvalSchema global action. */
    this.refineEvalSchema = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "refineEvalSchema",
      operationName: "refineEvalSchema",
      operationReturnType: "RefineEvalSchema",
      namespace: null,
      variables: {
        evalSystemId: { required: false, type: "String" },
        userMessage: { required: false, type: "String" }
      }
    });
    /** Executes the regenerateScenarioMedia global action. */
    this.regenerateScenarioMedia = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "regenerateScenarioMedia",
      operationName: "regenerateScenarioMedia",
      operationReturnType: "RegenerateScenarioMedia",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        generatePatientImage: { required: false, type: "Boolean" },
        generateSceneVideo: { required: false, type: "Boolean" },
        generateClinicalVideos: { required: false, type: "Boolean" }
      }
    });
    /** Executes the registerUser global action. */
    this.registerUser = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "registerUser",
      operationName: "registerUser",
      operationReturnType: "RegisterUser",
      namespace: null,
      variables: {
        invitationToken: { required: false, type: "String" },
        firstName: { required: false, type: "String" },
        lastName: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        requestNotes: { required: false, type: "String" }
      }
    });
    /** Executes the renewExpiringWebhookSubscriptions global action. */
    this.renewExpiringWebhookSubscriptions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "renewExpiringWebhookSubscriptions",
      operationName: "renewExpiringWebhookSubscriptions",
      operationReturnType: "RenewExpiringWebhookSubscriptions",
      namespace: null,
      variables: {}
    });
    /** Executes the repairAgencyQaBackbone global action. */
    this.repairAgencyQaBackbone = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "repairAgencyQaBackbone",
      operationName: "repairAgencyQaBackbone",
      operationReturnType: "RepairAgencyQaBackbone",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        institution: { required: false, type: "String" }
      }
    });
    /** Executes the repairInvitedUserCohortMemberships global action. */
    this.repairInvitedUserCohortMemberships = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "repairInvitedUserCohortMemberships",
      operationName: "repairInvitedUserCohortMemberships",
      operationReturnType: "RepairInvitedUserCohortMemberships",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        limit: { required: false, type: "Float" },
        userId: { required: false, type: "String" },
        email: { required: false, type: "String" }
      }
    });
    /** Executes the repairLegacyCohortMembership global action. */
    this.repairLegacyCohortMembership = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "repairLegacyCohortMembership",
      operationName: "repairLegacyCohortMembership",
      operationReturnType: "RepairLegacyCohortMembership",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        email: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        primaryRole: { required: false, type: "String" },
        forceScenarioAccess: { required: false, type: "Boolean" }
      }
    });
    /** Executes the repairNullRequiredFields global action. */
    this.repairNullRequiredFields = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "repairNullRequiredFields",
      operationName: "repairNullRequiredFields",
      operationReturnType: "RepairNullRequiredFields",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        institution: { required: false, type: "String" },
        modelApiIdentifier: { required: false, type: "String" },
        fieldApiIdentifier: { required: false, type: "String" },
        errorMessage: { required: false, type: "String" }
      }
    });
    /** Executes the reprocessShift global action. */
    this.reprocessShift = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "reprocessShift",
      operationName: "reprocessShift",
      operationReturnType: "ReprocessShift",
      namespace: null,
      variables: { shiftProcessingId: { required: false, type: "String" } }
    });
    /** Executes the requestInstitutionalPartnership global action. */
    this.requestInstitutionalPartnership = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "requestInstitutionalPartnership",
      operationName: "requestInstitutionalPartnership",
      operationReturnType: "RequestInstitutionalPartnership",
      namespace: null,
      variables: {
        targetInstitution: { required: false, type: "String" },
        requestMessage: {
          required: false,
          type: "RequestInstitutionalPartnershipRequestMessageInput"
        },
        requestType: { required: false, type: "String" }
      }
    });
    /** Executes the requestNewPreceptor global action. */
    this.requestNewPreceptor = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "requestNewPreceptor",
      operationName: "requestNewPreceptor",
      operationReturnType: "RequestNewPreceptor",
      namespace: null,
      variables: {
        firstName: { required: false, type: "String" },
        lastName: { required: false, type: "String" },
        phoneNumber: { required: false, type: "String" },
        email: { required: false, type: "String" },
        shiftId: { required: false, type: "String" },
        patientEncounterId: { required: false, type: "String" },
        clinicalSite: { required: false, type: "String" },
        agency: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        notes: { required: false, type: "String" }
      }
    });
    /** Executes the requestScenarioShareCode global action. */
    this.requestScenarioShareCode = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "requestScenarioShareCode",
      operationName: "requestScenarioShareCode",
      operationReturnType: "RequestScenarioShareCode",
      namespace: null,
      variables: {
        token: { required: false, type: "String" },
        requesterEmail: { required: false, type: "String" },
        requesterMessage: { required: false, type: "String" }
      }
    });
    /** Executes the requestShiftReview global action. */
    this.requestShiftReview = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "requestShiftReview",
      operationName: "requestShiftReview",
      operationReturnType: "RequestShiftReview",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        requestReason: { required: false, type: "String" }
      }
    });
    /** Executes the resendPasswordSetupEmail global action. */
    this.resendPasswordSetupEmail = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "resendPasswordSetupEmail",
      operationName: "resendPasswordSetupEmail",
      operationReturnType: "ResendPasswordSetupEmail",
      namespace: null,
      variables: { email: { required: false, type: "String" } }
    });
    /** Executes the resetPasswordWithToken global action. */
    this.resetPasswordWithToken = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "resetPasswordWithToken",
      operationName: "resetPasswordWithToken",
      operationReturnType: "ResetPasswordWithToken",
      namespace: null,
      variables: {
        token: { required: false, type: "String" },
        code: { required: false, type: "String" },
        password: { required: false, type: "String" }
      }
    });
    /** Executes the resolveHitl global action. */
    this.resolveHitl = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "resolveHitl",
      operationName: "resolveHitl",
      operationReturnType: "ResolveHitl",
      namespace: null,
      variables: {}
    });
    /** Executes the resolvePhiFalsePositive global action. */
    this.resolvePhiFalsePositive = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "resolvePhiFalsePositive",
      operationName: "resolvePhiFalsePositive",
      operationReturnType: "ResolvePhiFalsePositive",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        resolutionSource: { required: false, type: "String" }
      }
    });
    /** Executes the resumeConversationWithHistory global action. */
    this.resumeConversationWithHistory = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "resumeConversationWithHistory",
      operationName: "resumeConversationWithHistory",
      operationReturnType: "ResumeConversationWithHistory",
      namespace: null,
      variables: {
        threadId: { required: false, type: "String" },
        assistantId: { required: false, type: "String" }
      }
    });
    /** Executes the reviewPartnershipRequest global action. */
    this.reviewPartnershipRequest = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "reviewPartnershipRequest",
      operationName: "reviewPartnershipRequest",
      operationReturnType: "ReviewPartnershipRequest",
      namespace: null,
      variables: {
        partnershipId: { required: false, type: "String" },
        decision: { required: false, type: "String" },
        responseMessage: { required: false, type: "String" },
        sharedResources: { required: false, type: "JSONObject" }
      }
    });
    /** Executes the reviewQaChartField global action. */
    this.reviewQaChartField = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "reviewQaChartField",
      operationName: "reviewQaChartField",
      operationReturnType: "ReviewQaChartField",
      namespace: null,
      variables: {
        fieldRecordId: { required: false, type: "String" },
        decisionType: { required: false, type: "String" },
        notes: { required: false, type: "String" },
        mappingResult: { required: false, type: "JSONObject" }
      }
    });
    /** Executes the reviewQuestionAdaptiveFeedback global action. */
    this.reviewQuestionAdaptiveFeedback = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "reviewQuestionAdaptiveFeedback",
      operationName: "reviewQuestionAdaptiveFeedback",
      operationReturnType: "ReviewQuestionAdaptiveFeedback",
      namespace: null,
      variables: {
        feedbackId: { required: false, type: "String" },
        decision: { required: false, type: "String" },
        editedQuestion: { required: false, type: "JSONObject" },
        explanation: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the revokeAssistantAccess global action. */
    this.revokeAssistantAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "revokeAssistantAccess",
      operationName: "revokeAssistantAccess",
      operationReturnType: "RevokeAssistantAccess",
      namespace: null,
      variables: { accessGrantId: { required: false, type: "String" } }
    });
    /** Executes the revokeInstitutionAdministrator global action. */
    this.revokeInstitutionAdministrator = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "revokeInstitutionAdministrator",
      operationName: "revokeInstitutionAdministrator",
      operationReturnType: "RevokeInstitutionAdministrator",
      namespace: null,
      variables: { userId: { required: false, type: "String" } }
    });
    /** Executes the revokePublicScenarioAccess global action. */
    this.revokePublicScenarioAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "revokePublicScenarioAccess",
      operationName: "revokePublicScenarioAccess",
      operationReturnType: "RevokePublicScenarioAccess",
      namespace: null,
      variables: { accessGrantId: { required: false, type: "String" } }
    });
    /** Executes the runCleanupNow global action. */
    this.runCleanupNow = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "runCleanupNow",
      operationName: "runCleanupNow",
      operationReturnType: "RunCleanupNow",
      namespace: null,
      variables: {}
    });
    /** Executes the runDebugVectorStoreContents global action. */
    this.runDebugVectorStoreContents = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "runDebugVectorStoreContents",
      operationName: "runDebugVectorStoreContents",
      operationReturnType: "RunDebugVectorStoreContents",
      namespace: null,
      variables: {}
    });
    /** Executes the runEvaluation global action. */
    this.runEvaluation = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "runEvaluation",
      operationName: "runEvaluation",
      operationReturnType: "RunEvaluation",
      namespace: null,
      variables: {
        evalSystemId: { required: false, type: "String" },
        documentBase64: { required: false, type: "String" },
        documentMimeType: { required: false, type: "String" },
        documentFileName: { required: false, type: "String" },
        submitterEmail: { required: false, type: "String" },
        sourceType: { required: false, type: "String" },
        oneOffRecipients: { required: false, type: "String" },
        emailMetadata: { required: false, type: "String" }
      }
    });
    /** Executes the runFixVectorStoreAssociations global action. */
    this.runFixVectorStoreAssociations = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "runFixVectorStoreAssociations",
      operationName: "runFixVectorStoreAssociations",
      operationReturnType: "RunFixVectorStoreAssociations",
      namespace: null,
      variables: {}
    });
    /** Executes the runQaChartPipeline global action. */
    this.runQaChartPipeline = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "runQaChartPipeline",
      operationName: "runQaChartPipeline",
      operationReturnType: "RunQaChartPipeline",
      namespace: null,
      variables: { chartId: { required: false, type: "String" } }
    });
    /** Executes the runQuestionAdaptiveTuningBatch global action. */
    this.runQuestionAdaptiveTuningBatch = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "runQuestionAdaptiveTuningBatch",
      operationName: "runQuestionAdaptiveTuningBatch",
      operationReturnType: "RunQuestionAdaptiveTuningBatch",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        minItems: { required: false, type: "Float" },
        previewOnly: { required: false, type: "Boolean" },
        baseModel: { required: false, type: "String" },
        nEpochs: { required: false, type: "Float" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the runVoiceSimulationReplayLab global action. */
    this.runVoiceSimulationReplayLab = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "runVoiceSimulationReplayLab",
      operationName: "runVoiceSimulationReplayLab",
      operationReturnType: "RunVoiceSimulationReplayLab",
      namespace: null,
      variables: {
        scenarioIds: { required: false, type: "[String!]" },
        runsPerScenario: { required: false, type: "Float" },
        maxTurns: { required: false, type: "Float" },
        maxScenarios: { required: false, type: "Float" },
        competencyLevel: { required: false, type: "String" },
        errorRate: { required: false, type: "Float" },
        resumeStateJson: { required: false, type: "String" }
      }
    });
    /** Executes the saveExamItems global action. */
    this.saveExamItems = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "saveExamItems",
      operationName: "saveExamItems",
      operationReturnType: "SaveExamItems",
      namespace: null,
      variables: {
        repositoryRecordId: { required: false, type: "String" },
        decisions: { required: false, type: "[JSONObject!]" },
        requireValidation: { required: false, type: "Boolean" },
        createFinalizedCopy: { required: false, type: "Boolean" },
        finalizedName: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the saveQaWorkflow global action. */
    this.saveQaWorkflow = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "saveQaWorkflow",
      operationName: "saveQaWorkflow",
      operationReturnType: "SaveQaWorkflow",
      namespace: null,
      variables: {
        id: { required: false, type: "String" },
        name: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        intakeConfig: { required: false, type: "JSONObject" },
        clinicalPolicyConfig: { required: false, type: "JSONObject" },
        billingPolicyConfig: { required: false, type: "JSONObject" },
        compliancePolicyConfig: { required: false, type: "JSONObject" },
        knowledgeBaseConfig: { required: false, type: "JSONObject" },
        requiredMappingRules: { required: false, type: "[JSONObject!]" },
        notificationConfig: { required: false, type: "JSONObject" },
        reportStyleConfig: { required: false, type: "JSONObject" },
        reviewerEmails: { required: false, type: "[String!]" },
        operatorEmails: { required: false, type: "[String!]" }
      }
    });
    /** Executes the saveQuestionBankExportProfile global action. */
    this.saveQuestionBankExportProfile = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "saveQuestionBankExportProfile",
      operationName: "saveQuestionBankExportProfile",
      operationReturnType: "SaveQuestionBankExportProfile",
      namespace: null,
      variables: {
        profileId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        name: { required: false, type: "String" },
        sampleExportText: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the saveScenarioForImmersive global action. */
    this.saveScenarioForImmersive = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "saveScenarioForImmersive",
      operationName: "saveScenarioForImmersive",
      operationReturnType: "SaveScenarioForImmersive",
      namespace: null,
      variables: {
        scenario: { required: false, type: "JSONObject" },
        userId: { required: false, type: "String" },
        institution: { required: false, type: "String" }
      }
    });
    /** Executes the scrapeFisdapHtmlForPdf global action. */
    this.scrapeFisdapHtmlForPdf = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "scrapeFisdapHtmlForPdf",
      operationName: "scrapeFisdapHtmlForPdf",
      operationReturnType: "ScrapeFisdapHtmlForPdf",
      namespace: null,
      variables: { shiftId: { required: false, type: "String" } }
    });
    /** Executes the sendAttendanceMagicLinks global action. */
    this.sendAttendanceMagicLinks = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendAttendanceMagicLinks",
      operationName: "sendAttendanceMagicLinks",
      operationReturnType: "SendAttendanceMagicLinks",
      namespace: null,
      variables: {}
    });
    /** Executes the sendClinicalNotifications global action. */
    this.sendClinicalNotifications = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendClinicalNotifications",
      operationName: "sendClinicalNotifications",
      operationReturnType: "SendClinicalNotifications",
      namespace: null,
      variables: {
        documentId: { required: false, type: "String" },
        shiftProcessingId: { required: false, type: "String" },
        evaluationId: { required: false, type: "String" },
        notificationType: { required: false, type: "String" },
        urgencyLevel: { required: false, type: "String" },
        customMessage: { required: false, type: "String" },
        forceDelivery: { required: false, type: "Boolean" }
      }
    });
    /** Executes the sendCombinedFisdap global action. */
    this.sendCombinedFisdap = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendCombinedFisdap",
      operationName: "sendCombinedFisdap",
      operationReturnType: "SendCombinedFisdap",
      namespace: null,
      variables: {
        shiftId: { required: false, type: "String" },
        bypassMode: { required: false, type: "Boolean" },
        htmlContent: { required: false, type: "String" }
      }
    });
    /** Executes the sendEvaluationNotification global action. */
    this.sendEvaluationNotification = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendEvaluationNotification",
      operationName: "sendEvaluationNotification",
      operationReturnType: "SendEvaluationNotification",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        forceNotification: { required: false, type: "Boolean" },
        additionalRecipients: { required: false, type: "[String!]" }
      }
    });
    /** Executes the sendEvaluationNotificationA global action. */
    this.sendEvaluationNotificationA = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendEvaluationNotificationA",
      operationName: "sendEvaluationNotificationA",
      operationReturnType: "SendEvaluationNotificationA",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        forceNotification: { required: false, type: "Boolean" },
        notificationMode: { required: false, type: "String" },
        additionalRecipients: { required: false, type: "[String!]" }
      }
    });
    /** Executes the sendFormReminders global action. */
    this.sendFormReminders = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendFormReminders",
      operationName: "sendFormReminders",
      operationReturnType: "SendFormReminders",
      namespace: null,
      variables: {}
    });
    /** Executes the sendInvite global action. */
    this.sendInvite = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendInvite",
      operationName: "sendInvite",
      operationReturnType: "SendInvite",
      namespace: null,
      variables: {
        email: { required: false, type: "String" },
        firstName: { required: false, type: "String" },
        lastName: { required: false, type: "String" },
        accessCodeType: { required: false, type: "String" },
        duration: { required: false, type: "String" },
        customMessage: { required: false, type: "String" },
        maxUses: { required: false, type: "Float" },
        assistantIds: { required: false, type: "[String!]" },
        fromSender: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        institutionRole: { required: false, type: "[String!]" },
        agentAccessMode: { required: false, type: "String" },
        agentNames: { required: false, type: "[String!]" },
        cohortId: { required: false, type: "String" },
        cohortRole: { required: false, type: "String" },
        instructorSpecializations: { required: false, type: "[String!]" },
        staffPositions: { required: false, type: "[String!]" },
        qaPortalAccess: { required: false, type: "Boolean" },
        qaWorkgroupIds: { required: false, type: "[String!]" },
        qaRoutingRoleKeys: { required: false, type: "[String!]" }
      }
    });
    /** Executes the sendPasswordSetupForUser global action. */
    this.sendPasswordSetupForUser = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendPasswordSetupForUser",
      operationName: "sendPasswordSetupForUser",
      operationReturnType: "SendPasswordSetupForUser",
      namespace: null,
      variables: { email: { required: false, type: "String" } }
    });
    /** Executes the sendVoiceSimInvitation global action. */
    this.sendVoiceSimInvitation = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendVoiceSimInvitation",
      operationName: "sendVoiceSimInvitation",
      operationReturnType: "SendVoiceSimInvitation",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        trainingLevel: { required: false, type: "String" },
        sharingMode: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        memberSelection: { required: false, type: "String" },
        selectedMemberIds: { required: false, type: "[String!]" },
        emails: { required: false, type: "[String!]" },
        useInstitutionalDomain: { required: false, type: "Boolean" },
        institutionalDomain: { required: false, type: "String" },
        expirationHours: { required: false, type: "Float" },
        attemptsAllowed: { required: false, type: "Float" },
        customMessage: { required: false, type: "String" },
        notifyOnCompletion: { required: false, type: "Boolean" },
        completionNotifyInstructorIds: { required: false, type: "[String!]" }
      }
    });
    /** Executes the setupAdminAssistantAmy global action. */
    this.setupAdminAssistantAmy = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupAdminAssistantAmy",
      operationName: "setupAdminAssistantAmy",
      operationReturnType: "SetupAdminAssistantAmy",
      namespace: null,
      variables: {
        resetExisting: { required: false, type: "Boolean" },
        enableAuditLogging: { required: false, type: "Boolean" },
        testMode: { required: false, type: "Boolean" }
      }
    });
    /** Executes the setupAgentConfigurations global action. */
    this.setupAgentConfigurations = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupAgentConfigurations",
      operationName: "setupAgentConfigurations",
      operationReturnType: "SetupAgentConfigurations",
      namespace: null,
      variables: {}
    });
    /** Executes the setupAgentPersonalities global action. */
    this.setupAgentPersonalities = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupAgentPersonalities",
      operationName: "setupAgentPersonalities",
      operationReturnType: "SetupAgentPersonalities",
      namespace: null,
      variables: { agentTypes: { required: false, type: "[String!]" } }
    });
    /** Executes the setupDefaultAccess global action. */
    this.setupDefaultAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupDefaultAccess",
      operationName: "setupDefaultAccess",
      operationReturnType: "SetupDefaultAccess",
      namespace: null,
      variables: {}
    });
    /** Executes the setupDefaultAgentConfigurations global action. */
    this.setupDefaultAgentConfigurations = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupDefaultAgentConfigurations",
      operationName: "setupDefaultAgentConfigurations",
      operationReturnType: "SetupDefaultAgentConfigurations",
      namespace: null,
      variables: { userId: { required: false, type: "String" } }
    });
    /** Executes the setupDocumentProcessorAssistant global action. */
    this.setupDocumentProcessorAssistant = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupDocumentProcessorAssistant",
      operationName: "setupDocumentProcessorAssistant",
      operationReturnType: "SetupDocumentProcessorAssistant",
      namespace: null,
      variables: {}
    });
    /** Executes the setupEmailWebhookForwarding global action. */
    this.setupEmailWebhookForwarding = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupEmailWebhookForwarding",
      operationName: "setupEmailWebhookForwarding",
      operationReturnType: "SetupEmailWebhookForwarding",
      namespace: null,
      variables: {}
    });
    /** Executes the setupPassword global action. */
    this.setupPassword = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupPassword",
      operationName: "setupPassword",
      operationReturnType: "SetupPassword",
      namespace: null,
      variables: {
        password: { required: false, type: "String" },
        token: { required: false, type: "String" }
      }
    });
    /** Executes the setupSTCCInstitution global action. */
    this.setupSTCCInstitution = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupSTCCInstitution",
      operationName: "setupSTCCInstitution",
      operationReturnType: "SetupSTCCInstitution",
      namespace: null,
      variables: {}
    });
    /** Executes the setupUserAgentAccess global action. */
    this.setupUserAgentAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "setupUserAgentAccess",
      operationName: "setupUserAgentAccess",
      operationReturnType: "SetupUserAgentAccess",
      namespace: null,
      variables: {}
    });
    /** Executes the signOut global action. */
    this.signOut = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "signOut",
      operationName: "signOut",
      operationReturnType: "SignOut",
      namespace: null,
      variables: {}
    });
    /** Executes the simulateActions global action. */
    this.simulateActions = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "simulateActions",
      operationName: "simulateActions",
      operationReturnType: "SimulateActions",
      namespace: null,
      variables: {
        scenario: { required: false, type: "JSONObject" },
        currentState: { required: false, type: "JSONObject" },
        actionSet: { required: false, type: "JSONObject" }
      }
    });
    /** Executes the standardizeUserRoles global action. */
    this.standardizeUserRoles = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "standardizeUserRoles",
      operationName: "standardizeUserRoles",
      operationReturnType: "StandardizeUserRoles",
      namespace: null,
      variables: {}
    });
    /** Executes the stopImpersonating global action. */
    this.stopImpersonating = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "stopImpersonating",
      operationName: "stopImpersonating",
      operationReturnType: "StopImpersonating",
      namespace: null,
      variables: {}
    });
    /** Executes the storeConversationMessage global action. */
    this.storeConversationMessage = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "storeConversationMessage",
      operationName: "storeConversationMessage",
      operationReturnType: "StoreConversationMessage",
      namespace: null,
      variables: {
        conversationId: { required: false, type: "String" },
        messageType: { required: false, type: "String" },
        content: { required: false, type: "JSONObject" },
        metadata: { required: false, type: "JSONObject" },
        tokenUsage: { required: false, type: "JSONObject" },
        modelUsed: { required: false, type: "String" },
        processingTimeMs: { required: false, type: "Float" },
        responseId: { required: false, type: "String" }
      }
    });
    /** Executes the submitHitlReview global action. */
    this.submitHitlReview = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "submitHitlReview",
      operationName: "submitHitlReview",
      operationReturnType: "SubmitHitlReview",
      namespace: null,
      variables: {
        shiftProcessingId: { required: false, type: "String" },
        humanVerdict: { required: false, type: "String" },
        overallGrade: { required: false, type: "Float" },
        fieldReviews: { required: false, type: "JSONObject" },
        reviewNotes: { required: false, type: "String" }
      }
    });
    /** Executes the submitQaHumanReview global action. */
    this.submitQaHumanReview = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "submitQaHumanReview",
      operationName: "submitQaHumanReview",
      operationReturnType: "SubmitQaHumanReview",
      namespace: null,
      variables: {
        chartId: { required: false, type: "String" },
        humanOutcome: { required: false, type: "String" },
        explanation: { required: false, type: "String" },
        disagreementNotes: { required: false, type: "String" }
      }
    });
    /** Executes the submitQuickChartEvaluation global action. */
    this.submitQuickChartEvaluation = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "submitQuickChartEvaluation",
      operationName: "submitQuickChartEvaluation",
      operationReturnType: "SubmitQuickChartEvaluation",
      namespace: null,
      variables: {
        chartFileId: { required: false, type: "String" },
        chartText: { required: false, type: "String" },
        chartMetadata: { required: false, type: "JSONObject" },
        forceTennesseeProtocolCheck: { required: false, type: "Boolean" },
        forceCmsMedicalNecessityReview: { required: false, type: "Boolean" },
        title: { required: false, type: "String" },
        sourceType: { required: false, type: "String" },
        sourceSystem: { required: false, type: "String" },
        sourceReference: { required: false, type: "String" },
        sourceEmail: { required: false, type: "String" },
        sourceSubject: { required: false, type: "String" },
        sourceMessageId: { required: false, type: "String" },
        emailMetadata: { required: false, type: "JSONObject" },
        notifyOriginalSender: { required: false, type: "Boolean" }
      }
    });
    /** Executes the submitShiftManually global action. */
    this.submitShiftManually = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "submitShiftManually",
      operationName: "submitShiftManually",
      operationReturnType: "SubmitShiftManually",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        shiftId: { required: false, type: "String" },
        file: { required: false, type: "SubmitShiftManuallyFileInput" },
        submissionEmail: { required: false, type: "String" },
        isOBO: { required: false, type: "Boolean" },
        originalSubmitter: { required: false, type: "String" }
      }
    });
    /** Executes the syncAgentFromVM global action. */
    this.syncAgentFromVM = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "syncAgentFromVM",
      operationName: "syncAgentFromVM",
      operationReturnType: "SyncAgentFromVM",
      namespace: null,
      variables: {}
    });
    /** Executes the syncAgentToVM global action. */
    this.syncAgentToVM = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "syncAgentToVM",
      operationName: "syncAgentToVM",
      operationReturnType: "SyncAgentToVM",
      namespace: null,
      variables: { agentConfigId: { required: false, type: "String" } }
    });
    /** Executes the syncAgentsToVM global action. */
    this.syncAgentsToVM = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "syncAgentsToVM",
      operationName: "syncAgentsToVM",
      operationReturnType: "SyncAgentsToVM",
      namespace: null,
      variables: {
        forceResync: { required: false, type: "Boolean" },
        configIds: { required: false, type: "[String!]" }
      }
    });
    /** Executes the syncAllUserCreditSources global action. */
    this.syncAllUserCreditSources = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "syncAllUserCreditSources",
      operationName: "syncAllUserCreditSources",
      operationReturnType: "SyncAllUserCreditSources",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        userIds: { required: false, type: "[String!]" },
        limit: { required: false, type: "Float" }
      }
    });
    /** Executes the syncCohortInstructorsToMemberships global action. */
    this.syncCohortInstructorsToMemberships = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "syncCohortInstructorsToMemberships",
      operationName: "syncCohortInstructorsToMemberships",
      operationReturnType: "SyncCohortInstructorsToMemberships",
      namespace: null,
      variables: {}
    });
    /** Executes the syncFisdapCalendar global action. */
    this.syncFisdapCalendar = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "syncFisdapCalendar",
      operationName: "syncFisdapCalendar",
      operationReturnType: "SyncFisdapCalendar",
      namespace: null,
      variables: {
        cohortId: { required: false, type: "String" },
        forceSync: { required: false, type: "Boolean" },
        initiatedByUserId: { required: false, type: "String" },
        clearExisting: { required: false, type: "Boolean" }
      }
    });
    /** Executes the syncSharedResources global action. */
    this.syncSharedResources = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "syncSharedResources",
      operationName: "syncSharedResources",
      operationReturnType: "SyncSharedResources",
      namespace: null,
      variables: { partnershipId: { required: false, type: "String" } }
    });
    /** Executes the synchronizeVectorStore global action. */
    this.synchronizeVectorStore = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "synchronizeVectorStore",
      operationName: "synchronizeVectorStore",
      operationReturnType: "SynchronizeVectorStore",
      namespace: null,
      variables: {
        vectorStoreId: { required: false, type: "String" },
        forceFullSync: { required: false, type: "Boolean" }
      }
    });
    /** Executes the synthesizeRAGMemories global action. */
    this.synthesizeRAGMemories = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "synthesizeRAGMemories",
      operationName: "synthesizeRAGMemories",
      operationReturnType: "SynthesizeRAGMemories",
      namespace: null,
      variables: {
        sourceType: { required: false, type: "String" },
        sourceId: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        forceReprocess: { required: false, type: "Boolean" }
      }
    });
    /** Executes the testActualSendMail global action. */
    this.testActualSendMail = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "testActualSendMail",
      operationName: "testActualSendMail",
      operationReturnType: "TestActualSendMail",
      namespace: null,
      variables: {}
    });
    /** Executes the testAgentsSDK global action. */
    this.testAgentsSDK = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "testAgentsSDK",
      operationName: "testAgentsSDK",
      operationReturnType: "TestAgentsSDK",
      namespace: null,
      variables: {
        input: { required: false, type: "String" },
        testMode: { required: false, type: "Boolean" }
      }
    });
    /** Executes the testAssistantAccess global action. */
    this.testAssistantAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "testAssistantAccess",
      operationName: "testAssistantAccess",
      operationReturnType: "TestAssistantAccess",
      namespace: null,
      variables: {
        assistantId: { required: false, type: "String" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the testVMConnection global action. */
    this.testVMConnection = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "testVMConnection",
      operationName: "testVMConnection",
      operationReturnType: "TestVMConnection",
      namespace: null,
      variables: {}
    });
    /** Executes the trackScenarioTokenAccess global action. */
    this.trackScenarioTokenAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "trackScenarioTokenAccess",
      operationName: "trackScenarioTokenAccess",
      operationReturnType: "TrackScenarioTokenAccess",
      namespace: null,
      variables: { tokenId: { required: false, type: "String" } }
    });
    /** Executes the updateAgentConfigsWithRAG global action. */
    this.updateAgentConfigsWithRAG = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateAgentConfigsWithRAG",
      operationName: "updateAgentConfigsWithRAG",
      operationReturnType: "UpdateAgentConfigsWithRAG",
      namespace: null,
      variables: {
        dryRun: { required: false, type: "Boolean" },
        agentTypes: { required: false, type: "[String!]" },
        forceUpdate: { required: false, type: "Boolean" }
      }
    });
    /** Executes the updateAgentConfigurationGlobal global action. */
    this.updateAgentConfigurationGlobal = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateAgentConfigurationGlobal",
      operationName: "updateAgentConfigurationGlobal",
      operationReturnType: "UpdateAgentConfigurationGlobal",
      namespace: null,
      variables: {
        id: { required: false, type: "String" },
        agentType: { required: false, type: "String" },
        name: { required: false, type: "String" },
        description: { required: false, type: "String" },
        instructions: { required: false, type: "String" },
        modelSettings: { required: false, type: "JSONObject" },
        enabledTools: { required: false, type: "[String!]" },
        capabilities: { required: false, type: "JSONObject" },
        guardrailSettings: { required: false, type: "JSONObject" },
        isActive: { required: false, type: "Boolean" }
      }
    });
    /** Executes the updateAgentContextSettings global action. */
    this.updateAgentContextSettings = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateAgentContextSettings",
      operationName: "updateAgentContextSettings",
      operationReturnType: "UpdateAgentContextSettings",
      namespace: null,
      variables: {
        agentType: { required: false, type: "String" },
        contextEnabled: { required: false, type: "Boolean" },
        authorizedUserIds: { required: false, type: "[String!]" },
        contextFeatures: { required: false, type: "JSONObject" }
      }
    });
    /** Executes the updateAgentGuardrails global action. */
    this.updateAgentGuardrails = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateAgentGuardrails",
      operationName: "updateAgentGuardrails",
      operationReturnType: "UpdateAgentGuardrails",
      namespace: null,
      variables: {}
    });
    /** Executes the updateAgentInitiatorMessages global action. */
    this.updateAgentInitiatorMessages = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateAgentInitiatorMessages",
      operationName: "updateAgentInitiatorMessages",
      operationReturnType: "UpdateAgentInitiatorMessages",
      namespace: null,
      variables: {}
    });
    /** Executes the updateAgentsWithVectorStore global action. */
    this.updateAgentsWithVectorStore = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateAgentsWithVectorStore",
      operationName: "updateAgentsWithVectorStore",
      operationReturnType: "UpdateAgentsWithVectorStore",
      namespace: null,
      variables: { vectorStoreId: { required: false, type: "String" } }
    });
    /** Executes the updateAllUsersWithPrintSavePermission global action. */
    this.updateAllUsersWithPrintSavePermission = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateAllUsersWithPrintSavePermission",
      operationName: "updateAllUsersWithPrintSavePermission",
      operationReturnType: "UpdateAllUsersWithPrintSavePermission",
      namespace: null,
      variables: {}
    });
    /** Executes the updateInstitutionalConfig global action. */
    this.updateInstitutionalConfig = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateInstitutionalConfig",
      operationName: "updateInstitutionalConfig",
      operationReturnType: "UpdateInstitutionalConfig",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        configurationUpdates: { required: false, type: "JSONObject" },
        reason: { required: false, type: "String" }
      }
    });
    /** Executes the updateUserInstitutionRole global action. */
    this.updateUserInstitutionRole = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateUserInstitutionRole",
      operationName: "updateUserInstitutionRole",
      operationReturnType: "UpdateUserInstitutionRole",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        institutionRole: { required: false, type: "String" },
        cohort: { required: false, type: "String" },
        cohortRole: { required: false, type: "String" }
      }
    });
    /** Executes the updateUserRoleAndCohort global action. */
    this.updateUserRoleAndCohort = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateUserRoleAndCohort",
      operationName: "updateUserRoleAndCohort",
      operationReturnType: "UpdateUserRoleAndCohort",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        institutionRole: { required: false, type: "String" },
        cohort: { required: false, type: "String" },
        notes: { required: false, type: "String" },
        newCohortName: { required: false, type: "String" },
        cohortId: { required: false, type: "String" },
        approvalStatus: { required: false, type: "String" }
      }
    });
    /** Executes the updateUserScenarioAccess global action. */
    this.updateUserScenarioAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateUserScenarioAccess",
      operationName: "updateUserScenarioAccess",
      operationReturnType: "UpdateUserScenarioAccess",
      namespace: null,
      variables: {
        userId: { required: false, type: "String" },
        hasAccess: { required: false, type: "Boolean" },
        scope: { required: false, type: "String" }
      }
    });
    /** Executes the uploadAndProcessScenarioAudio global action. */
    this.uploadAndProcessScenarioAudio = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "uploadAndProcessScenarioAudio",
      operationName: "uploadAndProcessScenarioAudio",
      operationReturnType: "UploadAndProcessScenarioAudio",
      namespace: null,
      variables: {
        scenarioId: { required: false, type: "String" },
        runId: { required: false, type: "String" },
        phase: { required: false, type: "String" },
        audioFile: {
          required: false,
          type: "UploadAndProcessScenarioAudioAudioFileInput"
        },
        audioFileUrl: { required: false, type: "String" },
        userFileId: { required: false, type: "String" }
      }
    });
    /** Executes the uploadFilesToVectorStore global action. */
    this.uploadFilesToVectorStore = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "uploadFilesToVectorStore",
      operationName: "uploadFilesToVectorStore",
      operationReturnType: "UploadFilesToVectorStore",
      namespace: null,
      variables: {
        vectorStoreId: { required: false, type: "String" },
        fileUrls: { required: false, type: "[String!]" },
        agentType: { required: false, type: "String" }
      }
    });
    /** Executes the uploadQaKnowledgeDocument global action. */
    this.uploadQaKnowledgeDocument = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "uploadQaKnowledgeDocument",
      operationName: "uploadQaKnowledgeDocument",
      operationReturnType: "UploadQaKnowledgeDocument",
      namespace: null,
      variables: {
        knowledgeBaseId: { required: false, type: "String" },
        title: { required: false, type: "String" },
        base64: { required: false, type: "String" },
        fileName: { required: false, type: "String" },
        mimeType: { required: false, type: "String" },
        domainTags: { required: false, type: "[String!]" }
      }
    });
    /** Executes the upsertQuestionBankItem global action. */
    this.upsertQuestionBankItem = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "upsertQuestionBankItem",
      operationName: "upsertQuestionBankItem",
      operationReturnType: "UpsertQuestionBankItem",
      namespace: null,
      variables: {
        repositoryRecordId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        name: { required: false, type: "String" },
        status: { required: false, type: "String" },
        isPublic: { required: false, type: "Boolean" },
        level: { required: false, type: "String" },
        question: { required: false, type: "JSONObject" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the upsertStccImpressionPolicy global action. */
    this.upsertStccImpressionPolicy = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "upsertStccImpressionPolicy",
      operationName: "upsertStccImpressionPolicy",
      operationReturnType: "UpsertStccImpressionPolicy",
      namespace: null,
      variables: {
        institution: { required: false, type: "String" },
        userId: { required: false, type: "String" },
        force: { required: false, type: "Boolean" }
      }
    });
    /** Executes the validateCohortRoleCompatibility global action. */
    this.validateCohortRoleCompatibility = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "validateCohortRoleCompatibility",
      operationName: "validateCohortRoleCompatibility",
      operationReturnType: "ValidateCohortRoleCompatibility",
      namespace: null,
      variables: {}
    });
    /** Executes the validateEmbedToken global action. */
    this.validateEmbedToken = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "validateEmbedToken",
      operationName: "validateEmbedToken",
      operationReturnType: "ValidateEmbedToken",
      namespace: null,
      variables: {
        token: { required: false, type: "String" },
        hostDomain: { required: false, type: "String" },
        assistantId: { required: false, type: "String" }
      }
    });
    /** Executes the validateExamItems global action. */
    this.validateExamItems = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "validateExamItems",
      operationName: "validateExamItems",
      operationReturnType: "ValidateExamItems",
      namespace: null,
      variables: {
        repositoryRecordId: { required: false, type: "String" },
        items: { required: false, type: "[JSONObject!]" },
        institution: { required: false, type: "String" },
        saveToRecord: { required: false, type: "Boolean" },
        model: { required: false, type: "String" },
        maxTokens: { required: false, type: "Float" },
        userId: { required: false, type: "String" }
      }
    });
    /** Executes the validatePreceptorAssignment global action. */
    this.validatePreceptorAssignment = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "validatePreceptorAssignment",
      operationName: "validatePreceptorAssignment",
      operationReturnType: "ValidatePreceptorAssignment",
      namespace: null,
      variables: {
        preceptorId: { required: false, type: "String" },
        institution: { required: false, type: "String" },
        shiftId: { required: false, type: "String" }
      }
    });
    /** Executes the validateScenarioSharePassword global action. */
    this.validateScenarioSharePassword = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "validateScenarioSharePassword",
      operationName: "validateScenarioSharePassword",
      operationReturnType: "ValidateScenarioSharePassword",
      namespace: null,
      variables: {
        token: { required: false, type: "String" },
        password: { required: false, type: "String" }
      }
    });
    /** Executes the validateVoiceSimAccess global action. */
    this.validateVoiceSimAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "validateVoiceSimAccess",
      operationName: "validateVoiceSimAccess",
      operationReturnType: "ValidateVoiceSimAccess",
      namespace: null,
      variables: {
        voiceSimSessionId: { required: false, type: "String" },
        scenarioId: { required: false, type: "String" }
      }
    });
    /** Executes the validateVoiceSimToken global action. */
    this.validateVoiceSimToken = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "validateVoiceSimToken",
      operationName: "validateVoiceSimToken",
      operationReturnType: "ValidateVoiceSimToken",
      namespace: null,
      variables: {
        voiceSimSessionId: { required: false, type: "String" },
        deviceFingerprint: { required: false, type: "String" },
        ipAddress: { required: false, type: "String" },
        scenarioId: { required: false, type: "String" },
        token: { required: false, type: "String" }
      }
    });
    /** Executes the verifyEncounterDocumentation global action. */
    this.verifyEncounterDocumentation = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "verifyEncounterDocumentation",
      operationName: "verifyEncounterDocumentation",
      operationReturnType: "VerifyEncounterDocumentation",
      namespace: null,
      variables: {
        shiftId: { required: false, type: "String" },
        studentId: { required: false, type: "String" }
      }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: null,
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    /**
     * The list of environments with a customized API root endpoint
     */
    this.apiRoots = { "development": "https://papamedic-ai--development.gadget.app/", "production": "https://app.papamedic.ai/" };
    this.applicationId = "237922";
    /** Start a transaction against the Gadget backend which will atomically commit (or rollback). */
    this.transaction = async (callback) => {
      return await this.connection.transaction(callback);
    };
    /**
    * Get a new direct upload token for file uploads to directly to cloud storage.
    * See https://docs.gadget.dev/guides/storing-files#direct-uploads-using-tokens for more information
    * @return { url: string, token: string } A `url` to upload one file to, and a token for that file to pass back to Gadget as an action input.
    */
    this.getDirectUploadToken = async () => {
      const result = await this.query("query GetDirectUploadToken($nonce: String) { gadgetMeta { directUploadToken(nonce: $nonce) { url, token } } }", { nonce: Math.random().toString(36).slice(2, 7) }, {
        requestPolicy: "network-only"
      });
      return result.gadgetMeta.directUploadToken;
    };
    let inSSRContext = false;
    this.options = options;
    try {
      inSSRContext = !!(import.meta.env && import.meta.env.SSR);
    } catch (error) {
    }
    if (inSSRContext) {
      const api = globalThis.GadgetGlobals?.api;
      if (api) {
        return api.actAsSession;
      }
    }
    this.environment = (options?.environment ?? getImplicitEnv() ?? fallbackEnv).toLocaleLowerCase();
    let apiRoot;
    if (this.apiRoots[this.environment]) {
      apiRoot = this.apiRoots[this.environment];
    } else {
      const envPart = this.environment == productionEnv ? "" : `--${this.environment}`;
      apiRoot = `https://papamedic-ai${envPart}.gadget.app`;
    }
    const exchanges = { ...options?.exchanges };
    if (this.environment !== productionEnv) {
      const devHarnessExchange = ({ forward }) => {
        return (operations$) => {
          const operationResult$ = forward(operations$);
          return pipe(
            operationResult$,
            map((result) => {
              try {
                if (typeof window !== "undefined" && typeof CustomEvent === "function") {
                  const event = new CustomEvent("gadget:devharness:graphqlresult", { detail: result });
                  window.dispatchEvent(event);
                }
              } catch (error) {
                console.warn("[gadget] error dispatching gadget dev harness event", error);
              }
              return result;
            })
          );
        };
      };
      exchanges.beforeAll = [
        devHarnessExchange,
        ...exchanges.beforeAll ?? []
      ];
    }
    const connectionOptions = {
      endpoint: new URL("api/graphql", apiRoot).toString(),
      applicationId: this.applicationId,
      authenticationMode: options?.authenticationMode,
      ...options,
      exchanges,
      environment: this.environment
    };
    const authenticationMode = maybeGetAuthenticationModeOptionsFromClientOptions(options ?? {});
    connectionOptions.authenticationMode = authenticationMode ?? (typeof window == "undefined" ? { anonymous: true } : { browserSession: true });
    this.connection = new GadgetConnection(connectionOptions);
    if (typeof window != "undefined" && typeof window.document != "undefined" && this.connection.authenticationMode == AuthenticationMode.APIKey && !options?.authenticationMode?.dangerouslyAllowBrowserApiKey) {
      throw new Error("GGT_BROWSER_API_KEY_USAGE: Using a Gadget API key to authenticate this client object is insecure and will leak your API keys to attackers. Please use a different authentication mode.");
    }
    this.voiceSimSession = new VoiceSimSessionManager(this.connection);
    this.accessCode = new AccessCodeManager(this.connection);
    this.scenarioShareToken = new ScenarioShareTokenManager(this.connection);
    this.bulkJobResultV2 = new BulkJobResultV2Manager(this.connection);
    this.publicScenarioAccess = new PublicScenarioAccessManager(this.connection);
    this.memoryItemV2 = new MemoryItemV2Manager(this.connection);
    this.agentConfiguration = new AgentConfigurationManager(this.connection);
    this.ph4456Evaluation = new Ph4456EvaluationManager(this.connection);
    this.preceptorEvaluation = new PreceptorEvaluationManager(this.connection);
    this.institutionVectorStore = new InstitutionVectorStoreManager(this.connection);
    this.preceptorRequest = new PreceptorRequestManager(this.connection);
    this.embedToken = new EmbedTokenManager(this.connection);
    this.message = new MessageManager(this.connection);
    this.user = new UserManager(this.connection);
    this.assistant = new AssistantManager(this.connection);
    this.session = new SessionManager(this.connection);
    this.currentSession = new CurrentSessionManager(this.connection);
    this.thread = new ThreadManager(this.connection);
    this.vectorStore = new VectorStoreManager(this.connection);
    this.assistantFunctionLibrary = new AssistantFunctionLibraryManager(this.connection);
    this.hitlTask = new HitlTaskManager(this.connection);
    this.studentFeedbackHistory = new StudentFeedbackHistoryManager(this.connection);
    this.adminAssistantAuditLog = new AdminAssistantAuditLogManager(this.connection);
    this.chatMessage = new ChatMessageManager(this.connection);
    this.documentProcessorConfig = new DocumentProcessorConfigManager(this.connection);
    this.sessionSummaryV2 = new SessionSummaryV2Manager(this.connection);
    this.institutionalPartnership = new InstitutionalPartnershipManager(this.connection);
    this.conversationArchive = new ConversationArchiveManager(this.connection);
    this.userFile = new UserFileManager(this.connection);
    this.clinicalEvaluation = new ClinicalEvaluationManager(this.connection);
    this.agentMessage = new AgentMessageManager(this.connection);
    this.clinicalDocumentProcessor = new ClinicalDocumentProcessorManager(this.connection);
    this.fisdapSession = new FisdapSessionManager(this.connection);
    this.agency = new AgencyManager(this.connection);
    this.knowledgeBase = new KnowledgeBaseManager(this.connection);
    this.nremtMedicalEvaluation = new NremtMedicalEvaluationManager(this.connection);
    this.agentChatV2 = new AgentChatV2Manager(this.connection);
    this.shift = new ShiftManager(this.connection);
    this.cohort = new CohortManager(this.connection);
    this.scenarioGenerationProgress = new ScenarioGenerationProgressManager(this.connection);
    this.patientEncounter = new PatientEncounterManager(this.connection);
    this.nremtTraumaEvaluation = new NremtTraumaEvaluationManager(this.connection);
    this.educationalContent = new EducationalContentManager(this.connection);
    this.cohortMembership = new CohortMembershipManager(this.connection);
    this.auditLogV2 = new AuditLogV2Manager(this.connection);
    this.agentChat = new AgentChatManager(this.connection);
    this.institutionalRepository = new InstitutionalRepositoryManager(this.connection);
    this.formLayout = new FormLayoutManager(this.connection);
    this.assistantAccess = new AssistantAccessManager(this.connection);
    this.agentConversation = new AgentConversationManager(this.connection);
    this.shiftProcessing = new ShiftProcessingManager(this.connection);
    this.preceptor = new PreceptorManager(this.connection);
    this.webhookSubscription = new WebhookSubscriptionManager(this.connection);
    this.bulkJobV2 = new BulkJobV2Manager(this.connection);
    this.roomOfRequirement = new RoomOfRequirementManager(this.connection);
    this.conversationMemory = new ConversationMemoryManager(this.connection);
    this.simulationSession = new SimulationSessionManager(this.connection);
    this.clinicalSite = new ClinicalSiteManager(this.connection);
    this.chatMessageV2 = new ChatMessageV2Manager(this.connection);
    this.deletedShiftProcessing = new DeletedShiftProcessingManager(this.connection);
    this.watermarkConfiguration = new WatermarkConfigurationManager(this.connection);
    this.aiTrainingData = new AiTrainingDataManager(this.connection);
    this.clinicalScenario = new ClinicalScenarioManager(this.connection);
    this.generatedEcg = new GeneratedEcgManager(this.connection);
    this.institutionConfiguration = new InstitutionConfigurationManager(this.connection);
    this.extractionTemplate = new ExtractionTemplateManager(this.connection);
    this.shiftUnlockToken = new ShiftUnlockTokenManager(this.connection);
    this.scenarioRun = new ScenarioRunManager(this.connection);
    this.evalSystem = new EvalSystemManager(this.connection);
    this.evalResult = new EvalResultManager(this.connection);
    this.micuAccessToken = new MicuAccessTokenManager(this.connection);
    this.micuCase = new MicuCaseManager(this.connection);
    this.micuDeviceInstance = new MicuDeviceInstanceManager(this.connection);
    this.micuDeviceLog = new MicuDeviceLogManager(this.connection);
    this.micuMedicationInstance = new MicuMedicationInstanceManager(this.connection);
    this.micuMedicationLog = new MicuMedicationLogManager(this.connection);
    this.formQrCode = new FormQrCodeManager(this.connection);
    this.formSubmission = new FormSubmissionManager(this.connection);
    this.institutionForm = new InstitutionFormManager(this.connection);
    this.shiftPack = new ShiftPackManager(this.connection);
    this.cohortSemester = new CohortSemesterManager(this.connection);
    this.shiftDocumentation = new ShiftDocumentationManager(this.connection);
    this.liveAudioChunk = new LiveAudioChunkManager(this.connection);
    this.attendanceMagicLinkToken = new AttendanceMagicLinkTokenManager(this.connection);
    this.emsRunEvaluation = new EmsRunEvaluationManager(this.connection);
    this.qaChart = new QaChartManager(this.connection);
    this.qaChartField = new QaChartFieldManager(this.connection);
    this.qaGroup = new QaGroupManager(this.connection);
    this.qaKnowledgeBase = new QaKnowledgeBaseManager(this.connection);
    this.qaKnowledgeDocument = new QaKnowledgeDocumentManager(this.connection);
    this.qaMappingMemory = new QaMappingMemoryManager(this.connection);
    this.qaProcessingEvent = new QaProcessingEventManager(this.connection);
    this.qaReviewDecision = new QaReviewDecisionManager(this.connection);
    this.qaRoutingAssignment = new QaRoutingAssignmentManager(this.connection);
    this.qaRoutingRole = new QaRoutingRoleManager(this.connection);
    this.qaWorkflow = new QaWorkflowManager(this.connection);
    this.quickChartEvaluation = new QuickChartEvaluationManager(this.connection);
    this.quickQaProtocolRoute = new QuickQaProtocolRouteManager(this.connection);
    this.clinicalReviewArtifact = new ClinicalReviewArtifactManager(this.connection);
    this.qaCrewIdentity = new QaCrewIdentityManager(this.connection);
    this.authorTrendProfile = new AuthorTrendProfileManager(this.connection);
    this.attendanceEvent = new AttendanceEventManager(this.connection);
    this.attendanceUserIpProfile = new AttendanceUserIpProfileManager(this.connection);
    this.attendanceTestLink = new AttendanceTestLinkManager(this.connection);
    this.internal = {
      voiceSimSession: new InternalModelManager("voiceSimSession", this.connection, { "pluralApiIdentifier": "voiceSimSessions", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      accessCode: new InternalModelManager("accessCode", this.connection, { "pluralApiIdentifier": "accessCodes", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      scenarioShareToken: new InternalModelManager("scenarioShareToken", this.connection, { "pluralApiIdentifier": "scenarioShareTokens", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      bulkJobResultV2: new InternalModelManager("bulkJobResultV2", this.connection, { "pluralApiIdentifier": "bulkJobResultV2s", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      publicScenarioAccess: new InternalModelManager("publicScenarioAccess", this.connection, { "pluralApiIdentifier": "publicScenarioAccesses", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      memoryItemV2: new InternalModelManager("memoryItemV2", this.connection, { "pluralApiIdentifier": "memoryItemV2s", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      agentConfiguration: new InternalModelManager("agentConfiguration", this.connection, { "pluralApiIdentifier": "agentConfigurations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      ph4456Evaluation: new InternalModelManager("ph4456Evaluation", this.connection, { "pluralApiIdentifier": "ph4456Evaluations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      preceptorEvaluation: new InternalModelManager("preceptorEvaluation", this.connection, { "pluralApiIdentifier": "preceptorEvaluations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      institutionVectorStore: new InternalModelManager("institutionVectorStore", this.connection, { "pluralApiIdentifier": "institutionVectorStores", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      preceptorRequest: new InternalModelManager("preceptorRequest", this.connection, { "pluralApiIdentifier": "preceptorRequests", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      embedToken: new InternalModelManager("embedToken", this.connection, { "pluralApiIdentifier": "embedTokens", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      message: new InternalModelManager("message", this.connection, { "pluralApiIdentifier": "messages", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      user: new InternalModelManager("user", this.connection, { "pluralApiIdentifier": "users", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      assistant: new InternalModelManager("assistant", this.connection, { "pluralApiIdentifier": "assistants", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      session: new InternalModelManager("session", this.connection, { "pluralApiIdentifier": "sessions", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      thread: new InternalModelManager("thread", this.connection, { "pluralApiIdentifier": "threads", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      vectorStore: new InternalModelManager("vectorStore", this.connection, { "pluralApiIdentifier": "vectorStores", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      assistantFunctionLibrary: new InternalModelManager("assistantFunctionLibrary", this.connection, { "pluralApiIdentifier": "assistantFunctionLibraries", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      hitlTask: new InternalModelManager("hitlTask", this.connection, { "pluralApiIdentifier": "hitlTasks", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      studentFeedbackHistory: new InternalModelManager("studentFeedbackHistory", this.connection, { "pluralApiIdentifier": "studentFeedbackHistories", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      adminAssistantAuditLog: new InternalModelManager("adminAssistantAuditLog", this.connection, { "pluralApiIdentifier": "adminAssistantAuditLogs", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      chatMessage: new InternalModelManager("chatMessage", this.connection, { "pluralApiIdentifier": "chatMessages", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      documentProcessorConfig: new InternalModelManager("documentProcessorConfig", this.connection, { "pluralApiIdentifier": "documentProcessorConfigs", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      sessionSummaryV2: new InternalModelManager("sessionSummaryV2", this.connection, { "pluralApiIdentifier": "sessionSummaryV2s", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      institutionalPartnership: new InternalModelManager("institutionalPartnership", this.connection, { "pluralApiIdentifier": "institutionalPartnerships", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      conversationArchive: new InternalModelManager("conversationArchive", this.connection, { "pluralApiIdentifier": "conversationArchives", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      userFile: new InternalModelManager("userFile", this.connection, { "pluralApiIdentifier": "userFiles", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      clinicalEvaluation: new InternalModelManager("clinicalEvaluation", this.connection, { "pluralApiIdentifier": "clinicalEvaluations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      agentMessage: new InternalModelManager("agentMessage", this.connection, { "pluralApiIdentifier": "agentMessages", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      clinicalDocumentProcessor: new InternalModelManager("clinicalDocumentProcessor", this.connection, { "pluralApiIdentifier": "clinicalDocumentProcessors", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      fisdapSession: new InternalModelManager("fisdapSession", this.connection, { "pluralApiIdentifier": "fisdapSessions", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      agency: new InternalModelManager("agency", this.connection, { "pluralApiIdentifier": "agencies", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      knowledgeBase: new InternalModelManager("knowledgeBase", this.connection, { "pluralApiIdentifier": "knowledgeBases", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      nremtMedicalEvaluation: new InternalModelManager("nremtMedicalEvaluation", this.connection, { "pluralApiIdentifier": "nremtMedicalEvaluations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      agentChatV2: new InternalModelManager("agentChatV2", this.connection, { "pluralApiIdentifier": "agentChatV2s", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      shift: new InternalModelManager("shift", this.connection, { "pluralApiIdentifier": "shifts", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      cohort: new InternalModelManager("cohort", this.connection, { "pluralApiIdentifier": "cohorts", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      scenarioGenerationProgress: new InternalModelManager("scenarioGenerationProgress", this.connection, { "pluralApiIdentifier": "scenarioGenerationProgresses", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      patientEncounter: new InternalModelManager("patientEncounter", this.connection, { "pluralApiIdentifier": "patientEncounters", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      nremtTraumaEvaluation: new InternalModelManager("nremtTraumaEvaluation", this.connection, { "pluralApiIdentifier": "nremtTraumaEvaluations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      educationalContent: new InternalModelManager("educationalContent", this.connection, { "pluralApiIdentifier": "educationalContents", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      cohortMembership: new InternalModelManager("cohortMembership", this.connection, { "pluralApiIdentifier": "cohortMemberships", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      auditLogV2: new InternalModelManager("auditLogV2", this.connection, { "pluralApiIdentifier": "auditLogV2s", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      agentChat: new InternalModelManager("agentChat", this.connection, { "pluralApiIdentifier": "agentChats", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      institutionalRepository: new InternalModelManager("institutionalRepository", this.connection, { "pluralApiIdentifier": "institutionalRepositories", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      formLayout: new InternalModelManager("formLayout", this.connection, { "pluralApiIdentifier": "formLayouts", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      assistantAccess: new InternalModelManager("assistantAccess", this.connection, { "pluralApiIdentifier": "assistantAccesses", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      agentConversation: new InternalModelManager("agentConversation", this.connection, { "pluralApiIdentifier": "agentConversations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      shiftProcessing: new InternalModelManager("shiftProcessing", this.connection, { "pluralApiIdentifier": "shiftProcessings", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      preceptor: new InternalModelManager("preceptor", this.connection, { "pluralApiIdentifier": "preceptors", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      webhookSubscription: new InternalModelManager("webhookSubscription", this.connection, { "pluralApiIdentifier": "webhookSubscriptions", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      bulkJobV2: new InternalModelManager("bulkJobV2", this.connection, { "pluralApiIdentifier": "bulkJobV2s", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      roomOfRequirement: new InternalModelManager("roomOfRequirement", this.connection, { "pluralApiIdentifier": "roomOfRequirements", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      conversationMemory: new InternalModelManager("conversationMemory", this.connection, { "pluralApiIdentifier": "conversationMemories", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      simulationSession: new InternalModelManager("simulationSession", this.connection, { "pluralApiIdentifier": "simulationSessions", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      clinicalSite: new InternalModelManager("clinicalSite", this.connection, { "pluralApiIdentifier": "clinicalSites", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      chatMessageV2: new InternalModelManager("chatMessageV2", this.connection, { "pluralApiIdentifier": "chatMessageV2s", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      deletedShiftProcessing: new InternalModelManager("deletedShiftProcessing", this.connection, { "pluralApiIdentifier": "deletedShiftProcessings", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      watermarkConfiguration: new InternalModelManager("watermarkConfiguration", this.connection, { "pluralApiIdentifier": "watermarkConfigurations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      aiTrainingData: new InternalModelManager("aiTrainingData", this.connection, { "pluralApiIdentifier": "aiTrainingDatas", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      clinicalScenario: new InternalModelManager("clinicalScenario", this.connection, { "pluralApiIdentifier": "clinicalScenarios", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      generatedEcg: new InternalModelManager("generatedEcg", this.connection, { "pluralApiIdentifier": "generatedEcgs", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      institutionConfiguration: new InternalModelManager("institutionConfiguration", this.connection, { "pluralApiIdentifier": "institutionConfigurations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      extractionTemplate: new InternalModelManager("extractionTemplate", this.connection, { "pluralApiIdentifier": "extractionTemplates", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      shiftUnlockToken: new InternalModelManager("shiftUnlockToken", this.connection, { "pluralApiIdentifier": "shiftUnlockTokens", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      scenarioRun: new InternalModelManager("scenarioRun", this.connection, { "pluralApiIdentifier": "scenarioRuns", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      evalSystem: new InternalModelManager("evalSystem", this.connection, { "pluralApiIdentifier": "evalSystems", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      evalResult: new InternalModelManager("evalResult", this.connection, { "pluralApiIdentifier": "evalResults", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      micuAccessToken: new InternalModelManager("micuAccessToken", this.connection, { "pluralApiIdentifier": "micuAccessTokens", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      micuCase: new InternalModelManager("micuCase", this.connection, { "pluralApiIdentifier": "micuCases", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      micuDeviceInstance: new InternalModelManager("micuDeviceInstance", this.connection, { "pluralApiIdentifier": "micuDeviceInstances", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      micuDeviceLog: new InternalModelManager("micuDeviceLog", this.connection, { "pluralApiIdentifier": "micuDeviceLogs", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      micuMedicationInstance: new InternalModelManager("micuMedicationInstance", this.connection, { "pluralApiIdentifier": "micuMedicationInstances", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      micuMedicationLog: new InternalModelManager("micuMedicationLog", this.connection, { "pluralApiIdentifier": "micuMedicationLogs", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      formQrCode: new InternalModelManager("formQrCode", this.connection, { "pluralApiIdentifier": "formQrCodes", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      formSubmission: new InternalModelManager("formSubmission", this.connection, { "pluralApiIdentifier": "formSubmissions", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      institutionForm: new InternalModelManager("institutionForm", this.connection, { "pluralApiIdentifier": "institutionForms", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      shiftPack: new InternalModelManager("shiftPack", this.connection, { "pluralApiIdentifier": "shiftPacks", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      cohortSemester: new InternalModelManager("cohortSemester", this.connection, { "pluralApiIdentifier": "cohortSemesters", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      shiftDocumentation: new InternalModelManager("shiftDocumentation", this.connection, { "pluralApiIdentifier": "shiftDocumentations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      liveAudioChunk: new InternalModelManager("liveAudioChunk", this.connection, { "pluralApiIdentifier": "liveAudioChunks", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      attendanceMagicLinkToken: new InternalModelManager("attendanceMagicLinkToken", this.connection, { "pluralApiIdentifier": "attendanceMagicLinkTokens", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      emsRunEvaluation: new InternalModelManager("emsRunEvaluation", this.connection, { "pluralApiIdentifier": "emsRunEvaluations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaChart: new InternalModelManager("qaChart", this.connection, { "pluralApiIdentifier": "qaCharts", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaChartField: new InternalModelManager("qaChartField", this.connection, { "pluralApiIdentifier": "qaChartFields", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaGroup: new InternalModelManager("qaGroup", this.connection, { "pluralApiIdentifier": "qaGroups", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaKnowledgeBase: new InternalModelManager("qaKnowledgeBase", this.connection, { "pluralApiIdentifier": "qaKnowledgeBases", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaKnowledgeDocument: new InternalModelManager("qaKnowledgeDocument", this.connection, { "pluralApiIdentifier": "qaKnowledgeDocuments", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaMappingMemory: new InternalModelManager("qaMappingMemory", this.connection, { "pluralApiIdentifier": "qaMappingMemories", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaProcessingEvent: new InternalModelManager("qaProcessingEvent", this.connection, { "pluralApiIdentifier": "qaProcessingEvents", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaReviewDecision: new InternalModelManager("qaReviewDecision", this.connection, { "pluralApiIdentifier": "qaReviewDecisions", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaRoutingAssignment: new InternalModelManager("qaRoutingAssignment", this.connection, { "pluralApiIdentifier": "qaRoutingAssignments", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaRoutingRole: new InternalModelManager("qaRoutingRole", this.connection, { "pluralApiIdentifier": "qaRoutingRoles", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaWorkflow: new InternalModelManager("qaWorkflow", this.connection, { "pluralApiIdentifier": "qaWorkflows", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      quickChartEvaluation: new InternalModelManager("quickChartEvaluation", this.connection, { "pluralApiIdentifier": "quickChartEvaluations", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      quickQaProtocolRoute: new InternalModelManager("quickQaProtocolRoute", this.connection, { "pluralApiIdentifier": "quickQaProtocolRoutes", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      clinicalReviewArtifact: new InternalModelManager("clinicalReviewArtifact", this.connection, { "pluralApiIdentifier": "clinicalReviewArtifacts", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      qaCrewIdentity: new InternalModelManager("qaCrewIdentity", this.connection, { "pluralApiIdentifier": "qaCrewIdentities", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      authorTrendProfile: new InternalModelManager("authorTrendProfile", this.connection, { "pluralApiIdentifier": "authorTrendProfiles", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      attendanceEvent: new InternalModelManager("attendanceEvent", this.connection, { "pluralApiIdentifier": "attendanceEvents", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      attendanceUserIpProfile: new InternalModelManager("attendanceUserIpProfile", this.connection, { "pluralApiIdentifier": "attendanceUserIpProfiles", "hasAmbiguousIdentifiers": false, "namespace": [] }),
      attendanceTestLink: new InternalModelManager("attendanceTestLink", this.connection, { "pluralApiIdentifier": "attendanceTestLinks", "hasAmbiguousIdentifiers": false, "namespace": [] })
    };
  }
  /**
   * Returns a new Client instance that will call the Gadget API as the application's admin user.
   * This can only be used for API clients using internal authentication.
   * @returns {PapamedicAiClient} A new PapamedicAiClient instance with admin authentication
   */
  get actAsAdmin() {
    assert(this.options?.authenticationMode?.internal, `actAsAdmin can only be used for API clients using internal authentication, this client is using ${JSON.stringify(this.options?.authenticationMode)}`);
    return new PapamedicAiClient({
      ...this.options,
      authenticationMode: {
        internal: {
          ...this.options.authenticationMode.internal,
          actAsSession: false
        }
      }
    });
  }
  /**
   * Returns a new PapamedicAiClient instance that will call the Gadget API as with the permission of the current session.
   * This can only be used for API clients using internal authentication.
   * @returns {PapamedicAiClient} A new PapamedicAiClient instance with session authentication
   */
  get actAsSession() {
    assert(this.options?.authenticationMode?.internal, "actAsSession can only be used for API clients using internal authentication");
    return new PapamedicAiClient({
      ...this.options,
      authenticationMode: {
        internal: {
          ...this.options.authenticationMode.internal,
          actAsSession: true
        }
      }
    });
  }
  /** Run an arbitrary GraphQL query. */
  async query(graphQL, variables, options) {
    const { data, error } = await this.connection.currentClient.query(graphQL, variables, options).toPromise();
    if (error)
      throw error;
    return data;
  }
  /** Run an arbitrary GraphQL mutation. */
  async mutate(graphQL, variables, options) {
    const { data, error } = await this.connection.currentClient.mutation(graphQL, variables, options).toPromise();
    if (error)
      throw error;
    return data;
  }
  /**
   * `fetch` function that works the same as the built-in `fetch` function, but automatically passes authentication information for this API client.
   *
   * @example
   * await api.fetch("https://myapp--development.gadget.app/foo/bar");
   *
   * @example
   * // fetch a relative URL from the endpoint this API client is configured to fetch from
   * await api.fetch("/foo/bar");
   **/
  async fetch(input, init = {}) {
    return await this.connection.fetch(input, init);
  }
  async enqueue(action, inputOrOptions, maybeOptions) {
    assert(action, ".enqueue must be passed an action as the first argument but was passed undefined");
    let input;
    let options;
    if (typeof maybeOptions !== "undefined") {
      if (typeof inputOrOptions == "string") {
        input = { id: inputOrOptions };
      } else {
        input = inputOrOptions;
      }
      options = maybeOptions;
    } else if (!action.variables || Object.keys(action.variables).length == 0) {
      input = {};
      options = inputOrOptions;
    } else {
      if (typeof inputOrOptions == "string") {
        input = { id: inputOrOptions };
      } else {
        input = inputOrOptions;
      }
      options = {};
    }
    return await enqueueActionRunner(this.connection, action, input, options);
  }
  /**
   * Returns a handle for a given background action id
   *
   * @param action The action that was enqueued
   * @param id The id of the background action
   *
   * @example
   * const handle = api.handle(api.widget.update, "app-job-12346");
   *
   * @example
   * const handle = api.handle(api.someGlobalAction, "app-job-56789");
   **/
  handle(action, id) {
    return new BackgroundActionHandle(this.connection, action, id);
  }
  toString() {
    return `PapamedicAiClient<${this.environment}>`;
  }
  toJSON() {
    return this.toString();
  }
}
PapamedicAiClient.prototype[$modelRelationships] = { "voiceSimSession": { "scenario": { "type": "BelongsTo", "model": "clinicalScenario" }, "cohort": { "type": "BelongsTo", "model": "cohort" }, "sharedBy": { "type": "BelongsTo", "model": "user" }, "simulationSessions": { "type": "HasMany", "model": "simulationSession" }, "student": { "type": "BelongsTo", "model": "user" } }, "accessCode": { "createdBy": { "type": "BelongsTo", "model": "user" } }, "scenarioShareToken": { "cohort": { "type": "BelongsTo", "model": "cohort" }, "createdBy": { "type": "BelongsTo", "model": "user" }, "scenario": { "type": "BelongsTo", "model": "clinicalScenario" }, "simulationSession": { "type": "HasOne", "model": "simulationSession" }, "scenarioRuns": { "type": "HasMany", "model": "scenarioRun" } }, "bulkJobResultV2": { "job": { "type": "BelongsTo", "model": "bulkJobV2" } }, "publicScenarioAccess": { "grantedBy": { "type": "BelongsTo", "model": "user" }, "user": { "type": "BelongsTo", "model": "user" }, "cohort": { "type": "BelongsTo", "model": "cohort" } }, "memoryItemV2": { "user": { "type": "BelongsTo", "model": "user" } }, "agentConfiguration": { "lastModifiedBy": { "type": "BelongsTo", "model": "user" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "ph4456Evaluation": { "scenario": { "type": "BelongsTo", "model": "clinicalScenario" }, "cohort": { "type": "BelongsTo", "model": "cohort" }, "createdBy": { "type": "BelongsTo", "model": "user" }, "shareToken": { "type": "BelongsTo", "model": "scenarioShareToken" }, "simulationSession": { "type": "BelongsTo", "model": "simulationSession" }, "student": { "type": "BelongsTo", "model": "user" }, "instructor": { "type": "BelongsTo", "model": "user" }, "scenarioRun": { "type": "BelongsTo", "model": "scenarioRun" } }, "preceptorEvaluation": { "student": { "type": "BelongsTo", "model": "user" }, "shift": { "type": "BelongsTo", "model": "shift" }, "reviewedBy": { "type": "BelongsTo", "model": "user" }, "preceptor": { "type": "BelongsTo", "model": "preceptor" } }, "institutionVectorStore": { "institution": { "type": "BelongsTo", "model": "institutionConfiguration" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "preceptorRequest": { "patientEncounter": { "type": "BelongsTo", "model": "patientEncounter" }, "requestedBy": { "type": "BelongsTo", "model": "user" }, "shift": { "type": "BelongsTo", "model": "shift" }, "reviewedBy": { "type": "BelongsTo", "model": "user" }, "createdPreceptor": { "type": "BelongsTo", "model": "preceptor" } }, "embedToken": { "createdBy": { "type": "BelongsTo", "model": "user" }, "assistant": { "type": "BelongsTo", "model": "assistant" } }, "message": { "thread": { "type": "BelongsTo", "model": "thread" }, "user": { "type": "BelongsTo", "model": "user" }, "reviewedBy": { "type": "BelongsTo", "model": "user" } }, "user": { "invitedUsers": { "type": "HasMany", "model": "user" }, "creatorGrantedBy": { "type": "BelongsTo", "model": "user" }, "threads": { "type": "HasMany", "model": "thread" }, "messages": { "type": "HasMany", "model": "message" }, "approvedBy": { "type": "BelongsTo", "model": "user" }, "cohortMemberships": { "type": "HasMany", "model": "cohortMembership" }, "subscriptionGrantedBy": { "type": "BelongsTo", "model": "user" }, "cohort": { "type": "BelongsTo", "model": "cohort" }, "invitedBy": { "type": "BelongsTo", "model": "user" } }, "assistant": { "threads": { "type": "HasMany", "model": "thread" }, "accessGrants": { "type": "HasMany", "model": "assistantAccess" } }, "session": { "user": { "type": "BelongsTo", "model": "user" } }, "thread": { "user": { "type": "BelongsTo", "model": "user" }, "messages": { "type": "HasMany", "model": "message" }, "assistant": { "type": "BelongsTo", "model": "assistant" } }, "vectorStore": { "lastModifiedBy": { "type": "BelongsTo", "model": "user" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "assistantFunctionLibrary": { "assistant": { "type": "BelongsTo", "model": "assistant" } }, "hitlTask": { "shiftProcessing": { "type": "BelongsTo", "model": "shiftProcessing" } }, "studentFeedbackHistory": { "reviewedBy": { "type": "BelongsTo", "model": "user" }, "student": { "type": "BelongsTo", "model": "user" } }, "adminAssistantAuditLog": { "reviewedBy": { "type": "BelongsTo", "model": "user" }, "user": { "type": "BelongsTo", "model": "user" } }, "chatMessage": { "conversation": { "type": "BelongsTo", "model": "agentChat" } }, "documentProcessorConfig": { "vectorStore": { "type": "BelongsTo", "model": "vectorStore" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "sessionSummaryV2": { "user": { "type": "BelongsTo", "model": "user" } }, "institutionalPartnership": { "approvedBy": { "type": "BelongsTo", "model": "user" }, "requestedBy": { "type": "BelongsTo", "model": "user" } }, "conversationArchive": { "originalThread": { "type": "BelongsTo", "model": "thread" }, "user": { "type": "BelongsTo", "model": "user" }, "assistant": { "type": "BelongsTo", "model": "assistant" } }, "userFile": { "parentFile": { "type": "BelongsTo", "model": "userFile" }, "vectorStore": { "type": "BelongsTo", "model": "vectorStore" }, "childFiles": { "type": "HasMany", "model": "userFile" }, "owner": { "type": "BelongsTo", "model": "user" }, "shiftProcessing": { "type": "BelongsTo", "model": "shiftProcessing" } }, "clinicalEvaluation": { "reviewer": { "type": "BelongsTo", "model": "user" }, "shiftProcessing": { "type": "BelongsTo", "model": "shiftProcessing" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "agentMessage": { "agentConfiguration": { "type": "BelongsTo", "model": "agentConfiguration" }, "reviewedBy": { "type": "BelongsTo", "model": "user" }, "conversation": { "type": "BelongsTo", "model": "agentConversation" } }, "clinicalDocumentProcessor": { "createdBy": { "type": "BelongsTo", "model": "user" }, "childProcessors": { "type": "HasMany", "model": "clinicalDocumentProcessor" }, "usedByDocuments": { "type": "HasMany", "model": "shiftProcessing" }, "lastModifiedBy": { "type": "BelongsTo", "model": "user" }, "parentProcessor": { "type": "BelongsTo", "model": "clinicalDocumentProcessor" } }, "fisdapSession": { "updatedBy": { "type": "BelongsTo", "model": "user" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "agency": { "lastModifiedBy": { "type": "BelongsTo", "model": "user" }, "clinicalSites": { "type": "HasMany", "model": "clinicalSite" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "knowledgeBase": { "lastModifiedBy": { "type": "BelongsTo", "model": "user" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "nremtMedicalEvaluation": { "createdBy": { "type": "BelongsTo", "model": "user" }, "scenario": { "type": "BelongsTo", "model": "clinicalScenario" }, "instructor": { "type": "BelongsTo", "model": "user" }, "student": { "type": "BelongsTo", "model": "user" }, "cohort": { "type": "BelongsTo", "model": "cohort" }, "simulationSession": { "type": "BelongsTo", "model": "simulationSession" }, "shareToken": { "type": "BelongsTo", "model": "scenarioShareToken" }, "scenarioRun": { "type": "BelongsTo", "model": "scenarioRun" } }, "agentChatV2": { "user": { "type": "BelongsTo", "model": "user" } }, "shift": { "deletedBy": { "type": "BelongsTo", "model": "user" }, "preceptor": { "type": "BelongsTo", "model": "user" }, "unlockRequestedBy": { "type": "BelongsTo", "model": "user" }, "agency": { "type": "BelongsTo", "model": "agency" }, "cohort": { "type": "BelongsTo", "model": "cohort" }, "clinicalSite": { "type": "BelongsTo", "model": "clinicalSite" }, "encounters": { "type": "HasMany", "model": "patientEncounter" } }, "cohort": { "lastModifiedBy": { "type": "BelongsTo", "model": "user" }, "users": { "type": "HasMany", "model": "user" }, "createdBy": { "type": "BelongsTo", "model": "user" }, "shifts": { "type": "HasMany", "model": "shift" }, "decommissionedBy": { "type": "BelongsTo", "model": "user" }, "semesters": { "type": "HasMany", "model": "cohortSemester" } }, "scenarioGenerationProgress": { "user": { "type": "BelongsTo", "model": "user" } }, "patientEncounter": { "preceptor": { "type": "BelongsTo", "model": "preceptor" }, "submittedBy": { "type": "BelongsTo", "model": "user" }, "reviewedBy": { "type": "BelongsTo", "model": "user" }, "student": { "type": "BelongsTo", "model": "user" }, "shiftDocumentation": { "type": "BelongsTo", "model": "shiftDocumentation" }, "shift": { "type": "BelongsTo", "model": "shift" } }, "nremtTraumaEvaluation": { "instructor": { "type": "BelongsTo", "model": "user" }, "scenario": { "type": "BelongsTo", "model": "clinicalScenario" }, "shareToken": { "type": "BelongsTo", "model": "scenarioShareToken" }, "createdBy": { "type": "BelongsTo", "model": "user" }, "student": { "type": "BelongsTo", "model": "user" }, "cohort": { "type": "BelongsTo", "model": "cohort" }, "simulationSession": { "type": "BelongsTo", "model": "simulationSession" }, "scenarioRun": { "type": "BelongsTo", "model": "scenarioRun" } }, "educationalContent": {}, "cohortMembership": { "assignedBy": { "type": "BelongsTo", "model": "user" }, "user": { "type": "BelongsTo", "model": "user" }, "cohort": { "type": "BelongsTo", "model": "cohort" } }, "auditLogV2": { "approvedBy": { "type": "BelongsTo", "model": "user" }, "user": { "type": "BelongsTo", "model": "user" }, "conversation": { "type": "BelongsTo", "model": "agentChatV2" } }, "agentChat": { "messages": { "type": "HasMany", "model": "chatMessage" }, "user": { "type": "BelongsTo", "model": "user" } }, "institutionalRepository": { "lastModifiedBy": { "type": "BelongsTo", "model": "user" }, "parentTemplate": { "type": "BelongsTo", "model": "institutionalRepository" }, "childTemplates": { "type": "HasMany", "model": "institutionalRepository" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "formLayout": { "createdBy": { "type": "BelongsTo", "model": "user" } }, "assistantAccess": { "grantedBy": { "type": "BelongsTo", "model": "user" }, "assistant": { "type": "BelongsTo", "model": "assistant" } }, "agentConversation": { "user": { "type": "BelongsTo", "model": "user" }, "reviewedBy": { "type": "BelongsTo", "model": "user" }, "agentConfiguration": { "type": "BelongsTo", "model": "agentConfiguration" } }, "shiftProcessing": { "clinicalEvaluations": { "type": "HasMany", "model": "clinicalEvaluation" }, "userFile": { "type": "BelongsTo", "model": "userFile" }, "reviewedBy": { "type": "BelongsTo", "model": "user" }, "assignedInstructor": { "type": "BelongsTo", "model": "user" }, "submittedBy": { "type": "BelongsTo", "model": "user" }, "processor": { "type": "BelongsTo", "model": "clinicalDocumentProcessor" }, "studentCohort": { "type": "BelongsTo", "model": "cohort" } }, "preceptor": { "agency": { "type": "BelongsTo", "model": "agency" }, "user": { "type": "BelongsTo", "model": "user" }, "evaluations": { "type": "HasMany", "model": "preceptorEvaluation" }, "shifts": { "type": "HasMany", "model": "shift" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "webhookSubscription": {}, "bulkJobV2": { "conversation": { "type": "BelongsTo", "model": "agentChatV2" }, "results": { "type": "HasMany", "model": "bulkJobResultV2" }, "user": { "type": "BelongsTo", "model": "user" } }, "roomOfRequirement": { "archivedBy": { "type": "BelongsTo", "model": "user" } }, "conversationMemory": { "user": { "type": "BelongsTo", "model": "user" } }, "simulationSession": { "scenario": { "type": "BelongsTo", "model": "clinicalScenario" }, "user": { "type": "BelongsTo", "model": "user" }, "scenarioShareToken": { "type": "BelongsTo", "model": "scenarioShareToken" }, "cohort": { "type": "BelongsTo", "model": "cohort" }, "voiceSimSession": { "type": "BelongsTo", "model": "voiceSimSession" }, "instructor": { "type": "BelongsTo", "model": "user" }, "scenarioRun": { "type": "BelongsTo", "model": "scenarioRun" } }, "clinicalSite": { "agency": { "type": "BelongsTo", "model": "agency" }, "shifts": { "type": "HasMany", "model": "shift" }, "createdBy": { "type": "BelongsTo", "model": "user" }, "lastModifiedBy": { "type": "BelongsTo", "model": "user" } }, "chatMessageV2": { "conversation": { "type": "BelongsTo", "model": "agentChatV2" } }, "deletedShiftProcessing": { "userFile": { "type": "BelongsTo", "model": "userFile" }, "submittedBy": { "type": "BelongsTo", "model": "user" }, "processor": { "type": "BelongsTo", "model": "clinicalDocumentProcessor" }, "deletedBy": { "type": "BelongsTo", "model": "user" }, "reviewedBy": { "type": "BelongsTo", "model": "user" }, "assignedInstructor": { "type": "BelongsTo", "model": "user" } }, "watermarkConfiguration": { "createdBy": { "type": "BelongsTo", "model": "user" } }, "aiTrainingData": { "assistantUsed": { "type": "BelongsTo", "model": "assistant" }, "reviewedBy": { "type": "BelongsTo", "model": "user" }, "user": { "type": "BelongsTo", "model": "user" } }, "clinicalScenario": { "createdBy": { "type": "BelongsTo", "model": "user" }, "ph4456Evaluations": { "type": "HasMany", "model": "ph4456Evaluation" } }, "generatedEcg": { "linkedSimulation": { "type": "BelongsTo", "model": "simulationSession" }, "linkedScenario": { "type": "BelongsTo", "model": "clinicalScenario" } }, "institutionConfiguration": { "lastModifiedBy": { "type": "BelongsTo", "model": "user" }, "configuredBy": { "type": "BelongsTo", "model": "user" } }, "extractionTemplate": { "createdBy": { "type": "BelongsTo", "model": "user" } }, "shiftUnlockToken": {}, "scenarioRun": { "scenarioShareToken": { "type": "BelongsTo", "model": "scenarioShareToken" }, "scenario": { "type": "BelongsTo", "model": "clinicalScenario" }, "cohort": { "type": "BelongsTo", "model": "cohort" }, "instructor": { "type": "BelongsTo", "model": "user" } }, "evalSystem": { "createdBy": { "type": "BelongsTo", "model": "user" }, "evalResults": { "type": "HasMany", "model": "evalResult" } }, "evalResult": { "createdBy": { "type": "BelongsTo", "model": "user" }, "evalSystem": { "type": "BelongsTo", "model": "evalSystem" } }, "micuAccessToken": { "user": { "type": "BelongsTo", "model": "user" } }, "micuCase": { "deviceInstances": { "type": "HasMany", "model": "micuDeviceInstance" }, "medicationInstances": { "type": "HasMany", "model": "micuMedicationInstance" }, "user": { "type": "BelongsTo", "model": "user" } }, "micuDeviceInstance": { "case": { "type": "BelongsTo", "model": "micuCase" }, "deviceLogs": { "type": "HasMany", "model": "micuDeviceLog" } }, "micuDeviceLog": { "device": { "type": "BelongsTo", "model": "micuDeviceInstance" } }, "micuMedicationInstance": { "case": { "type": "BelongsTo", "model": "micuCase" }, "medicationLogs": { "type": "HasMany", "model": "micuMedicationLog" } }, "micuMedicationLog": { "medication": { "type": "BelongsTo", "model": "micuMedicationInstance" } }, "formQrCode": { "institutionForm": { "type": "BelongsTo", "model": "institutionForm" }, "shiftDocumentation": { "type": "BelongsTo", "model": "shiftDocumentation" }, "shift": { "type": "BelongsTo", "model": "shift" }, "student": { "type": "BelongsTo", "model": "user" } }, "formSubmission": { "institutionForm": { "type": "BelongsTo", "model": "institutionForm" }, "reviewedBy": { "type": "BelongsTo", "model": "user" }, "shiftDocumentation": { "type": "BelongsTo", "model": "shiftDocumentation" }, "shift": { "type": "BelongsTo", "model": "shift" }, "student": { "type": "BelongsTo", "model": "user" } }, "institutionForm": { "createdBy": { "type": "BelongsTo", "model": "user" } }, "shiftPack": { "createdBy": { "type": "BelongsTo", "model": "user" }, "cohortSemester": { "type": "BelongsTo", "model": "cohortSemester" }, "cohort": { "type": "BelongsTo", "model": "cohort" } }, "cohortSemester": { "cohort": { "type": "BelongsTo", "model": "cohort" }, "createdBy": { "type": "BelongsTo", "model": "user" }, "shiftPacks": { "type": "HasMany", "model": "shiftPack" } }, "shiftDocumentation": { "patientEncounters": { "type": "HasMany", "model": "patientEncounter" }, "shift": { "type": "BelongsTo", "model": "shift" }, "student": { "type": "BelongsTo", "model": "user" }, "preceptor": { "type": "BelongsTo", "model": "user" }, "attendanceVerifiedBy": { "type": "BelongsTo", "model": "user" }, "appliedShiftPack": { "type": "BelongsTo", "model": "shiftPack" }, "attendanceMagicLinks": { "type": "HasMany", "model": "attendanceMagicLinkToken" } }, "liveAudioChunk": { "simulationSession": { "type": "BelongsTo", "model": "simulationSession" }, "createdBy": { "type": "BelongsTo", "model": "user" } }, "attendanceMagicLinkToken": { "shift": { "type": "BelongsTo", "model": "shift" }, "shiftDocumentation": { "type": "BelongsTo", "model": "shiftDocumentation" }, "student": { "type": "BelongsTo", "model": "user" } }, "emsRunEvaluation": { "createdBy": { "type": "BelongsTo", "model": "user" }, "originalFile": { "type": "BelongsTo", "model": "userFile" } }, "qaChart": { "createdBy": { "type": "BelongsTo", "model": "user" }, "workflow": { "type": "BelongsTo", "model": "qaWorkflow" }, "primaryCaregiverUser": { "type": "BelongsTo", "model": "user" }, "secondaryCrewMemberUser": { "type": "BelongsTo", "model": "user" }, "thirdCrewMemberUser": { "type": "BelongsTo", "model": "user" } }, "qaChartField": { "chart": { "type": "BelongsTo", "model": "qaChart" } }, "qaGroup": { "workflow": { "type": "BelongsTo", "model": "qaWorkflow" } }, "qaKnowledgeBase": { "createdBy": { "type": "BelongsTo", "model": "user" }, "workflow": { "type": "BelongsTo", "model": "qaWorkflow" } }, "qaKnowledgeDocument": { "knowledgeBase": { "type": "BelongsTo", "model": "qaKnowledgeBase" } }, "qaMappingMemory": { "approvedBy": { "type": "BelongsTo", "model": "user" }, "workflow": { "type": "BelongsTo", "model": "qaWorkflow" } }, "qaProcessingEvent": { "chart": { "type": "BelongsTo", "model": "qaChart" }, "workflow": { "type": "BelongsTo", "model": "qaWorkflow" } }, "qaReviewDecision": { "reviewedBy": { "type": "BelongsTo", "model": "user" }, "chart": { "type": "BelongsTo", "model": "qaChart" } }, "qaRoutingAssignment": { "group": { "type": "BelongsTo", "model": "qaGroup" }, "routingRole": { "type": "BelongsTo", "model": "qaRoutingRole" }, "user": { "type": "BelongsTo", "model": "user" }, "workflow": { "type": "BelongsTo", "model": "qaWorkflow" } }, "qaRoutingRole": { "workflow": { "type": "BelongsTo", "model": "qaWorkflow" } }, "qaWorkflow": { "createdBy": { "type": "BelongsTo", "model": "user" }, "lastModifiedBy": { "type": "BelongsTo", "model": "user" } }, "quickChartEvaluation": { "createdBy": { "type": "BelongsTo", "model": "user" }, "originalFile": { "type": "BelongsTo", "model": "userFile" }, "qaChart": { "type": "BelongsTo", "model": "qaChart" }, "qaWorkflow": { "type": "BelongsTo", "model": "qaWorkflow" } }, "quickQaProtocolRoute": { "vectorStore": { "type": "BelongsTo", "model": "vectorStore" } }, "clinicalReviewArtifact": { "adminReviewedBy": { "type": "BelongsTo", "model": "user" }, "reviewer": { "type": "BelongsTo", "model": "user" } }, "qaCrewIdentity": { "user": { "type": "BelongsTo", "model": "user" } }, "authorTrendProfile": { "authorUser": { "type": "BelongsTo", "model": "user" } }, "attendanceEvent": { "expectedClinicalSite": { "type": "BelongsTo", "model": "clinicalSite" }, "matchedClinicalSite": { "type": "BelongsTo", "model": "clinicalSite" }, "shift": { "type": "BelongsTo", "model": "shift" }, "shiftDocumentation": { "type": "BelongsTo", "model": "shiftDocumentation" }, "user": { "type": "BelongsTo", "model": "user" } }, "attendanceUserIpProfile": { "lastEvent": { "type": "BelongsTo", "model": "attendanceEvent" }, "user": { "type": "BelongsTo", "model": "user" } }, "attendanceTestLink": { "createdBy": { "type": "BelongsTo", "model": "user" }, "assignedUser": { "type": "BelongsTo", "model": "user" } } };
const Client = PapamedicAiClient;
export {
  Client,
  DefaultAccessCodeSelection2 as DefaultAccessCodeSelection,
  DefaultAdminAssistantAuditLogSelection2 as DefaultAdminAssistantAuditLogSelection,
  DefaultAgencySelection2 as DefaultAgencySelection,
  DefaultAgentChatSelection2 as DefaultAgentChatSelection,
  DefaultAgentChatV2Selection2 as DefaultAgentChatV2Selection,
  DefaultAgentConfigurationSelection2 as DefaultAgentConfigurationSelection,
  DefaultAgentConversationSelection2 as DefaultAgentConversationSelection,
  DefaultAgentMessageSelection2 as DefaultAgentMessageSelection,
  DefaultAiTrainingDataSelection2 as DefaultAiTrainingDataSelection,
  DefaultAssistantAccessSelection2 as DefaultAssistantAccessSelection,
  DefaultAssistantFunctionLibrarySelection2 as DefaultAssistantFunctionLibrarySelection,
  DefaultAssistantSelection2 as DefaultAssistantSelection,
  DefaultAttendanceEventSelection2 as DefaultAttendanceEventSelection,
  DefaultAttendanceMagicLinkTokenSelection2 as DefaultAttendanceMagicLinkTokenSelection,
  DefaultAttendanceTestLinkSelection2 as DefaultAttendanceTestLinkSelection,
  DefaultAttendanceUserIpProfileSelection2 as DefaultAttendanceUserIpProfileSelection,
  DefaultAuditLogV2Selection2 as DefaultAuditLogV2Selection,
  DefaultAuthorTrendProfileSelection2 as DefaultAuthorTrendProfileSelection,
  DefaultBulkJobResultV2Selection2 as DefaultBulkJobResultV2Selection,
  DefaultBulkJobV2Selection2 as DefaultBulkJobV2Selection,
  DefaultChatMessageSelection2 as DefaultChatMessageSelection,
  DefaultChatMessageV2Selection2 as DefaultChatMessageV2Selection,
  DefaultClinicalDocumentProcessorSelection2 as DefaultClinicalDocumentProcessorSelection,
  DefaultClinicalEvaluationSelection2 as DefaultClinicalEvaluationSelection,
  DefaultClinicalReviewArtifactSelection2 as DefaultClinicalReviewArtifactSelection,
  DefaultClinicalScenarioSelection2 as DefaultClinicalScenarioSelection,
  DefaultClinicalSiteSelection2 as DefaultClinicalSiteSelection,
  DefaultCohortMembershipSelection2 as DefaultCohortMembershipSelection,
  DefaultCohortSelection2 as DefaultCohortSelection,
  DefaultCohortSemesterSelection2 as DefaultCohortSemesterSelection,
  DefaultConversationArchiveSelection2 as DefaultConversationArchiveSelection,
  DefaultConversationMemorySelection2 as DefaultConversationMemorySelection,
  DefaultDeletedShiftProcessingSelection2 as DefaultDeletedShiftProcessingSelection,
  DefaultDocumentProcessorConfigSelection2 as DefaultDocumentProcessorConfigSelection,
  DefaultEducationalContentSelection2 as DefaultEducationalContentSelection,
  DefaultEmbedTokenSelection2 as DefaultEmbedTokenSelection,
  DefaultEmsRunEvaluationSelection2 as DefaultEmsRunEvaluationSelection,
  DefaultEvalResultSelection2 as DefaultEvalResultSelection,
  DefaultEvalSystemSelection2 as DefaultEvalSystemSelection,
  DefaultExtractionTemplateSelection2 as DefaultExtractionTemplateSelection,
  DefaultFisdapSessionSelection2 as DefaultFisdapSessionSelection,
  DefaultFormLayoutSelection2 as DefaultFormLayoutSelection,
  DefaultFormQrCodeSelection2 as DefaultFormQrCodeSelection,
  DefaultFormSubmissionSelection2 as DefaultFormSubmissionSelection,
  DefaultGeneratedEcgSelection2 as DefaultGeneratedEcgSelection,
  DefaultHitlTaskSelection2 as DefaultHitlTaskSelection,
  DefaultInstitutionConfigurationSelection2 as DefaultInstitutionConfigurationSelection,
  DefaultInstitutionFormSelection2 as DefaultInstitutionFormSelection,
  DefaultInstitutionVectorStoreSelection2 as DefaultInstitutionVectorStoreSelection,
  DefaultInstitutionalPartnershipSelection2 as DefaultInstitutionalPartnershipSelection,
  DefaultInstitutionalRepositorySelection2 as DefaultInstitutionalRepositorySelection,
  DefaultKnowledgeBaseSelection2 as DefaultKnowledgeBaseSelection,
  DefaultLiveAudioChunkSelection2 as DefaultLiveAudioChunkSelection,
  DefaultMemoryItemV2Selection2 as DefaultMemoryItemV2Selection,
  DefaultMessageSelection2 as DefaultMessageSelection,
  DefaultMicuAccessTokenSelection2 as DefaultMicuAccessTokenSelection,
  DefaultMicuCaseSelection2 as DefaultMicuCaseSelection,
  DefaultMicuDeviceInstanceSelection2 as DefaultMicuDeviceInstanceSelection,
  DefaultMicuDeviceLogSelection2 as DefaultMicuDeviceLogSelection,
  DefaultMicuMedicationInstanceSelection2 as DefaultMicuMedicationInstanceSelection,
  DefaultMicuMedicationLogSelection2 as DefaultMicuMedicationLogSelection,
  DefaultNremtMedicalEvaluationSelection2 as DefaultNremtMedicalEvaluationSelection,
  DefaultNremtTraumaEvaluationSelection2 as DefaultNremtTraumaEvaluationSelection,
  DefaultPatientEncounterSelection2 as DefaultPatientEncounterSelection,
  DefaultPh4456EvaluationSelection2 as DefaultPh4456EvaluationSelection,
  DefaultPreceptorEvaluationSelection2 as DefaultPreceptorEvaluationSelection,
  DefaultPreceptorRequestSelection2 as DefaultPreceptorRequestSelection,
  DefaultPreceptorSelection2 as DefaultPreceptorSelection,
  DefaultPublicScenarioAccessSelection2 as DefaultPublicScenarioAccessSelection,
  DefaultQaChartFieldSelection2 as DefaultQaChartFieldSelection,
  DefaultQaChartSelection2 as DefaultQaChartSelection,
  DefaultQaCrewIdentitySelection2 as DefaultQaCrewIdentitySelection,
  DefaultQaGroupSelection2 as DefaultQaGroupSelection,
  DefaultQaKnowledgeBaseSelection2 as DefaultQaKnowledgeBaseSelection,
  DefaultQaKnowledgeDocumentSelection2 as DefaultQaKnowledgeDocumentSelection,
  DefaultQaMappingMemorySelection2 as DefaultQaMappingMemorySelection,
  DefaultQaProcessingEventSelection2 as DefaultQaProcessingEventSelection,
  DefaultQaReviewDecisionSelection2 as DefaultQaReviewDecisionSelection,
  DefaultQaRoutingAssignmentSelection2 as DefaultQaRoutingAssignmentSelection,
  DefaultQaRoutingRoleSelection2 as DefaultQaRoutingRoleSelection,
  DefaultQaWorkflowSelection2 as DefaultQaWorkflowSelection,
  DefaultQuickChartEvaluationSelection2 as DefaultQuickChartEvaluationSelection,
  DefaultQuickQaProtocolRouteSelection2 as DefaultQuickQaProtocolRouteSelection,
  DefaultRoomOfRequirementSelection2 as DefaultRoomOfRequirementSelection,
  DefaultScenarioGenerationProgressSelection2 as DefaultScenarioGenerationProgressSelection,
  DefaultScenarioRunSelection2 as DefaultScenarioRunSelection,
  DefaultScenarioShareTokenSelection2 as DefaultScenarioShareTokenSelection,
  DefaultSessionSelection2 as DefaultSessionSelection,
  DefaultSessionSummaryV2Selection2 as DefaultSessionSummaryV2Selection,
  DefaultShiftDocumentationSelection2 as DefaultShiftDocumentationSelection,
  DefaultShiftPackSelection2 as DefaultShiftPackSelection,
  DefaultShiftProcessingSelection2 as DefaultShiftProcessingSelection,
  DefaultShiftSelection2 as DefaultShiftSelection,
  DefaultShiftUnlockTokenSelection2 as DefaultShiftUnlockTokenSelection,
  DefaultSimulationSessionSelection2 as DefaultSimulationSessionSelection,
  DefaultStudentFeedbackHistorySelection2 as DefaultStudentFeedbackHistorySelection,
  DefaultThreadSelection2 as DefaultThreadSelection,
  DefaultUserFileSelection2 as DefaultUserFileSelection,
  DefaultUserSelection2 as DefaultUserSelection,
  DefaultVectorStoreSelection2 as DefaultVectorStoreSelection,
  DefaultVoiceSimSessionSelection2 as DefaultVoiceSimSessionSelection,
  DefaultWatermarkConfigurationSelection2 as DefaultWatermarkConfigurationSelection,
  DefaultWebhookSubscriptionSelection2 as DefaultWebhookSubscriptionSelection,
  PapamedicAiClient,
  maybeGetAuthenticationModeOptionsFromClientOptions
};
//# sourceMappingURL=Client.js.map
